/*
 * @license
 * Pipeline Theme (c) Groupthought Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t, e, i, s, o, r, n, a, l, c, h) {
    "use strict";
    function d(t) {
        var e = Object.create(null);
        return (
            t &&
                Object.keys(t).forEach(function (i) {
                    if ("default" !== i) {
                        var s = Object.getOwnPropertyDescriptor(t, i);
                        Object.defineProperty(
                            e,
                            i,
                            s.get
                                ? s
                                : {
                                      enumerable: !0,
                                      get: function () {
                                          return t[i];
                                      },
                                  }
                        );
                    }
                }),
            (e.default = t),
            Object.freeze(e)
        );
    }
    var u = d(o);
    function p(t) {
        const e = t.querySelectorAll("[data-modal]"),
            i = document.querySelector("[data-modal-container]");
        e.forEach((t) => {
            i.querySelector(`[id="${t.id}"]`) || i.appendChild(t);
        });
    }
    function m(t) {
        t.querySelectorAll(".float__wrapper").forEach((t) => {
            const e = t.querySelector("label"),
                i = t.querySelector("input, textarea");
            e &&
                i.addEventListener("keyup", (t) => {
                    "" !== t.target.value ? e.classList.add("label--float") : e.classList.remove("label--float");
                }),
                i && i.value && i.value.length && e.classList.add("label--float");
        });
    }
    function y(t) {
        t.querySelectorAll(".errors").forEach((t) => {
            t.setAttribute("tabindex", "0"), t.setAttribute("aria-live", "assertive"), t.setAttribute("role", "alert");
        });
    }
    function g() {
        const t = {};
        return (
            (t.windowHeight = window.innerHeight),
            (t.announcementHeight = v("#shopify-section-announcement")),
            (t.footerHeight = v('[data-section-type*="footer"]')),
            (t.menuHeight = v("[data-header-height]")),
            (t.headerHeight = t.menuHeight + t.announcementHeight),
            (t.logoHeight = (function () {
                const t = v("[data-footer-logo]");
                return t > 0 ? t + 20 : 0;
            })()),
            (t.stickyHeader = document.querySelector('[data-header-sticky="sticky"]') ? t.menuHeight : 0),
            (t.backfillHeight = v("[data-header-backfill]")),
            t
        );
    }
    function f() {
        document.addEventListener("theme:resize", w),
            (function () {
                const { windowHeight: t, announcementHeight: e, headerHeight: i, logoHeight: s, menuHeight: o, footerHeight: r, stickyHeader: n, backfillHeight: a } = g();
                document.documentElement.style.setProperty("--scrollbar-width", `${b()}px`),
                    document.documentElement.style.setProperty("--footer-logo", `${s}px`),
                    document.documentElement.style.setProperty("--full-screen", `${t}px`),
                    document.documentElement.style.setProperty("--three-quarters", 0.75 * t + "px"),
                    document.documentElement.style.setProperty("--two-thirds", 0.66 * t + "px"),
                    document.documentElement.style.setProperty("--one-half", 0.5 * t + "px"),
                    document.documentElement.style.setProperty("--one-third", 0.33 * t + "px"),
                    document.documentElement.style.setProperty("--one-fifth", 0.2 * t + "px"),
                    document.documentElement.style.setProperty("--menu-height", `${o}px`),
                    document.documentElement.style.setProperty("--announcement-height", `${e}px`),
                    document.documentElement.style.setProperty("--header-height", `${i}px`),
                    document.documentElement.style.setProperty("--footer-height", `${r}px`),
                    document.documentElement.style.setProperty("--content-full", t - i - s / 2 + "px"),
                    document.documentElement.style.setProperty("--menu-height-sticky", `${n}px`);
                let l = Math.abs(a - o) > 1 ? `${o}px` : "auto";
                document.documentElement.style.setProperty("--menu-backfill-height", l);
            })();
    }
    function w() {
        const { windowHeight: t, announcementHeight: e, headerHeight: i, logoHeight: s, menuHeight: o, footerHeight: r, stickyHeader: n, backfillHeight: a } = g();
        document.documentElement.style.setProperty("--scrollbar-width", `${b()}px`),
            document.documentElement.style.setProperty("--full-screen", `${t}px`),
            document.documentElement.style.setProperty("--menu-height", `${o}px`),
            document.documentElement.style.setProperty("--announcement-height", `${e}px`),
            document.documentElement.style.setProperty("--header-height", `${i}px`),
            document.documentElement.style.setProperty("--footer-height", `${r}px`),
            document.documentElement.style.setProperty("--content-full", t - i - s / 2 + "px"),
            document.documentElement.style.setProperty("--menu-height-sticky", `${n}px`);
        let l = Math.abs(a - o) > 1 ? `${o}px` : "auto";
        document.documentElement.style.setProperty("--menu-backfill-height", l);
    }
    function v(t) {
        const e = document.querySelector(t);
        return e ? e.clientHeight : 0;
    }
    function b() {
        const t = document.createElement("div");
        (t.style.visibility = "hidden"), (t.style.overflow = "scroll"), (t.style.msOverflowStyle = "scrollbar"), document.body.appendChild(t);
        const e = document.createElement("div");
        t.appendChild(e);
        const i = t.offsetWidth - e.offsetWidth;
        return t.parentNode.removeChild(t), i;
    }
    function S(t, e) {
        let i = 64,
            s = 0;
        e.forEach((t) => {
            if (t.offsetHeight > s) {
                const e = parseInt(window.getComputedStyle(t).marginTop) + parseInt(window.getComputedStyle(t).marginBottom);
                e > i && (i = e), (s = t.offsetHeight);
            }
        });
        const o = t.querySelectorAll("[data-overflow-background]");
        [t, ...o].forEach((t) => {
            t.style.setProperty("min-height", `calc(${s + i}px + var(--menu-height))`);
        });
    }
    function E(t) {
        let e = document.querySelector("[data-footer-logo]") ? document.querySelector("[data-footer-logo]").clientHeight + 20 : 0;
        const i = document.querySelector("#MainContent .shopify-section:last-child [data-section-id]"),
            s = i ? i.getAttribute("data-section-id") : null;
        if ((((null !== s && t.getAttribute("data-section-id") !== s) || !i) && (e = 0), window.innerWidth < window.theme.sizes.medium)) {
            return void t.querySelectorAll("[data-overflow-frame]").forEach((t) => {
                const e = t.querySelectorAll("[data-overflow-content]");
                S(t, e);
            });
        }
        const o = document.createElement("div");
        t.prepend(o), (o.style.display = "none"), (o.style.width = getComputedStyle(t).getPropertyValue("--outer"));
        const r = 2 * parseInt(getComputedStyle(o).getPropertyValue("width"));
        t.firstChild.remove();
        let n = 0;
        const a = t.querySelectorAll("[data-overflow-frame]");
        t.querySelectorAll("[data-overflow-content]").forEach((t) => {
            t.offsetHeight > n && (n = t.offsetHeight);
        });
        [...a, ...t.querySelectorAll("[data-overflow-background]")].forEach((t) => {
            t.style.setProperty("min-height", `${n + r}px`);
        }),
            t.style.setProperty("min-height", `${n + r + 2 + e}px`);
    }
    function L(t) {
        const i = t.querySelectorAll(".js-overflow-container");
        if (i) {
            i.forEach((t) => {
                const e = t.querySelectorAll(".js-overflow-content");
                S(t, e),
                    document.addEventListener("theme:resize", () => {
                        S(t, e);
                    });
            });
            const s = t.querySelectorAll("[data-slideshow-wrapper]");
            s.length &&
                s.forEach((t) => {
                    const i = e.data(t);
                    void 0 !== i && i.reloadCells();
                });
        }
        const s = t.querySelectorAll("[data-overflow-wrapper]");
        s &&
            s.forEach((t) => {
                E(t),
                    document.addEventListener("theme:resize", () => {
                        E(t);
                    });
            });
    }
    function k(t, e = 500, i = !1) {
        var s, o, r, n, a;
        function l() {
            var c = Date.now() - n;
            c < e && c >= 0 ? (s = setTimeout(l, e - c)) : ((s = null), i || ((a = t.apply(r, o)), (r = o = null)));
        }
        null == e && (e = 100);
        var c = function () {
            (r = this), (o = arguments), (n = Date.now());
            var c = i && !s;
            return s || (s = setTimeout(l, e)), c && ((a = t.apply(r, o)), (r = o = null)), a;
        };
        return (
            (c.clear = function () {
                s && (clearTimeout(s), (s = null));
            }),
            (c.flush = function () {
                s && ((a = t.apply(r, o)), (r = o = null), clearTimeout(s), (s = null));
            }),
            c
        );
    }
    (window.requestIdleCallback =
        window.requestIdleCallback ||
        function (t) {
            var e = Date.now();
            return setTimeout(function () {
                t({
                    didTimeout: !1,
                    timeRemaining: function () {
                        return Math.max(0, 50 - (Date.now() - e));
                    },
                });
            }, 1);
        }),
        (window.cancelIdleCallback =
            window.cancelIdleCallback ||
            function (t) {
                clearTimeout(t);
            });
    let T,
        A = window.innerWidth,
        q = window.innerHeight;
    function C() {
        document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
            A !== window.innerWidth && (document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })), (A = window.innerWidth)),
            q !== window.innerHeight && (document.dispatchEvent(new CustomEvent("theme:resize:height", { bubbles: !0 })), (q = window.innerHeight));
    }
    let x,
        P = window.pageYOffset,
        $ = null,
        M = null,
        H = null,
        _ = null,
        I = 0;
    function D() {
        const t = window.pageYOffset;
        t > P ? ((M = !0), ($ = !1)) : t < P ? ((M = !1), ($ = !0)) : (($ = null), (M = null)),
            (P = t),
            document.dispatchEvent(new CustomEvent("theme:scroll", { detail: { up: $, down: M, position: t }, bubbles: !1 })),
            $ && !H && document.dispatchEvent(new CustomEvent("theme:scroll:up", { detail: { position: t }, bubbles: !1 })),
            M && !_ && document.dispatchEvent(new CustomEvent("theme:scroll:down", { detail: { position: t }, bubbles: !1 })),
            (_ = M),
            (H = $);
    }
    function B(t) {
        let e = t.target;
        t.detail && t.detail instanceof Element && (e = t.detail), i.disableBodyScroll(e), document.documentElement.setAttribute("data-scroll-locked", "");
    }
    function W() {
        if (
            ((I = setTimeout(() => {
                document.body.removeAttribute("data-drawer-closing");
            }, 20)),
            document.body.hasAttribute("data-drawer-closing"))
        )
            return document.body.removeAttribute("data-drawer-closing"), void (I && clearTimeout(I));
        document.body.setAttribute("data-drawer-closing", ""), document.documentElement.removeAttribute("data-scroll-locked"), i.clearAllBodyScrollLocks();
    }
    window.addEventListener("resize", () => {
        T && window.cancelAnimationFrame(T), (T = window.requestAnimationFrame(k(C, 50)));
    }),
        window.addEventListener(
            "scroll",
            function () {
                x && window.cancelAnimationFrame(x), (x = window.requestAnimationFrame(D));
            },
            { passive: !0 }
        ),
        window.addEventListener("theme:scroll:lock", B),
        window.addEventListener("theme:scroll:unlock", W),
        document.addEventListener(
            "load",
            (t) => {
                !(function (t) {
                    "IMG" == t.tagName && t.classList.contains("loading-shimmer") && t.classList.remove("loading-shimmer");
                })(t.target);
            },
            !0
        ),
        window.addEventListener("DOMContentLoaded", () => {
            f(), m(document), y(document), p(document), window.theme.settings.animate_scroll && t.refresh();
        }),
        window.addEventListener("load", () => {
            document.querySelectorAll("img.loading-shimmer").forEach((t) => {
                t.complete && t.classList.remove("loading-shimmer");
            }),
                L(document);
        }),
        document.addEventListener("shopify:section:load", (e) => {
            const i = e.target;
            m(i), y(i), p(i), L(i), window.theme.settings.animate_scroll && t.refresh();
        }),
        document.addEventListener("shopify:section:reorder", () => {
            document.dispatchEvent(new CustomEvent("theme:header:check", { bubbles: !1 }));
        });
    const F = (t, e = !1, i = "block") => {
        t && (e ? t.style.removeProperty("display") : (t.style.display = i));
    };
    function O(t) {
        (this.status = t.status || null), (this.headers = t.headers || null), (this.json = t.json || null), (this.body = t.body || null);
    }
    O.prototype = Error.prototype;
    const N = "data-scrollbar-slider",
        z = "[data-scrollbar-arrow-prev]",
        R = "[data-scrollbar-arrow-next]",
        V = "is-hidden",
        j = 200;
    let U = class {
        init() {
            this.arrowNext && this.arrowPrev && (window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow(), this.events());
        }
        resize() {
            document.addEventListener("theme:resize", () => {
                window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow();
            });
        }
        events() {
            this.arrowNext.addEventListener("click", (t) => {
                t.preventDefault(), this.goToNext();
            }),
                this.arrowPrev.addEventListener("click", (t) => {
                    t.preventDefault(), this.goToPrev();
                }),
                this.scrollbar.addEventListener("scroll", () => {
                    this.togglePrevArrow(), this.toggleNextArrow();
                });
        }
        goToNext() {
            const t = this.scrollbar.getBoundingClientRect().width / 2 + this.scrollbar.scrollLeft;
            this.move(t), this.arrowPrev.classList.remove(V), this.toggleNextArrow();
        }
        goToPrev() {
            const t = this.scrollbar.scrollLeft - this.scrollbar.getBoundingClientRect().width / 2;
            this.move(t), this.arrowNext.classList.remove(V), this.togglePrevArrow();
        }
        toggleNextArrow() {
            setTimeout(() => {
                window.isRTL
                    ? this.arrowNext.classList.toggle(V, 0 === this.scrollbar.scrollLeft)
                    : this.arrowNext.classList.toggle(V, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth);
            }, j);
        }
        togglePrevArrow() {
            setTimeout(() => {
                window.isRTL
                    ? this.arrowPrev.classList.toggle(V, Math.abs(this.scrollbar.scrollLeft) + this.scrollbar.getBoundingClientRect().width + 1 >= this.scrollbar.scrollWidth)
                    : this.arrowPrev.classList.toggle(V, this.scrollbar.scrollLeft <= 0);
            }, j);
        }
        scrollToVisibleElement() {
            [].forEach.call(this.scrollbar.children, (t) => {
                t.addEventListener("click", (e) => {
                    ("a" === e.target.tagName.toLowerCase() || (e.currentTarget && "a" === e.currentTarget.tagName.toLowerCase()) || (e.currentTarget && e.currentTarget.querySelector("a"))) && e.preventDefault(),
                        this.move(t.offsetLeft - t.clientWidth);
                });
            });
        }
        move(t) {
            this.scrollbar.scrollTo({ top: 0, left: t, behavior: "smooth" });
        }
        constructor(t) {
            (this.scrollbar = t),
                (this.arrowNext = this.scrollbar.parentNode.querySelector(R)),
                (this.arrowPrev = this.scrollbar.parentNode.querySelector(z)),
                this.init(),
                this.resize(),
                this.scrollbar.hasAttribute(N) && this.scrollToVisibleElement();
        }
    };
    const J = "[data-sibling-inner]";
    let K = class {
        init() {
            this.siblings.forEach((t) => {
                new U(t);
            });
        }
        constructor(t) {
            (this.siblings = t.querySelectorAll(J)), this.init();
        }
    };
    const Y = {
            onLoad() {
                new K(this.container);
            },
        },
        Q = { expires: 7, path: "/", domain: window.location.hostname };
    let G = class {
        write(t) {
            document.cookie = `${this.options.name}=${t}; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
        }
        read() {
            let t = [];
            const e = document.cookie.split("; ").find((t) => t.startsWith(this.options.name));
            if (-1 !== document.cookie.indexOf("; ") && e) {
                const e = document.cookie
                    .split("; ")
                    .find((t) => t.startsWith(this.options.name))
                    .split("=")[1];
                null !== e && (t = e.split(","));
            }
            return t;
        }
        destroy() {
            document.cookie = `${this.options.name}=null; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
        }
        remove(t) {
            const e = this.read(),
                i = e.indexOf(t);
            -1 !== i && (e.splice(i, 1), this.write(e));
        }
        constructor(t = {}) {
            this.options = { ...Q, ...t };
        }
    };
    const X = 4,
        Z = 10,
        tt = "[data-recently-viewed-products]",
        et = "data-limit",
        it = "[data-recent-link-tab]",
        st = "[data-recent-wrapper]",
        ot = "[data-recently-viewed-tab]",
        rt = "[data-tabs-holder-scroll]",
        nt = "[data-api-content]",
        at = "data-minimum",
        lt = "hide",
        ct = "section-without-title--skip",
        ht = { expires: 90, name: "shopify_recently_viewed" },
        dt = [],
        ut = [];
    const pt = {
        onLoad() {
            dt[this.id] = new (class {
                renderProducts() {
                    const t = this.cookie.read(),
                        e = [];
                    let i = 0;
                    if (t.length > 0) {
                        for (let s = 0; s < t.length; s++) {
                            const o = t[s];
                            if (ut.includes(o)) continue;
                            const r = `${window.theme.routes.root_url}products/${o}?section_id=api-product-grid-item`;
                            if ((e.push(r), i++, i === this.howManyToShow || i === t.length - 1)) break;
                        }
                        if (e.length > 0 && e.length >= this.minimum) {
                            this.container.classList.remove(lt), this.recentViewedLink && this.recentViewedLink.previousElementSibling && (this.tabsHolderScroll.classList.remove(lt), this.container.classList.add(ct));
                            const t = e.map((t) => fetch(t, { mode: "no-cors" }).then(this.handleErrors)),
                                i = [];
                            Promise.allSettled(t)
                                .then((t) =>
                                    Promise.all(
                                        t.map(async (t) => {
                                            "fulfilled" === t.status && i.push(await t.value.text());
                                        })
                                    )
                                )
                                .then(() => {
                                    i.forEach((t) => {
                                        const e = document.createElement("div"),
                                            i = document.createElement("div");
                                        (e.innerHTML = t),
                                            i.classList.add("product-grid-slide"),
                                            i.setAttribute("data-carousel-slide", null),
                                            i.setAttribute("data-item", null),
                                            (i.innerHTML = e.querySelector(nt).innerHTML),
                                            this.wrapper.appendChild(i);
                                    }),
                                        new K(this.container);
                                })
                                .then(() => {
                                    F(this.wrapper, !0), this.container.dispatchEvent(new CustomEvent("theme:recent-products:added", { bubbles: !0 }));
                                });
                        } else if (this.recentViewedTab) {
                            const t = Array.prototype.filter.call(this.recentViewedTab.parentNode.children, (t) => t !== this.recentViewedTab).length > 1;
                            this.recentViewedLink && this.recentViewedLink.previousElementSibling && (this.tabsHolderScroll.classList.add(lt), this.container.classList.remove(ct)), t || this.container.classList.add(lt);
                        } else this.container.classList.add(lt);
                    }
                }
                handleErrors(t) {
                    return t.ok
                        ? t
                        : t.text().then(function (e) {
                              throw new O({ status: t.statusText, headers: t.headers, text: e });
                          });
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.cookie = new G(ht)),
                        (this.wrapper = this.container.querySelector(tt)),
                        null !== this.wrapper &&
                            ((this.howManyToShow = parseInt(this.container.querySelector(st).getAttribute(et)) || X),
                            (this.minimum = parseInt(this.container.querySelector(st).getAttribute(at))),
                            (this.recentViewedTab = this.container.querySelector(ot)),
                            (this.recentViewedLink = this.container.querySelector(it)),
                            (this.tabsHolderScroll = this.container.querySelector(rt)),
                            this.renderProducts());
                }
            })(this);
        },
    };
    function mt(t) {
        return t.replace(/http(s)?:/, "");
    }
    function yt() {
        this.entries = [];
    }
    function gt(t, e) {
        ft(t);
        var i = (function (t, e) {
            ft(t),
                (function (t) {
                    if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
                    if (0 === t.length) throw new Error(t + " is empty.");
                    if (!t[0].hasOwnProperty("name")) throw new Error(t[0] + "does not contain name key.");
                    if ("string" != typeof t[0].name) throw new TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.");
                })(e);
            var i = [];
            return (
                e.forEach(function (e) {
                    for (var s = 0; s < t.options.length; s++) {
                        if ((t.options[s].name || t.options[s]).toLowerCase() === e.name.toLowerCase()) {
                            i[s] = e.value;
                            break;
                        }
                    }
                }),
                i
            );
        })(t, e);
        return (function (t, e) {
            return (
                ft(t),
                (function (t) {
                    if (Array.isArray(t) && "object" == typeof t[0]) throw new Error(t + "is not a valid array of options.");
                })(e),
                t.variants.filter(function (t) {
                    return e.every(function (e, i) {
                        return t.options[i] === e;
                    });
                })[0] || null
            );
        })(t, i);
    }
    function ft(t) {
        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.");
    }
    (yt.prototype.add = function (t, e, i) {
        this.entries.push({ element: t, event: e, fn: i }), t.addEventListener(e, i);
    }),
        (yt.prototype.removeAll = function () {
            this.entries = this.entries.filter(function (t) {
                return t.element.removeEventListener(t.event, t.fn), !1;
            });
        });
    var wt = '[name="id"]',
        vt = '[name="selling_plan"]',
        bt = '[name^="options"]',
        St = '[name="quantity"]',
        Et = '[name^="properties"]';
    const Lt = {};
    function kt(t = {}) {
        if ((t.type || (t.type = "json"), t.url))
            return Lt[t.url]
                ? Lt[t.url]
                : (function (t, e) {
                      const i = new Promise((i, s) => {
                          "text" === e
                              ? fetch(t)
                                    .then((t) => t.text())
                                    .then((t) => {
                                        i(t);
                                    })
                                    .catch((t) => {
                                        s(t);
                                    })
                              : (function (t, e, i) {
                                    let s = document.getElementsByTagName("head")[0],
                                        o = !1,
                                        r = document.createElement("script");
                                    (r.src = t),
                                        (r.onload = r.onreadystatechange = function () {
                                            o || (this.readyState && "loaded" != this.readyState && "complete" != this.readyState) ? i() : ((o = !0), e());
                                        }),
                                        s.appendChild(r);
                                })(
                                    t,
                                    function () {
                                        i();
                                    },
                                    function () {
                                        s();
                                    }
                                );
                      });
                      return (Lt[t] = i), i;
                  })(t.url, t.type);
        if (t.json)
            return Lt[t.json]
                ? Promise.resolve(Lt[t.json])
                : window
                      .fetch(t.json)
                      .then((t) => t.json())
                      .then((e) => ((Lt[t.json] = e), e));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return Lt[e]
                ? Lt[e]
                : (function (t) {
                      const e = "".concat(t.name, t.version),
                          i = new Promise((e, i) => {
                              try {
                                  window.Shopify.loadFeatures([
                                      {
                                          name: t.name,
                                          version: t.version,
                                          onLoad: (t) => {
                                              !(function (t, e, i) {
                                                  i ? e(i) : t();
                                              })(e, i, t);
                                          },
                                      },
                                  ]);
                              } catch (t) {
                                  i(t);
                              }
                          });
                      return (Lt[e] = i), i;
                  })(t);
        }
        return Promise.reject();
    }
    const Tt = "[data-swapper-wrapper]",
        At = "[data-swapper-target]",
        qt = "data-swapper-hover";
    let Ct = {};
    function xt(t) {
        Ct[t.id] = [];
        t.querySelectorAll(Tt).forEach((e) => {
            Ct[t.id].push(
                new (class {
                    init() {
                        this.hovers.forEach((t) => {
                            t.addEventListener(
                                "mouseenter",
                                function () {
                                    const e = t.getAttribute(qt);
                                    this.target.innerHTML = `${e}`;
                                }.bind(this)
                            );
                        }),
                            this.hovers.forEach((t) => {
                                t.addEventListener(
                                    "mouseleave",
                                    function () {
                                        this.target.innerHTML = this.deafaultContent;
                                    }.bind(this)
                                );
                            }),
                            this.hovers.forEach((t) => {
                                t.addEventListener(
                                    "click",
                                    function () {
                                        const e = t.getAttribute(qt);
                                        this.deafaultContent = `${e}`;
                                    }.bind(this)
                                );
                            });
                    }
                    constructor(t) {
                        (this.container = t),
                            (this.target = this.container.querySelector(At)),
                            (this.hovers = this.container.querySelectorAll(`[${qt}]`)),
                            this.target && this.hovers.length && ((this.deafaultContent = this.target.innerHTML), this.init());
                    }
                })(e)
            );
        });
    }
    const Pt = {
            onLoad() {
                xt(this.container);
            },
        },
        $t = { color: "ash" },
        Mt = "data-swatch",
        Ht = "[data-grid-item]",
        _t = "data-grid-image-default",
        It = "data-grid-image-target",
        Dt = "data-swatch-image",
        Bt = "data-swatch-image-id",
        Wt = "data-swatch-variant",
        Ft = "[data-grid-swatches]",
        Ot = "[data-swatch-template]",
        Nt = "data-swatch-handle",
        zt = "data-swatch-label",
        Rt = "is-fade";
    let Vt = class extends HTMLElement {
        init() {
            this.setStyles(),
                this.variant &&
                    this.outer &&
                    this.outer.addEventListener("theme:quickview:media", (t) => {
                        t && t.detail && t.detail.media && (this.media = t.detail.media);
                    });
        }
        setStyles() {
            this.colorMatch.hex && this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`),
                this.colorMatch.path && (this.element.style.setProperty("background-image", `url(${this.colorMatch.path})`), this.element.style.setProperty("background-size", "cover"));
        }
        replaceImage() {
            if (this.imageReplace && this.imageSlide && this.imageId) {
                if (this.imageSlide.hasAttribute(It) && this.imageSlide.getAttribute(It) !== this.imageId) {
                    this.imageSlide.classList.add(Rt);
                    const t = 1e3 * parseFloat(window.getComputedStyle(this.imageSlide).getPropertyValue("animation-duration"));
                    setTimeout(() => {
                        this.imageSlide.classList.remove(Rt);
                    }, t);
                }
                this.imageSlide.setAttribute(It, this.imageId),
                    this.imageSlide.style.setProperty("background-color", "#fff"),
                    this.imageSlide.hasAttribute(_t) || this.imageSlide.setAttribute(_t, window.getComputedStyle(this.imageSlide).backgroundImage),
                    this.imageSlide.style.setProperty("background-image", this.imageReplace);
            }
        }
        constructor() {
            super(),
                (this.element = this.querySelector(`[${Mt}]`)),
                (this.colorString = this.element.getAttribute(Mt)),
                (this.image = this.element.getAttribute(Dt)),
                (this.imageId = this.element.getAttribute(Bt)),
                (this.variant = this.element.getAttribute(Wt)),
                (this.outer = this.element.closest(Ht)),
                (this.media = null),
                (this.imageSlide = null),
                (this.imageDefault = null),
                (this.stopSlideAnimation = !1);
            const t = new (class {
                getColor() {
                    return this.match;
                }
                init() {
                    return kt({ json: window.theme.assets.swatches })
                        .then((t) => this.matchColors(t, this.settings.color))
                        .catch((t) => {
                            console.log("failed to load swatch colors script"), console.log(t);
                        });
                }
                matchColors(t, e) {
                    let i = "#E5E5E5",
                        s = null;
                    const o = window.theme.assets.base || "/",
                        r = e.toLowerCase().replace(/\s/g, ""),
                        n = t.colors;
                    if (n) {
                        const t = (t) => Object.keys(t).toString().toLowerCase().replace(/\s/g, "") === r,
                            e = n.findIndex(t);
                        if (e > -1) {
                            const t = Object.values(n[e])[0],
                                r = t.toLowerCase();
                            r.includes(".jpg") || r.includes(".jpeg") || r.includes(".png") || r.includes(".svg") ? ((s = `${o}${encodeURIComponent(t)}`), (i = "#888888")) : (i = t);
                        }
                    }
                    return { color: this.settings.color, path: s, hex: i };
                }
                constructor(t = {}) {
                    (this.settings = { ...$t, ...t }), (this.match = this.init());
                }
            })({ color: this.colorString });
            t.getColor().then((t) => {
                (this.colorMatch = t), this.init();
            });
        }
    };
    function jt(t) {
        t.querySelectorAll(Ft).forEach((t) => {
            new (class {
                init() {
                    (this.wrap.innerHTML = ""),
                        this.swatches.forEach((t, e) => {
                            let i = this.product.variants.find((e) => e.options.includes(t));
                            const s = i.featured_media ? i.featured_media.preview_image.src : "",
                                o = i.featured_media ? i.featured_media.id : "",
                                r = Math.floor(9999 * Math.random());
                            this.wrap.innerHTML += u.render(this.template, { color: t, uniq: `${this.product.id}-${i.id}-${r}`, variant: i.id, product_id: this.product.id, image_id: o, image: s, index: e });
                        }),
                        new U(this.wrap);
                }
                constructor(t) {
                    (this.template = document.querySelector(Ot).innerHTML), (this.wrap = t), (this.handle = t.getAttribute(Nt));
                    const e = t.getAttribute(zt).trim().toLowerCase();
                    (function (t) {
                        const e = `${window.theme.routes.root_url}products/${t}.js`;
                        return window
                            .fetch(e)
                            .then((t) => t.json())
                            .catch((t) => {
                                console.error(t);
                            });
                    })(this.handle).then((t) => {
                        (this.product = t),
                            (this.colorOption = t.options.find(function (t) {
                                return t.name.toLowerCase() === e || null;
                            })),
                            this.colorOption && ((this.swatches = this.colorOption.values), this.init());
                    });
                }
            })(t);
        });
    }
    const Ut = {
            onLoad() {
                jt(this.container), xt(this.container);
            },
        },
        Jt = "[data-custom-scrollbar-items]",
        Kt = "[data-custom-scrollbar]",
        Yt = "[data-custom-scrollbar-track]",
        Qt = "hide",
        Gt = {};
    let Xt = class {
        events() {
            this.holderItems.addEventListener("scroll", this.calculatePosition.bind(this)),
                this.holderItems.addEventListener("theme:carousel:scroll", this.calculatePosition.bind(this)),
                document.addEventListener("theme:resize:width", this.calculateTrackWidth.bind(this)),
                document.addEventListener("theme:resize:width", this.calculatePosition.bind(this));
        }
        calculateTrackWidth() {
            const t = document.createElement("div");
            this.holderItems.prepend(t), (t.style.display = "none"), (t.style.width = getComputedStyle(this.holderItems).getPropertyValue("--outer"));
            const e = parseInt(getComputedStyle(t).getPropertyValue("width"));
            this.holderItems.firstChild.remove(),
                (this.scrollbarWidth = 0 === this.scrollbar.clientWidth ? this.scrollbar.parentNode.getBoundingClientRect().width : this.scrollbar.clientWidth),
                setTimeout(() => {
                    const t = this.children[0].clientWidth,
                        i = Number(getComputedStyle(this.children[0]).marginRight.replace("px", "")),
                        s = Number(getComputedStyle(this.children[0]).marginLeft.replace("px", ""));
                    (this.scrollWidth = this.children.length * (t + i + s) + e - i),
                        (this.trackWidth = ((this.scrollbarWidth + e) / this.scrollWidth) * 100),
                        (this.trackWidth = this.trackWidth < 5 ? 5 : this.trackWidth),
                        this.scrollbar.style.setProperty("--track-width", `${this.trackWidth}%`);
                    const o = Math.ceil(this.trackWidth) >= 100;
                    this.scrollbar.classList.toggle(Qt, o);
                }, 100);
        }
        calculatePosition() {
            let t = this.holderItems.scrollLeft / (this.holderItems.scrollWidth - this.holderItems.clientWidth);
            (t *= this.scrollbar.clientWidth - this.scrollbarTrack.clientWidth),
                (t = t < 0 ? 0 : t),
                (t = isNaN(t) ? 0 : t),
                this.scrollbar.style.setProperty("--position", `${Math.round(t)}px`),
                document.dispatchEvent(new CustomEvent("theme:scrollbar:scroll", { bubbles: !0, detail: { holder: this.holderItems } }));
        }
        constructor(t, e = null) {
            (this.holderItems = t.querySelector(Jt)),
                (this.scrollbar = t.querySelector(Kt)),
                (this.scrollbarTrack = t.querySelector(Yt)),
                (this.trackWidth = 0),
                (this.scrollWidth = 0),
                this.scrollbar && this.holderItems && ((this.children = e || this.holderItems.children), this.events(), this.calculateTrackWidth());
        }
    };
    const Zt = {
            onLoad() {
                Gt[this.id] = new Xt(this.container);
            },
        },
        te = "[data-carousel]",
        ee = "data-carousel-progress",
        ie = "[data-carousel-slide]",
        se = "[data-grid-slide]",
        oe = "[data-wrapper]",
        re = "[data-carousel-track]",
        ne = "data-options",
        ae = "data-custom-scrollbar-items",
        le = ".flickity-button.previous",
        ce = ".flickity-button.next",
        he = "data-recently-viewed-products",
        de = "data-related-products",
        ue = "[data-section-id]",
        pe = "wrapper--full",
        me = "not-moved-arrows",
        ye = "hide",
        ge = "flickity-enabled",
        fe = "hidden-arrows",
        we = "flickity-static",
        ve = 112;
    let be = class extends HTMLElement {
        connectedCallback() {
            (this.carousel = this.container.querySelector(te)),
                (this.carouselTrack = this.container.querySelector(re)),
                (this.wrapper = this.container.closest(oe)),
                (this.section = this.container.closest(ue)),
                (this.slidesVisible = null),
                (this.carouselInstance = null),
                (this.carouselPrev = null),
                (this.carouselNext = null),
                (this.customOptions = {}),
                (this.toggleWrapperModifierEvent = () => this.toggleWrapperModifier()),
                this.carousel && this.carousel.hasAttribute(he)
                    ? this.section.addEventListener("theme:recent-products:added", () => {
                          this.init();
                      })
                    : this.carousel && this.carousel.hasAttribute(de)
                    ? this.section.addEventListener("theme:related-products:added", () => {
                          this.init();
                      })
                    : this.init();
        }
        init() {
            this.carousel &&
                ((this.slidesTotal = this.carousel.querySelectorAll(ie).length),
                this.getGridLayout(),
                this.trackVisibleSlides(),
                this.carousel.hasAttribute(ne) && (this.customOptions = JSON.parse(decodeURIComponent(this.carousel.getAttribute(ne)))),
                this.initCarousel(),
                this.calculatedArrowsTopPosition(),
                this.toggleWrapperModifier(),
                document.addEventListener("theme:resize:width", this.toggleWrapperModifierEvent),
                this.carousel.hasAttribute(ee) && this.progressBarCalculate(),
                this.carousel.hasAttribute(ae) && new Xt(this.container));
        }
        initCarousel() {
            (this.options = {
                accessibility: !0,
                contain: !0,
                freeScroll: !0,
                prevNextButtons: !1,
                wrapArround: !1,
                groupCells: !1,
                autoPlay: !1,
                pageDots: !1,
                cellAlign: window.isRTL ? "right" : "left",
                rightToLeft: window.isRTL,
                dragThreshold: 10,
                arrowShape: { x0: 10, x1: 60, y1: 50, x2: 65, y2: 45, x3: 20 },
                on: {
                    resize: () => {
                        this.toggleArrows(),
                            this.calculatedArrowsTopPosition(),
                            setTimeout(() => {
                                this.visibleSlides();
                            }, 100);
                    },
                },
                ...this.customOptions,
            }),
                (this.carouselInstance = new s(this.carousel, this.options)),
                (this.carouselPrev = this.carousel.querySelector(le)),
                (this.carouselNext = this.carousel.querySelector(ce)),
                this.container.addEventListener("theme:tab:change", () => {
                    this.carouselInstance.resize(), (this.carouselPrev = this.carousel.querySelector(le)), (this.carouselNext = this.carousel.querySelector(ce));
                }),
                this.carouselInstance.on("dragStart", () => {
                    (this.carouselInstance.slider.style.pointerEvents = "none"), this.containDrag();
                }),
                this.carouselInstance.on("dragEnd", () => {
                    (this.carouselInstance.slider.style.pointerEvents = "auto"), this.containDrag();
                }),
                this.carouselInstance.on("change", (t) => this.lockArrows(t)),
                setTimeout(() => {
                    this.visibleSlides();
                }, 100),
                Shopify.designMode &&
                    setTimeout(() => {
                        this.carouselInstance.options.watchCSS && !this.carousel.classList.contains(ge)
                            ? (this.carouselInstance.destroy(),
                              (this.carouselInstance = new s(this.carousel, this.options)),
                              this.carouselInstance.resize(),
                              (this.carouselPrev = this.carousel.querySelector(le)),
                              (this.carouselNext = this.carousel.querySelector(ce)))
                            : this.carouselInstance.resize();
                    }, 10),
                this.carousel.classList.toggle(we, this.smallItems === this.carousel.querySelectorAll(ie).length),
                jt(this.container),
                new K(this.container);
        }
        calculatedArrowsTopPosition() {
            const t = this.container.querySelector(se);
            if (t) {
                const e = t.offsetHeight / 2;
                this.carousel.style.setProperty("--buttons-top", `${e}px`);
            }
        }
        toggleWrapperModifier() {
            if (!this.wrapper) return;
            const t = Number(getComputedStyle(document.documentElement).getPropertyValue("--scrollbar-width").replace("px", "")),
                e = this.wrapper.clientWidth;
            (this.wrapperWidthWithGutter = e + ve + t), this.wrapper.classList.toggle(pe, this.wrapperWidthWithGutter >= window.innerWidth), this.section.classList.toggle(me, !(this.wrapperWidthWithGutter >= window.innerWidth));
        }
        progressBarCalculate() {
            null !== this.carouselInstance &&
                this.carouselTrack &&
                this.carouselInstance.on("scroll", (t) => {
                    (t = 100 * Math.max(0, Math.min(1, t)) + "%"), (this.carouselTrack.style.width = t);
                });
        }
        getGridLayout() {
            (this.largeItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-large-items")) || 3),
                (this.mediumItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-medium-items")) || this.largeItems),
                (this.smallItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-small-items")) || this.mediumItems || this.largeItems);
        }
        visibleSlides() {
            if (!this.carousel) return;
            this.getGridLayout();
            const t = this.carousel.clientWidth || this.carouselInstance.size.width,
                e = null !== this.carouselInstance && this.carouselInstance.selectedElement ? this.carouselInstance.selectedElement.clientWidth : this.carousel.querySelector(ie).clientWidth,
                i = null !== this.carouselInstance && this.carouselInstance.slides ? this.carouselInstance.slides.length : this.carousel.querySelectorAll(ie).length,
                s = Math.floor(t / e);
            this.section.classList.remove(fe),
                this.carouselPrev && this.carouselNext && (this.carouselPrev.classList.remove(ye), this.carouselNext.classList.remove(ye)),
                window.innerWidth > window.theme.sizes.large && !this.options.groupCells && s <= this.largeItems && i <= this.largeItems && this.carouselPrev && this.carouselNext && this.hideArrows(),
                window.innerWidth >= window.theme.sizes.medium &&
                    window.innerWidth <= window.theme.sizes.large &&
                    !this.options.groupCells &&
                    s <= this.mediumItems &&
                    i <= this.mediumItems &&
                    this.carouselPrev &&
                    this.carouselNext &&
                    this.hideArrows(),
                window.innerWidth < window.theme.sizes.medium && !this.options.groupCells && s <= this.smallItems && i <= this.smallItems && this.carouselPrev && this.carouselNext && this.hideArrows();
        }
        trackVisibleSlides() {
            const t = window.matchMedia(`(max-width: ${window.theme.sizes.medium - 1}px)`),
                e = window.matchMedia(`(min-width: ${window.theme.sizes.medium}px) and (max-width: ${window.theme.sizes.large - 1}px)`),
                i = window.matchMedia(`(min-width: ${window.theme.sizes.large}px)`);
            t.addEventListener("change", (t) => {
                !t.matches || (this.slidesVisible = this.smallItems);
            }),
                !t.matches || (this.slidesVisible = this.smallItems),
                e.addEventListener("change", (t) => {
                    !t.matches || (this.slidesVisible = this.mediumItems);
                }),
                !e.matches || (this.slidesVisible = this.mediumItems),
                i.addEventListener("change", (t) => {
                    !t.matches || (this.slidesVisible = this.largeItems);
                }),
                !i.matches || (this.slidesVisible = this.largeItems);
        }
        containDrag() {
            const t = this.slidesTotal - this.slidesVisible;
            this.carouselInstance.selectedIndex >= t && (this.carouselInstance.select(t), this.lockArrows(this.carouselInstance.selectedIndex));
        }
        lockArrows(t) {
            if (this.options.wrapAround || this.options.groupCells) return;
            const e = parseInt(t),
                i = this.slidesTotal - this.slidesVisible;
            this.carouselNext.disabled = e >= i;
        }
        showArrows() {
            this.carouselPrev.classList.remove(ye), this.carouselNext.classList.remove(ye), this.section.classList.remove(fe);
        }
        hideArrows() {
            this.carouselPrev.classList.add(ye), this.carouselNext.classList.add(ye), this.section.classList.add(fe);
        }
        toggleArrows() {
            this.carouselPrev && this.carouselNext && (this.carouselPrev.disabled && this.carouselNext.disabled ? this.hideArrows() : this.showArrows());
        }
        constructor() {
            super(), (this.container = this);
        }
    };
    function Se(t, e) {
        (e = e || {}),
            t.focus(),
            void 0 !== e.className && t.classList.add(e.className),
            t.addEventListener("blur", function i(s) {
                s.target.removeEventListener(s.type, i), void 0 !== e.className && t.classList.remove(e.className);
            });
    }
    function Ee(t) {
        return (
            (t = t || {}),
            Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter(function (e) {
                if ("#" === e.hash || "" === e.hash) return !1;
                if (t.ignore && e.matches(t.ignore)) return !1;
                if (((i = e.hash.substr(1)), null === document.getElementById(i))) return !1;
                var i,
                    s = document.querySelector(e.hash);
                return (
                    !!s &&
                    (e.addEventListener("click", function () {
                        Se(s, t);
                    }),
                    !0)
                );
            })
        );
    }
    customElements.get("flickity-carousel") || customElements.define("flickity-carousel", be);
    var Le = {};
    function ke(t, e) {
        e = e || {};
        var i = (function (t) {
                return Array.prototype.slice.call(t.querySelectorAll("[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled[data-focus-element]")).filter(function (t) {
                    return Boolean(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
                });
            })(t),
            s = e.elementToFocus || t,
            o = i[0],
            r = i[i.length - 1];
        Te(),
            (Le.focusin = function (e) {
                t !== e.target && !t.contains(e.target) && o && o === e.target && o.focus(), (e.target !== t && e.target !== r && e.target !== o) || document.addEventListener("keydown", Le.keydown);
            }),
            (Le.focusout = function () {
                document.removeEventListener("keydown", Le.keydown);
            }),
            (Le.keydown = function (e) {
                "Tab" === e.code && (e.target !== r || e.shiftKey || (e.preventDefault(), o.focus()), (e.target !== t && e.target !== o) || !e.shiftKey || (e.preventDefault(), r.focus()));
            }),
            document.addEventListener("focusout", Le.focusout),
            document.addEventListener("focusin", Le.focusin),
            Se(s, e);
    }
    function Te() {
        document.removeEventListener("focusin", Le.focusin), document.removeEventListener("focusout", Le.focusout), document.removeEventListener("keydown", Le.keydown);
    }
    const Ae = (t, e) => {
            let i, s;
            return function o(...r) {
                const n = Date.now();
                (s = clearTimeout(s)), !i || n - i >= e ? (t.apply(null, r), (i = n)) : (s = setTimeout(o.bind(null, ...r), e - (n - i)));
            };
        },
        qe = "[data-size-button]",
        Ce = "[data-media-slide]",
        xe = "is-expanded";
    let Pe = class {
        init() {
            this.sizeButtons.forEach((t) => {
                t.addEventListener("click", () => {
                    t.classList.toggle(xe), t.closest(Ce).classList.toggle(xe);
                });
            });
        }
        constructor(t) {
            (this.container = t), (this.sizeButtons = this.container.querySelectorAll(qe)), this.sizeButtons.length > 0 && this.init();
        }
    };
    const $e = "data-quickview",
        Me = "data-quickview-holder",
        He = "[data-product-quickview-ajax]",
        _e = "[data-quickview-modal]",
        Ie = "[data-drawer-scrolls]",
        De = "[data-quickview-modal-template]",
        Be = "[data-quickview-head]",
        We = "[data-quickview-form-area]",
        Fe = "[data-toggle-button]",
        Oe = "[data-media-slide]",
        Ne = "[data-media-id]",
        ze = "data-popup-",
        Re = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        Ve = "hide",
        je = "is-active",
        Ue = "is-expanded",
        Je = "loading",
        Ke = 250,
        Ye = 400;
    let Qe = class extends HTMLElement {
        static get observedAttributes() {
            return [$e];
        }
        attributeChangedCallback(t, e, i) {
            e && (this.disconnectedCallback(), this.connectedCallback());
        }
        connectedCallback() {
            if (((this.quickviewHolder = this.container.querySelector(`[${Me}]`)), (this.modalCloseEvent = () => this.modalClose()), (this.clickQuickviewEvent = (t) => this.clickQuickviewButton(t)), this.quickviewHolder)) {
                if (
                    ((this.modalTemplate = this.quickviewHolder.querySelector(De)),
                    (this.modal = document.querySelector(_e)),
                    (this.modalID = this.quickviewHolder.getAttribute(Me)),
                    (this.modalContent = null),
                    (this.modalScroll = null),
                    (this.scrollLockEnable = !0),
                    (this.windowH = window.innerHeight),
                    (this.triggerButton = this.quickviewHolder.querySelector(`[${ze}${this.modalID}]`)),
                    (this.handle = this.triggerButton ? this.triggerButton.getAttribute(`${ze}${this.modalID}`) : null),
                    this.modalTemplate && !this.modal)
                ) {
                    const t = this.modalTemplate.innerHTML,
                        e = document.createElement("div");
                    (e.innerHTML = t), (this.modalHtml = e.querySelector(_e)), document.body.appendChild(this.modalHtml), (this.modal = document.querySelector(_e));
                }
                this.modalTemplate && this.triggerButton && this.triggerButton.addEventListener("click", this.clickQuickviewEvent);
            }
        }
        clickQuickviewButton(t) {
            t.preventDefault(),
                this.modal && this.modalID && (this.modal.id = this.modalID),
                document.documentElement.hasAttribute("data-scroll-locked") && (this.scrollLockEnable = !1),
                this.container.classList.add(Je),
                this.getQuickviewHTML();
        }
        getQuickviewHTML() {
            window
                .fetch(`${window.theme.routes.root_url}products/${this.handle}?section_id=api-product-quickview`)
                .then(this.handleErrors)
                .then((t) => t.text())
                .then((t) => {
                    const e = document.createElement("div");
                    (e.innerHTML = t), (this.modalContent = this.modal.querySelector(He)), (this.modalContent.innerHTML = e.querySelector("[data-api-content]").innerHTML), (this.modalScroll = this.modal.querySelector(Ie));
                    const i = this.modalContent.querySelector(Ne);
                    if (i) {
                        const t = document.createElement("div");
                        (t.innerHTML = i.parentElement.innerHTML), this.quickviewHolder.dispatchEvent(new CustomEvent("theme:quickview:media", { bubbles: !0, detail: { media: t } }));
                    }
                    this.modalCreate(), this.container.classList.remove(Je);
                });
        }
        modalCreate() {
            r.show(this.modalID, {
                onShow: (t, e, i) => {
                    (this.quickviewHead = t.querySelector(Be)),
                        (this.quickviewFormArea = t.querySelector(We)),
                        (this.toggleButton = t.querySelector(Fe)),
                        this.toggleForm("loading"),
                        document.addEventListener(
                            "theme:resize",
                            Ae(() => {
                                this.toggleForm("resize");
                            }, 500)
                        ),
                        this.clickEventToggleForm();
                    const s = t.querySelector(Re);
                    ke(t, { elementToFocus: s }),
                        this.modal.addEventListener("theme:quickview:close", this.modalCloseEvent),
                        document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.modalScroll })),
                        new Pe(this.modal);
                },
                onClose: (t, e, i) => {
                    t.querySelectorAll(Oe).forEach((t) => {
                        t.dispatchEvent(new CustomEvent("pause"));
                    }),
                        Te(),
                        e.focus(),
                        this.modal.removeEventListener("theme:quickview:close", this.modalCloseEvent),
                        this.scrollLockEnable ? document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })) : (this.scrollLockEnable = !0);
                },
            });
        }
        modalClose() {
            r.close(this.modalID);
        }
        handleErrors(t) {
            return t.ok
                ? t
                : t.json().then(function (e) {
                      throw new O({ status: t.statusText, headers: t.headers, json: e });
                  });
        }
        toggleForm(t) {
            (this.windowH === window.innerHeight && "resize" === t) ||
                (this.toggleButton.classList.contains(Ve) || this.toggleButton.classList.add(Ve),
                this.quickviewFormArea.classList.contains(Ue) || this.quickviewFormArea.classList.add(Ue),
                "resize" === t && (this.quickviewFormArea.classList.add(Ue), this.toggleButton.classList.add(Ve), (this.windowH = window.innerHeight)),
                setTimeout(() => {
                    const e = window.innerHeight - this.quickviewHead.offsetHeight - this.quickviewFormArea.offsetHeight,
                        i = e < Ke;
                    (e < Ye && e > Ke) || i ? (this.toggleButton.classList.remove(Ve), this.toggleButton.classList.add(je)) : this.toggleButton.classList.add(Ve),
                        i
                            ? ("loading" === t &&
                                  (this.quickviewFormArea.classList.add(Je),
                                  setTimeout(() => {
                                      this.quickviewFormArea.classList.remove(Je);
                                  }, 50)),
                              this.quickviewFormArea.classList.remove(Ue),
                              this.toggleButton.classList.remove(je))
                            : this.quickviewFormArea.classList.add(Ue);
                }, 200));
        }
        clickEventToggleForm() {
            this.toggleButton &&
                this.toggleButton.addEventListener("click", () => {
                    this.toggleButton.classList.toggle(je), this.quickviewFormArea.classList.toggle(Ue);
                });
        }
        disconnectedCallback() {
            this.modalTemplate && this.triggerButton && this.triggerButton.removeEventListener("click", this.clickQuickviewEvent);
        }
        constructor() {
            super(), (this.container = this);
        }
    };
    const Ge = (t, e = 500, i = !0) => {
            let s = window.getComputedStyle(t).display;
            if (i && "none" !== s) return;
            t.style.removeProperty("display"), "none" === s && (s = "block"), (t.style.display = s);
            let o = t.offsetHeight;
            (t.style.overflow = "hidden"),
                (t.style.height = 0),
                (t.style.paddingTop = 0),
                (t.style.paddingBottom = 0),
                (t.style.marginTop = 0),
                (t.style.marginBottom = 0),
                t.offsetHeight,
                (t.style.boxSizing = "border-box"),
                (t.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)"),
                (t.style.transitionProperty = "height, margin, padding"),
                (t.style.transitionDuration = e + "ms"),
                (t.style.height = o + "px"),
                t.style.removeProperty("padding-top"),
                t.style.removeProperty("padding-bottom"),
                t.style.removeProperty("margin-top"),
                t.style.removeProperty("margin-bottom"),
                window.setTimeout(() => {
                    t.style.removeProperty("height"), t.style.removeProperty("overflow"), t.style.removeProperty("transition-duration"), t.style.removeProperty("transition-property"), t.style.removeProperty("transition-timing-function");
                }, e);
        },
        Xe = (t, e = 500) => {
            (t.style.transitionProperty = "height, margin, padding"),
                (t.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)"),
                (t.style.transitionDuration = e + "ms"),
                (t.style.boxSizing = "border-box"),
                (t.style.height = t.offsetHeight + "px"),
                t.offsetHeight,
                (t.style.overflow = "hidden"),
                (t.style.height = 0),
                (t.style.paddingTop = 0),
                (t.style.paddingBottom = 0),
                (t.style.marginTop = 0),
                (t.style.marginBottom = 0),
                window.setTimeout(() => {
                    (t.style.display = "none"),
                        t.style.removeProperty("height"),
                        t.style.removeProperty("padding-top"),
                        t.style.removeProperty("padding-bottom"),
                        t.style.removeProperty("margin-top"),
                        t.style.removeProperty("margin-bottom"),
                        t.style.removeProperty("overflow"),
                        t.style.removeProperty("transition-duration"),
                        t.style.removeProperty("transition-property"),
                        t.style.removeProperty("transition-timing-function");
                }, e);
        };
    function Ze(t, ...e) {
        e.forEach((e) => {
            !(function (t, e) {
                if (!Reflect.has(t.constructor.prototype, e)) throw new Error(`${t} does not define property "${e}"`);
                if (Reflect.getOwnPropertyDescriptor(t.constructor.prototype, e).writable) throw new Error(`${t} does not define property "${e}" as a getter`);
                const i = Reflect.get(t, e);
                Reflect.defineProperty(t, e, { get: () => (void 0 !== i && (Reflect.deleteProperty(t, e), Reflect.defineProperty(t, e, { value: i })), i) });
            })(t, e);
        });
    }
    const ti = {
            wrapper: "[data-add-action-wrapper]",
            addButton: "[data-add-to-cart]",
            errorBoundary: "[data-error-boundary]",
            errorDisplay: "[data-error-display]",
            popdown: "[data-product-add-popdown-wrapper]",
            disabledAjax: '[data-ajax-disable="true"]',
            quickviewModal: "[data-quickview-modal]",
            inputFile: '[type="file"]',
        },
        ei = "loading",
        ii = "has-success",
        si = 3500,
        oi = 5e3;
    let ri = class extends HTMLElement {
        connectedCallback() {
            this.button && this.initWithForm();
        }
        get popdown() {
            // return document.querySelector(ti.popdown);
        }
        get disabledAjax() {
            return document.querySelector(ti.disabledAjax);
        }
        get button() {
            return this.wrapper.querySelector(ti.addButton);
        }
        get errors() {
            const t = this.wrapper.querySelector(ti.errors);
            if (!t) {
                const t = this.wrapper.closest(ti.errorBoundary);
                if (t) return t.querySelector(ti.errorDisplay);
            }
            return t;
        }
        initWithForm() {
            this.button.addEventListener(
                "click",
                function (t) {
                    t.preventDefault();
                    const e = t.target.closest("form");
                    if (e.querySelector(ti.inputFile)) return;
                    this.disabledAjax || t.preventDefault(), this.button.setAttribute("disabled", !0), this.button.classList.add(ei);
                    const i = new FormData(e),
                        s = new URLSearchParams(i).toString();
                    this.addToCartAction(s);
                }.bind(this)
            );
        }
        addToCartAction(t) {
            const e = `${window.theme.routes.cart}/add.js`,
                i = this;
            n.post(e, t, { headers: { "X-Requested-With": "XMLHttpRequest", "Content-Type": "application/x-www-form-urlencoded" } })
                .then(function (t) {
                    i.onSuccess(t.data);
                })
                .catch(function (t) {
                    console.warn(t), i.onError(t.data);
                });
        }
        onSuccess(t) {
            this.updateHeaderTotal(),
                this.button.classList.remove(ei),
                this.button.classList.add(ii),
                setTimeout(() => {
                    this.button.classList.remove(ii), this.button.removeAttribute("disabled");
                }, si),
                this.button.closest(ti.quickviewModal) && this.button.closest(ti.quickviewModal).dispatchEvent(new CustomEvent("theme:quickview:close")),
                window.theme.state.cartOpen ? document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: !0 })) : window.location.href = "/cart";
              // dev notes: disable cart popup
              // this.popdown.dispatchEvent(new CustomEvent("theme:cart:popdown", { detail: { variant: t }, bubbles: !0 })),
                this.disabledAjax && window.location.reload();
        }
        onError(t) {
            let e = "Network error: please try again";
            t && t.description && (e = t.description);
            const i = `<div class="errors">${e}</div>`;
            this.button.classList.remove(ei),
                this.button.removeAttribute("disabled"),
                (this.errors.innerHTML = i),
                Ge(this.errors),
                setTimeout(() => {
                    Xe(this.errors);
                }, oi);
        }
        updateHeaderTotal() {
            n.get(`${window.theme.routes.cart}.js`)
                .then((t) => {
                    document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart: t.data }, bubbles: !0 }));
                })
                .catch((t) => {
                    console.error(t);
                });
        }
        constructor() {
            super(), (this.wrapper = this), Ze(this, "popdown", "button");
        }
    };
    customElements.get("") || customElements.define("product-quickview", Qe), customElements.get("product-add-button") || customElements.define("product-add-button", ri);
    const ni = "[data-address-wrapper]",
        ai = "[data-new-address-form]",
        li = "[new-address-form-inner]",
        ci = ".address-new-toggle",
        hi = ".address-edit-toggle",
        di = ".address-delete",
        ui = "hide",
        pi = "data-form-id",
        mi = "data-confirm-message",
        yi = "Are you sure you wish to delete this address?",
        gi = "#EditAddress",
        fi = "AddressCountryNew",
        wi = "AddressProvinceNew",
        vi = "AddressProvinceContainerNew",
        bi = ".address-country-option",
        Si = "AddressCountry",
        Ei = "AddressProvince",
        Li = "AddressProvinceContainer";
    const ki = document.querySelector(ni);
    ki &&
        new (class {
            init() {
                if (this.addressNewForm) {
                    const t = this.section,
                        e = this.addressNewForm.querySelector(li);
                    this.customerAddresses();
                    const i = t.querySelectorAll(ci);
                    i.length &&
                        i.forEach((t) => {
                            t.addEventListener("click", function () {
                                e.classList.toggle(ui);
                            });
                        });
                    const s = t.querySelectorAll(hi);
                    s.length &&
                        s.forEach((e) => {
                            e.addEventListener("click", function () {
                                const e = this.getAttribute(pi);
                                t.querySelector(`${gi}_${e}`).classList.toggle(ui);
                            });
                        });
                    const o = t.querySelectorAll(di);
                    o.length &&
                        o.forEach((t) => {
                            t.addEventListener("click", function () {
                                const t = this.getAttribute(pi),
                                    e = this.getAttribute(mi);
                                confirm(e || yi) && Shopify.postLink(window.theme.routes.account_addresses_url + "/" + t, { parameters: { _method: "delete" } });
                            });
                        });
                }
            }
            customerAddresses() {
                Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(fi, wi, { hideElement: vi }),
                    this.section.querySelectorAll(bi).forEach((t) => {
                        const e = t.getAttribute(pi),
                            i = `${Si}_${e}`,
                            s = `${Ei}_${e}`,
                            o = `${Li}_${e}`;
                        new Shopify.CountryProvinceSelector(i, s, { hideElement: o });
                    });
            }
            constructor(t) {
                (this.section = t), (this.addressNewForm = this.section.querySelector(ai)), this.init();
            }
        })(ki),
        document.querySelector("#RecoverPassword") &&
            (function () {
                var t = { recoverPasswordForm: "#RecoverPassword", hideRecoverPasswordLink: "#HideRecoverPasswordLink" };
                function e(t) {
                    t.preventDefault(), s();
                }
                function i() {
                    "#recover" === window.location.hash && s();
                }
                function s() {
                    var t = document.querySelector("#CustomerEmail").value;
                    (document.querySelector("#RecoverEmail").value = t), document.querySelector("#RecoverPasswordForm").classList.toggle("display-none"), document.querySelector("#CustomerLoginForm").classList.toggle("display-none");
                }
                function o() {
                    document.querySelector(".reset-password-success") && document.querySelector("#ResetSuccess").classList.remove("display-none");
                }
                i(), o(), document.querySelector(t.recoverPasswordForm).addEventListener("click", e), document.querySelector(t.hideRecoverPasswordLink).addEventListener("click", e);
            })(),
        (window.Shopify = window.Shopify || {}),
        (window.Shopify.theme = window.Shopify.theme || {}),
        (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
        (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
        (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    const Ti = window.Shopify.theme.sections.registered,
        Ai = window.Shopify.theme.sections.instances,
        qi = "data-section-id",
        Ci = "data-section-type";
    let xi = class {
        callFunctions(t, e = null) {
            this.callStack[t].forEach((t) => {
                const i = { id: this.id, type: this.type, container: this.container };
                e ? t.call(i, e) : t.call(i);
            });
        }
        onLoad() {
            this.callFunctions("onLoad");
        }
        onUnload() {
            this.callFunctions("onUnload");
        }
        onSelect(t) {
            this.callFunctions("onSelect", t);
        }
        onDeselect(t) {
            this.callFunctions("onDeselect", t);
        }
        onBlockSelect(t) {
            this.callFunctions("onBlockSelect", t);
        }
        onBlockDeselect(t) {
            this.callFunctions("onBlockDeselect", t);
        }
        onReorder(t) {
            this.callFunctions("onReorder", t);
        }
        constructor(t, e) {
            (this.container = (function (t) {
                if (!(t instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                if (null === t.getAttribute(qi)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + qi + " attribute.");
                return t;
            })(t)),
                (this.id = t.getAttribute(qi)),
                (this.type = e.type),
                (this.callStack = e.getStack());
            try {
                this.onLoad();
            } catch (t) {
                console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(t);
            }
        }
    };
    function Pi(t, e) {
        if ("string" != typeof t) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== Ti[t]) throw new Error('Theme Sections: A section of type "' + t + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(e) || (e = [e]);
        const i = new (class {
            getStack() {
                return this.callStack;
            }
            constructor(t = null, e = []) {
                (this.type = t),
                    (this.components = (function (t) {
                        if ((void 0 !== t && "object" != typeof t) || null === t) throw new TypeError("Theme Sections: The components object provided is not a valid");
                        return t;
                    })(e)),
                    (this.callStack = { onLoad: [], onUnload: [], onSelect: [], onDeselect: [], onBlockSelect: [], onBlockDeselect: [], onReorder: [] }),
                    e.forEach((t) => {
                        for (const [e, i] of Object.entries(t)) {
                            const t = this.callStack[e];
                            Array.isArray(t) && "function" == typeof i ? t.push(i) : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`), console.warn(i));
                        }
                    });
            }
        })(t, e);
        return (Ti[t] = i), Ti;
    }
    function $i(t, e) {
        (t = _i(t)),
            void 0 === e && (e = document.querySelectorAll("[" + Ci + "]")),
            (e = Ii(e)),
            t.forEach(function (t) {
                const i = Ti[t];
                void 0 !== i &&
                    (e = e.filter(function (e) {
                        return !(Mi(e).length > 0) && null !== e.getAttribute(Ci) && (e.getAttribute(Ci) !== t || (Ai.push(new xi(e, i)), !1));
                    }));
            });
    }
    function Mi(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
        if (t instanceof Element || i instanceof Element)
            Ii(t).forEach(function (t) {
                e = e.concat(
                    Ai.filter(function (e) {
                        return e.container === t;
                    })
                );
            });
        else if ("string" == typeof t || "string" == typeof i) {
            _i(t).forEach(function (t) {
                e = e.concat(
                    Ai.filter(function (e) {
                        return e.type === t;
                    })
                );
            });
        }
        return e;
    }
    function Hi(t) {
        for (var e, i = 0; i < Ai.length; i++)
            if (Ai[i].id === t) {
                e = Ai[i];
                break;
            }
        return e;
    }
    function _i(t) {
        return (
            "*" === t
                ? (t = Object.keys(Ti))
                : "string" == typeof t
                ? (t = [t])
                : t.constructor === xi
                ? (t = [t.prototype.type])
                : Array.isArray(t) &&
                  t[0].constructor === xi &&
                  (t = t.map(function (t) {
                      return t.type;
                  })),
            (t = t.map(function (t) {
                return t.toLowerCase();
            }))
        );
    }
    function Ii(t) {
        return (
            NodeList.prototype.isPrototypeOf(t) && t.length > 0
                ? (t = Array.prototype.slice.call(t))
                : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
                ? (t = [])
                : !Array.isArray(t) && t instanceof Element && (t = [t]),
            t
        );
    }
    window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + qi + '="' + e + '"]');
            null !== i && $i(i.getAttribute(Ci), i);
        }),
        document.addEventListener("shopify:section:reorder", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + qi + '="' + e + '"]');
            "object" == typeof Mi(i)[0] &&
                Mi(i).forEach(function (t) {
                    t.onReorder();
                });
        }),
        document.addEventListener("shopify:section:unload", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + qi + '="' + e + '"]');
            "object" == typeof Mi(i)[0] &&
                Mi(i).forEach(function (t) {
                    var e = Ai.map(function (t) {
                        return t.id;
                    }).indexOf(t.id);
                    Ai.splice(e, 1), t.onUnload();
                });
        }),
        document.addEventListener("shopify:section:select", function (t) {
            var e = Hi(t.detail.sectionId);
            "object" == typeof e && e.onSelect(t);
        }),
        document.addEventListener("shopify:section:deselect", function (t) {
            var e = Hi(t.detail.sectionId);
            "object" == typeof e && e.onDeselect(t);
        }),
        document.addEventListener("shopify:block:select", function (t) {
            var e = Hi(t.detail.sectionId);
            "object" == typeof e && e.onBlockSelect(t);
        }),
        document.addEventListener("shopify:block:deselect", function (t) {
            var e = Hi(t.detail.sectionId);
            "object" == typeof e && e.onBlockDeselect(t);
        }));
    const Di = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])';
    function Bi(t) {
        const e = `data-popup-${t}`;
        r.init({
            openTrigger: e,
            disableScroll: !0,
            onShow: (t, e, i) => {
                i.preventDefault();
                const s = t.querySelector(Di);
                ke(t, { elementToFocus: s });
            },
            onClose: (t, e, i) => {
                i.preventDefault(), Te(), e.focus();
            },
        });
    }
    const Wi = "[data-toggle-password-modal]",
        Fi = ".storefront-password-form .errors",
        Oi = {};
    Pi("password", {
        onLoad() {
            Oi[this.id] = new (class {
                init() {
                    Bi("password"), this.errors && this.trigger.click();
                }
                constructor(t) {
                    (this.container = t.container), (this.trigger = this.container.querySelector(Wi)), (this.errors = this.container.querySelector(Fi)), this.init();
                }
            })(this);
        },
    }),
        (function () {
            var t = "#QrCode",
                e = ".giftcard__code";
            const i = document.querySelector(t);
            if (i) {
                function o() {
                    const t = i.getAttribute("data-identifier");
                    new QRCode(i, { text: t, width: 120, height: 120 });
                }
                window.addEventListener("load", o);
            }
            const s = document.querySelector(e);
            if (s) {
                function r() {
                    var t = document.querySelector("#GiftCardDigits"),
                        e = "";
                    if (document.body.createTextRange) (e = document.body.createTextRange()).moveToElementText(t), e.select();
                    else if (window.getSelection) {
                        var i = window.getSelection();
                        (e = document.createRange()).selectNodeContents(t), i.removeAllRanges(), i.addRange(e);
                    }
                }
                s.addEventListener("click", r());
            }
        })();
    const Ni = "[data-parallax-wrapper]",
        zi = "[data-parallax-img]";
    let Ri = {};
    const Vi = {
        onLoad() {
            Ri[this.id] = [];
            this.container.querySelectorAll(Ni).forEach((t) => {
                const e = t.querySelector(zi);
                Ri[this.id].push(new a(e, { center: !0, round: !0, frame: t }));
            });
        },
        onUnload: function () {
            Ri[this.id].forEach((t) => {
                "function" == typeof t.destroy && t.destroy();
            });
        },
    };
    Pi("article", Vi);
    const ji = "[data-ticker-frame]",
        Ui = "[data-ticker-scale]",
        Ji = "[data-ticker-text]",
        Ki = "data-clone",
        Yi = "ticker--animated",
        Qi = "ticker--unloaded",
        Gi = "ticker__comparitor",
        Xi = 1.63,
        Zi = 100,
        ts = {};
    let es = class {
        unload() {
            document.removeEventListener("theme:resize", this.resizeEvent);
        }
        listen() {
            document.addEventListener("theme:resize", this.resizeEvent), this.checkWidth();
        }
        checkWidth() {
            const t = 2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", "");
            if (this.frame.clientWidth - t < this.comparitor.clientWidth || this.stopClone) {
                if (
                    (this.text.classList.add(Yi),
                    1 === this.scale.childElementCount && ((this.clone = this.text.cloneNode(!0)), this.clone.setAttribute("aria-hidden", !0), this.clone.setAttribute(Ki, ""), this.scale.appendChild(this.clone), this.stopClone))
                )
                    for (let t = 0; t < 10; t++) {
                        const t = this.text.cloneNode(!0);
                        t.setAttribute("aria-hidden", !0), t.setAttribute(Ki, ""), this.scale.appendChild(t);
                    }
                const t = (this.text.clientWidth / Zi) * Xi;
                this.scale.style.setProperty("--animation-time", `${t}s`);
            } else {
                this.text.classList.add(Yi);
                let t = this.scale.querySelector(`[${Ki}]`);
                t && this.scale.removeChild(t), this.text.classList.remove(Yi);
            }
        }
        constructor(t, e = !1) {
            (this.frame = t),
                (this.stopClone = e),
                (this.scale = this.frame.querySelector(Ui)),
                (this.text = this.frame.querySelector(Ji)),
                (this.comparitor = this.text.cloneNode(!0)),
                this.comparitor.classList.add(Gi),
                this.frame.appendChild(this.comparitor),
                this.scale.classList.remove(Qi),
                (this.resizeEvent = k(() => this.checkWidth(), 300)),
                this.listen();
        }
    };
    const is = {
            onLoad() {
                ts[this.id] = [];
                this.container.querySelectorAll(ji).forEach((t) => {
                    ts[this.id].push(new es(t));
                });
            },
            onUnload() {
                ts[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        ss = "data-slider-speed",
        os = "data-slide",
        rs = "data-slide-index";
    const ns = "[data-cart-message]",
        as = "data-cart-message",
        ls = "[data-left-to-spend]",
        cs = "[data-cart-progress]",
        hs = "data-limit",
        ds = "data-percent",
        us = "is-success";
    let ps = class {
        init() {
            (this.cartFreeLimitShipping = 100 * Number(this.cartMessage[0].getAttribute(hs)) * this.rate),
                (this.shippingAmount = 0),
                (this.circumference = 28 * Math.PI),
                this.exchangeRateConversions(this.cartFreeLimitShipping, this.shippingAmount),
                this.cartBarProgress(),
                this.listen();
        }
        listen() {
            document.addEventListener(
                "theme:cart:change",
                function (t) {
                    (this.cart = t.detail.cart), this.render();
                }.bind(this)
            );
        }
        render() {
            const t = this.cart.total_price;
            this.freeShippingMessageHandle(t), this.cart && this.cart.total_price && this.cartMessage.length > 0 && ((this.shippingAmount = t), this.updateProgress());
        }
        freeShippingMessageHandle(t) {
            this.cartMessage.length > 0 &&
                this.container.querySelectorAll(ns).forEach((e) => {
                    const i = e.hasAttribute(as) && "true" === e.getAttribute(as) && t >= this.cartFreeLimitShipping && 0 !== t;
                    e.classList.toggle(us, i);
                });
        }
        cartBarProgress(t = null) {
            this.container.querySelectorAll(cs).forEach((e) => {
                this.setProgress(e, null === t ? e.getAttribute(ds) : t);
            });
        }
        setProgress(t, e) {
            const i = this.circumference - ((e / 100) * this.circumference) / 2;
            t.style.strokeDashoffset = i;
        }
        updateProgress() {
            const t = (this.shippingAmount / this.cartFreeLimitShipping) * 100;
            this.exchangeRateConversions(this.cartFreeLimitShipping, this.shippingAmount), this.cartBarProgress(t > 100 ? 100 : t);
        }
        exchangeRateConversions(t, e) {
            const i = theme.settings.currency_code_enable ? l.formatMoney(t - e, theme.moneyFormat) + ` ${theme.currencyCode}` : l.formatMoney(t - e, theme.moneyFormat);
            this.container.querySelectorAll(ls).forEach((t) => {
                t.innerHTML = i.replace(".00", "");
            });
        }
        constructor(t) {
            (this.container = t), (this.cartMessage = this.container.querySelectorAll(ns)), (this.rate = window.Shopify.currency.rate), this.cartMessage.length > 0 && this.init();
        }
    };
    const ms = "[data-bar]",
        ys = "[data-slide]",
        gs = "[data-ticker-frame]",
        fs = "[data-announcement-slider]",
        ws = "data-slide",
        vs = "[data-ticker-scale]",
        bs = "[data-ticker-text]",
        Ss = "data-target-referrer",
        Es = "data-slide",
        Ls = "mobile",
        ks = "desktop",
        Ts = "ticker--animated",
        As = {};
    Pi("announcement", {
        onLoad() {
            (As[this.id] = []),
                As[this.id].push(
                    new (class {
                        init() {
                            this.removeAnnouncement(), this.slider ? (this.slider && this.slides && this.slides.length > 1 ? this.initSliders() : this.initTickers()) : this.initTickers(!0);
                        }
                        removeAnnouncement() {
                            for (let t = 0; t < this.slides.length; t++) {
                                const e = this.slides[t];
                                e.hasAttribute(Ss) && (-1 !== this.locationPath.indexOf(e.getAttribute(Ss)) || window.Shopify.designMode || e.parentNode.removeChild(e));
                            }
                        }
                        initSliders() {
                            (this.slider = new (class {
                                init() {
                                    const t = {
                                        initialIndex: 0,
                                        autoPlay: this.speed,
                                        contain: !0,
                                        pageDots: !1,
                                        adaptiveHeight: !0,
                                        wrapAround: !0,
                                        groupCells: !1,
                                        cellAlign: "left",
                                        freeScroll: !1,
                                        prevNextButtons: !1,
                                        draggable: !0,
                                        rightToLeft: window.isRTL,
                                        on: {
                                            ready: () => {
                                                setTimeout(() => {
                                                    this.slideshow.dispatchEvent(new CustomEvent("theme:announcement:loaded", { bubbles: !0, detail: { slider: this } }));
                                                }, 50);
                                            },
                                        },
                                    };
                                    (this.flkty = new s(this.slideshow, t)), this.flkty && (document.addEventListener("theme:resize", this.resizeEvent), document.addEventListener("theme:scroll", this.scrollEvent));
                                }
                                resizeEvents() {
                                    this.flkty.resize();
                                }
                                scrollEvents() {
                                    if (this.flkty && this.speed) {
                                        const t = this.flkty.element,
                                            e = t.getBoundingClientRect().top + window.scrollY + t.offsetHeight;
                                        window.pageYOffset > e ? "playing" === this.flkty.player.state && this.flkty.pausePlayer() : "paused" === this.flkty.player.state && this.flkty.playPlayer();
                                    }
                                }
                                onUnload() {
                                    this.slideshow &&
                                        this.flkty &&
                                        (document.removeEventListener("theme:resize", this.resizeEvent), document.removeEventListener("theme:scroll", this.scrollEvent), (this.flkty.options.watchCSS = !1), this.flkty.destroy());
                                }
                                onBlockSelect(t) {
                                    if (!this.slideshow) return;
                                    const e = this.slideshow.querySelector(`[${os}="${t.detail.blockId}"]`);
                                    if (!e) return;
                                    const i = parseInt(e.getAttribute(rs));
                                    this.flkty.selectCell(i), this.flkty.stopPlayer();
                                }
                                onBlockDeselect() {
                                    this.flkty.playPlayer();
                                }
                                constructor(t, e) {
                                    (this.container = t), (this.slideshow = e);
                                    const i = this.slideshow.getAttribute(ss);
                                    (this.speed = !!i && parseInt(i)), (this.scrollEvent = () => this.scrollEvents()), (this.resizeEvent = () => this.resizeEvents()), this.slideshow && ((this.flkty = null), this.init());
                                }
                            })(this.container, this.slider)),
                                this.slider.flkty.reposition(),
                                this.barHolder.addEventListener("theme:announcement:loaded", () => {
                                    this.initTickers();
                                });
                        }
                        initTickers(t = !1) {
                            const e = this.barHolder.querySelector(gs);
                            e && new es(e, t);
                        }
                        toggleTicker(t, e) {
                            const i = document.querySelector(vs),
                                s = document.querySelector(`[${ws}="${t.detail.blockId}"]`);
                            e &&
                                s &&
                                (i.setAttribute("data-stop", ""),
                                i.querySelectorAll(bs).forEach((t) => {
                                    t.classList.remove(Ts), (t.style.transform = `translate3d(${-(s.offsetLeft - s.clientWidth)}px, 0, 0)`);
                                })),
                                !e &&
                                    s &&
                                    (i.querySelectorAll(bs).forEach((t) => {
                                        t.classList.add(Ts), t.removeAttribute("style");
                                    }),
                                    i.removeAttribute("data-stop"));
                        }
                        onBlockSelect(t) {
                            this.slider && "function" == typeof this.slider.onBlockSelect
                                ? this.slider.onBlockSelect(t)
                                : (document.querySelectorAll(`[${Es}="${t.detail.blockId}"]`).forEach((t) => {
                                      t.classList.contains(Ls) && (this.hasDeviceClass = Ls), t.classList.contains(ks) && (this.hasDeviceClass = ks), "" !== this.hasDeviceClass && t.classList.remove(this.hasDeviceClass);
                                  }),
                                  this.toggleTicker(t, !0));
                        }
                        onBlockDeselect(t) {
                            this.slider && "function" == typeof this.slider.onBlockDeselect
                                ? this.slider.onBlockDeselect(t)
                                : ("" !== this.hasDeviceClass &&
                                      document.querySelectorAll(`[${Es}="${t.detail.blockId}"]`).forEach((t) => {
                                          t.classList.add(this.hasDeviceClass);
                                      }),
                                  this.toggleTicker(t, !1));
                        }
                        onUnload() {
                            this.slider && "function" == typeof this.slider.onUnload && this.slider.onUnload();
                        }
                        constructor(t) {
                            (this.container = t.container),
                                (this.barHolder = this.container.querySelector(ms)),
                                (this.locationPath = location.href),
                                (this.slides = this.barHolder.querySelectorAll(ys)),
                                (this.slider = this.barHolder.querySelector(fs)),
                                (this.hasDeviceClass = ""),
                                new ps(this.container),
                                this.init();
                        }
                    })(this)
                );
        },
        onUnload() {
            As[this.id].forEach((t) => {
                "function" == typeof t.onUnload && t.onUnload();
            });
        },
        onBlockSelect(t) {
            As[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
            });
        },
        onBlockDeselect(t) {
            As[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockDeselect(t);
            });
        },
    });
    const qs = "[data-ticker-frame]",
        Cs = "data-slide",
        xs = "[data-ticker-scale]",
        Ps = "[data-ticker-text]",
        $s = "ticker--animated",
        Ms = {};
    Pi("logos", {
        onLoad() {
            (Ms[this.id] = []),
                Ms[this.id].push(
                    new (class {
                        init() {
                            this.initTickers(!0);
                        }
                        initTickers(t = !1) {
                            const e = this.container.querySelector(qs);
                            e && new es(e, t);
                        }
                        toggleTicker(t, e) {
                            const i = this.container.querySelector(xs),
                                s = this.container.querySelector(`[${Cs}="${t.detail.blockId}"]`);
                            e &&
                                s &&
                                i &&
                                (i.setAttribute("data-stop", ""),
                                i.querySelectorAll(Ps).forEach((t) => {
                                    t.classList.remove($s), (t.style.transform = `translate3d(${-(s.offsetLeft - s.clientWidth)}px, 0, 0)`);
                                })),
                                !e &&
                                    s &&
                                    i &&
                                    (i.querySelectorAll(Ps).forEach((t) => {
                                        t.classList.add($s), t.removeAttribute("style");
                                    }),
                                    i.removeAttribute("data-stop"));
                        }
                        onBlockSelect(t) {
                            this.toggleTicker(t, !0);
                        }
                        onBlockDeselect(t) {
                            this.toggleTicker(t, !1);
                        }
                        constructor(t) {
                            (this.container = t.container), this.init();
                        }
                    })(this)
                );
        },
        onBlockSelect(t) {
            Ms[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
            });
        },
        onBlockDeselect(t) {
            Ms[this.id].forEach((e) => {
                "function" == typeof e.onBlockSelect && e.onBlockDeselect(t);
            });
        },
    }),
        Pi("blog", Vi);
    var Hs = "[data-drawer]",
        _s = "[data-drawer-scrolls]",
        Is = "[data-drawer-underlay]",
        Ds = "[data-stagger-animation]",
        Bs = "data-drawer-toggle",
        Ws = ":scope > * > [data-animates]",
        Fs = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        Os = "drawer--visible",
        Ns = "display-none",
        zs = {};
    const Rs = {
            onLoad() {
                zs[this.id] = [];
                this.container.querySelectorAll(Hs).forEach((t) => {
                    zs[this.id].push(
                        new (class {
                            unload() {}
                            connectToggle() {
                                this.buttons.forEach((t) => {
                                    t.addEventListener(
                                        "click",
                                        function (t) {
                                            t.preventDefault(), this.drawer.dispatchEvent(new CustomEvent("theme:drawer:toggle", { bubbles: !1 }));
                                        }.bind(this)
                                    );
                                });
                            }
                            connectDrawer() {
                                this.drawer.addEventListener(
                                    "theme:drawer:toggle",
                                    function () {
                                        this.drawer.classList.contains(Os)
                                            ? this.drawer.dispatchEvent(new CustomEvent("theme:drawer:close", { bubbles: !1 }))
                                            : this.drawer.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: !1 }));
                                    }.bind(this)
                                ),
                                    this.drawer.addEventListener("theme:drawer:close", this.hideDrawer.bind(this)),
                                    this.drawer.addEventListener("theme:drawer:open", this.showDrawer.bind(this));
                            }
                            staggerChildAnimations() {
                                this.staggers.forEach((t) => {
                                    t.querySelectorAll(Ws).forEach((t, e) => {
                                        t.style.transitionDelay = 50 * e + 10 + "ms";
                                    });
                                });
                            }
                            closers() {
                                this.drawer.addEventListener(
                                    "keyup",
                                    function (t) {
                                        t.which === window.theme.keyboardKeys.ESCAPE && (this.hideDrawer(), this.buttons[0].focus());
                                    }.bind(this)
                                ),
                                    this.underlay.addEventListener(
                                        "click",
                                        function () {
                                            this.hideDrawer();
                                        }.bind(this)
                                    );
                            }
                            showDrawer() {
                                this.drawer.classList.remove(Ns),
                                    setTimeout(() => {
                                        this.buttons.forEach((t) => t.setAttribute("aria-expanded", !0)),
                                            this.drawer.classList.add(Os),
                                            document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.drawerScrolls }));
                                        const t = this.drawer.querySelector(Fs);
                                        ke(this.drawer, { elementToFocus: t });
                                    }, 1);
                            }
                            hideDrawer() {
                                this.buttons.forEach((t) => t.setAttribute("aria-expanded", !0)),
                                    this.drawer.classList.remove(Os),
                                    this.drawerScrolls.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                                    document.dispatchEvent(new CustomEvent("theme:sliderule:close", { bubbles: !1 })),
                                    Te(),
                                    setTimeout(() => {
                                        this.drawer.classList.contains(Os) || this.drawer.classList.add(Ns);
                                    }, 800);
                            }
                            constructor(t) {
                                (this.drawer = t), (this.drawerScrolls = this.drawer.querySelector(_s)), (this.underlay = this.drawer.querySelector(Is)), (this.key = this.drawer.dataset.drawer);
                                const e = `[${Bs}='${this.key}']`;
                                (this.buttons = document.querySelectorAll(e)), (this.staggers = this.drawer.querySelectorAll(Ds)), this.connectToggle(), this.connectDrawer(), this.closers(), this.staggerChildAnimations();
                            }
                        })(t)
                    );
                });
            },
            onUnload: function () {
                zs[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        Vs = "#shopify-section-announcement",
        js = "data-header-transparent",
        Us = "[data-header-wrapper] header",
        Js = "js__header__stuck",
        Ks = "js__header__stuck--animated",
        Ys = "js__header__stuck--trigger-animation",
        Qs = "js__header__stuck__backdrop";
    let Gs = {};
    const Xs = {
            onLoad() {
                Gs = new (class {
                    unload() {
                        document.removeEventListener("theme:scroll", this.listen), document.removeEventListener("theme:scroll:up", this.scrollUpDirectional), document.removeEventListener("theme:scroll:down", this.scrollDownDirectional);
                    }
                    listen() {
                        (this.sticks || this.animated) &&
                            document.addEventListener("theme:scroll", (t) => {
                                t.detail.down
                                    ? (!this.currentlyStuck && t.detail.position > this.stickDown && this.stickSimple(), !this.currentlyBlurred && t.detail.position > this.blur && this.addBlur())
                                    : (t.detail.position <= this.stickUp && this.unstickSimple(), t.detail.position <= this.blur && this.removeBlur());
                            }),
                            this.animated && (document.addEventListener("theme:scroll:up", this.scrollUpDirectional.bind(this)), document.addEventListener("theme:scroll:down", this.scrollDownDirectional.bind(this)));
                    }
                    stickSimple() {
                        this.animated && this.cls.add(Ks), this.cls.add(Js), this.wrapper.setAttribute(js, !1), (this.currentlyStuck = !0);
                    }
                    unstickSimple() {
                        this.cls.remove(Js), this.wrapper.setAttribute(js, this.transparent), this.animated && this.cls.remove(Ks), (this.currentlyStuck = !1);
                    }
                    scrollDownInit() {
                        window.scrollY > this.stickDown && this.stickSimple(), window.scrollY > this.blur && this.addBlur();
                    }
                    stickDirectional() {
                        this.cls.add(Ys);
                    }
                    unstickDirectional() {
                        this.cls.remove(Ys);
                    }
                    scrollDownDirectional() {
                        this.unstickDirectional();
                    }
                    scrollUpDirectional() {
                        window.scrollY <= this.stickDown ? this.unstickDirectional() : this.stickDirectional();
                    }
                    addBlur() {
                        this.cls.add(Qs), (this.currentlyBlurred = !0);
                    }
                    removeBlur() {
                        this.cls.remove(Qs), (this.currentlyBlurred = !1);
                    }
                    constructor(t) {
                        (this.wrapper = t),
                            (this.type = this.wrapper.dataset.headerSticky),
                            (this.transparent = this.wrapper.dataset.headerTransparent),
                            (this.sticks = "sticky" === this.type),
                            (this.animated = "directional" === this.type),
                            (this.currentlyStuck = !1),
                            (this.cls = this.wrapper.classList);
                        const e = document.querySelector(Vs),
                            i = e ? e.clientHeight : 0,
                            s = document.querySelector(Us).clientHeight;
                        (this.blur = s + i), (this.stickDown = s + i), (this.stickUp = i), "false" !== this.wrapper.getAttribute(js) && (this.blur = i), this.sticks && ((this.stickDown = i), this.scrollDownInit()), this.listen();
                    }
                })(this.container);
            },
            onUnload: function () {
                "function" == typeof Gs.unload && Gs.unload();
            },
        },
        Zs = "data-hover-disclosure-toggle",
        to = "[data-hover-disclosure]",
        eo = "[data-top-link]",
        io = "[data-header-wrapper]",
        so = "[data-stagger]",
        oo = "[data-stagger-first]",
        ro = "[data-stagger-second]",
        no = "[data-grid-item], [data-header-image]",
        ao = "is-visible",
        lo = "meganav--visible",
        co = "grandparent";
    let ho = {},
        uo = {};
    const po = {
            onLoad() {
                (ho[this.id] = []),
                    (uo = this.container.querySelectorAll(to)),
                    uo.forEach((t) => {
                        ho[this.id].push(
                            new (class {
                                onBlockSelect(t) {
                                    this.disclosure.contains(t.target) && this.showDisclosure();
                                }
                                onBlockDeselect(t) {
                                    this.disclosure.contains(t.target) && this.hideDisclosure();
                                }
                                showDisclosure() {
                                    this.grandparent ? this.wrapper.classList.add(lo) : this.wrapper.classList.remove(lo), this.trigger.setAttribute("aria-expanded", !0), this.trigger.classList.add(ao), this.disclosure.classList.add(ao);
                                }
                                hideDisclosure() {
                                    this.disclosure.classList.remove(ao), this.trigger.classList.remove(ao), this.trigger.setAttribute("aria-expanded", !1), this.wrapper.classList.remove(lo);
                                }
                                staggerChildAnimations() {
                                    this.disclosure.querySelectorAll(so).forEach((t, e) => {
                                        t.style.transitionDelay = 50 * e + 10 + "ms";
                                    }),
                                        this.disclosure.querySelectorAll(oo).forEach((t, e) => {
                                            const i = 150 * e;
                                            (t.style.transitionDelay = `${i}ms`),
                                                t.parentElement.querySelectorAll(ro).forEach((t, e) => {
                                                    const s = 20 * (e + 1);
                                                    t.style.transitionDelay = `${i + s}ms`;
                                                });
                                        }),
                                        this.disclosure.querySelectorAll(no).forEach((t, e) => {
                                            t.style.transitionDelay = 80 * (e + 1) + "ms";
                                        });
                                }
                                handleTablets() {
                                    this.trigger.addEventListener(
                                        "touchstart",
                                        function (t) {
                                            this.disclosure.classList.contains(ao) || (t.preventDefault(), this.showDisclosure());
                                        }.bind(this),
                                        { passive: !0 }
                                    );
                                }
                                connectHoverToggle() {
                                    this.trigger.addEventListener("mouseenter", this.showDisclosure.bind(this)),
                                        this.link.addEventListener("focus", this.showDisclosure.bind(this)),
                                        this.trigger.addEventListener("mouseleave", this.hideDisclosure.bind(this)),
                                        this.trigger.addEventListener(
                                            "focusout",
                                            function (t) {
                                                this.trigger.contains(t.relatedTarget) || this.hideDisclosure();
                                            }.bind(this)
                                        ),
                                        this.disclosure.addEventListener(
                                            "keyup",
                                            function (t) {
                                                t.which === window.theme.keyboardKeys.ESCAPE && this.hideDisclosure();
                                            }.bind(this)
                                        );
                                }
                                constructor(t) {
                                    (this.disclosure = t), (this.wrapper = t.closest(io)), (this.key = this.disclosure.id);
                                    const e = `[${Zs}='${this.key}']`;
                                    (this.trigger = document.querySelector(e)),
                                        (this.link = this.trigger.querySelector(eo)),
                                        (this.grandparent = this.trigger.classList.contains(co)),
                                        this.trigger.setAttribute("aria-haspopup", !0),
                                        this.trigger.setAttribute("aria-expanded", !1),
                                        this.trigger.setAttribute("aria-controls", this.key),
                                        this.connectHoverToggle(),
                                        this.handleTablets(),
                                        this.staggerChildAnimations();
                                }
                            })(t)
                        );
                    });
            },
            onBlockSelect(t) {
                ho[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                ho[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
            onUnload: function () {
                ho[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        mo = "[data-main-menu-text-item]",
        yo = "[data-text-items-wrapper]",
        go = ".navtext",
        fo = "data-menu-active",
        wo = "[data-header-wrapper]",
        vo = "data-underline-current",
        bo = ".menu__item.main-menu--active .navtext, .header__desktop__button.main-menu--active .navtext";
    let So = {},
        Eo = null;
    const Lo = {
            onLoad() {
                So[this.id] = [];
                this.container.querySelectorAll(yo).forEach((t) => {
                    So[this.id].push(
                        new (class {
                            init() {
                                if (this.itemList.length) {
                                    if ((this.listen(), this.listenResize(), (this.textBottom = null), this.setHeight(), Eo)) {
                                        if (this.defaultItem) {
                                            const t = this.defaultItem.offsetLeft || 0;
                                            this.sectionOuter.style.setProperty("--bar-left", `${t}px`);
                                        }
                                        this.reset();
                                    } else {
                                        const t = this.sectionOuter.querySelector(mo).offsetLeft;
                                        this.sectionOuter.style.setProperty("--bar-left", `${t}px`), this.sectionOuter.style.setProperty("--bar-width", "0px");
                                    }
                                    this.sectionOuter.style.setProperty("--bar-opacity", "1");
                                }
                            }
                            unload() {
                                document.removeEventListener("theme:resize", this.reset), (Eo = null);
                            }
                            listenResize() {
                                document.addEventListener("theme:resize", this.reset.bind(this));
                            }
                            setDefault() {
                                this.defaultItem && (Eo = { left: this.defaultItem.offsetLeft || null, width: this.defaultItem.clientWidth || null });
                            }
                            setHeight() {
                                const t = this.wrapper.clientHeight,
                                    e = this.itemList[0].querySelector(go).clientHeight,
                                    i = Math.floor(t / 2 - e / 2) - 4;
                                this.textBottom !== i && (this.sectionOuter.style.setProperty("--bar-text", `${e}px`), this.sectionOuter.style.setProperty("--bar-bottom", `${i}px`), (this.textBottom = i));
                            }
                            listen() {
                                this.itemList.forEach((t) => {
                                    t.addEventListener("mouseenter", (t) => {
                                        const e = t.target.querySelector(go);
                                        this.startBar(e);
                                    });
                                }),
                                    this.wrapper.addEventListener("mouseleave", this.clearBar.bind(this));
                            }
                            startBar(t) {
                                this.setHeight();
                                let e = "false" !== this.sectionOuter.getAttribute(fo),
                                    i = t.offsetLeft,
                                    s = t.clientWidth;
                                e
                                    ? this.render(s, i)
                                    : (this.sectionOuter.setAttribute(fo, !0),
                                      this.render(0, i),
                                      setTimeout(() => {
                                          this.render(s, i);
                                      }, 10));
                            }
                            render(t, e) {
                                this.sectionOuter.style.setProperty("--bar-left", `${e}px`), this.sectionOuter.style.setProperty("--bar-width", `${t}px`);
                            }
                            reset() {
                                this.setDefault(),
                                    Eo && Eo.left && Eo.width
                                        ? (this.sectionOuter.style.setProperty("--bar-left", `${Eo.left}px`), this.sectionOuter.style.setProperty("--bar-width", `${Eo.width}px`))
                                        : this.sectionOuter.style.setProperty("--bar-width", "0px");
                            }
                            clearBar() {
                                this.sectionOuter.setAttribute(fo, !1),
                                    setTimeout(() => {
                                        "false" !== this.sectionOuter.getAttribute(fo) || this.reset();
                                    }, 150);
                            }
                            constructor(t) {
                                (this.wrapper = t),
                                    (this.itemList = this.wrapper.querySelectorAll(mo)),
                                    (this.sectionOuter = document.querySelector(wo)),
                                    (this.underlineCurrent = "true" === this.sectionOuter.getAttribute(vo)),
                                    (this.defaultItem = null),
                                    this.underlineCurrent && (this.defaultItem = this.wrapper.querySelector(bo)),
                                    this.setDefault(),
                                    document.fonts.ready.then(() => {
                                        this.init();
                                    });
                            }
                        })(t)
                    );
                });
            },
            onUnload: function () {
                So[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                }),
                    delete So[this.id];
            },
        },
        ko = "data-header-cart-price",
        To = "data-header-cart-count",
        Ao = "data-header-cart-full";
    const qo = {
            onLoad() {
                new (class {
                    listen() {
                        document.addEventListener(
                            "theme:cart:change",
                            function (t) {
                                (this.cart = t.detail.cart), this.update();
                            }.bind(this)
                        );
                    }
                    update() {
                        this.cart &&
                            (this.prices.forEach((t) => {
                                t.setAttribute(ko, this.cart.total_price);
                                const e = l.formatMoney(this.cart.total_price, theme.moneyFormat);
                                t.innerHTML = e;
                            }),
                            this.counts.forEach((t) => {
                                t.setAttribute(To, this.cart.item_count), (t.innerHTML = `(${this.cart.item_count})`);
                            }),
                            this.dots.forEach((t) => {
                                const e = this.cart.item_count > 0;
                                t.setAttribute(Ao, e);
                            }));
                    }
                    constructor(t) {
                        (this.section = t),
                            (this.counts = this.section.querySelectorAll(`[${To}]`)),
                            (this.prices = this.section.querySelectorAll(`[${ko}]`)),
                            (this.dots = this.section.querySelectorAll(`[${Ao}]`)),
                            (this.cart = null),
                            this.listen();
                    }
                })(this.container);
            },
        },
        Co = "[data-search-popdown-wrap]",
        xo = "data-popdown-toggle",
        Po = "[data-close-popdown]",
        $o = "[data-predictive-search-input]",
        Mo = "[data-search-underlay]",
        Ho = "underlay--visible",
        _o = "is-visible";
    let Io = {};
    const Do = {
            onLoad() {
                Io[this.id] = {};
                const t = this.container.querySelector(`[${xo}]`);
                t &&
                    (Io[this.id] = new (class {
                        initTriggerEvents() {
                            this.trigger.setAttribute("aria-haspopup", !0),
                                this.trigger.setAttribute("aria-expanded", !1),
                                this.trigger.setAttribute("aria-controls", this.key),
                                this.trigger.addEventListener(
                                    "click",
                                    function (t) {
                                        t.preventDefault(), this.showPopdown();
                                    }.bind(this)
                                ),
                                this.trigger.addEventListener(
                                    "keyup",
                                    function (t) {
                                        t.which === window.theme.keyboardKeys.SPACE && this.showPopdown();
                                    }.bind(this)
                                );
                        }
                        initPopdownEvents() {
                            this.popdown.addEventListener(
                                "keyup",
                                function (t) {
                                    t.which === window.theme.keyboardKeys.ESCAPE && this.hidePopdown();
                                }.bind(this)
                            ),
                                this.close.addEventListener(
                                    "click",
                                    function () {
                                        this.hidePopdown();
                                    }.bind(this)
                                ),
                                this.underlay.addEventListener(
                                    "click",
                                    function () {
                                        this.hidePopdown();
                                    }.bind(this)
                                );
                        }
                        hidePopdown() {
                            this.popdown.classList.remove(_o),
                                this.underlay.classList.remove(Ho),
                                this.trigger.focus(),
                                (this.input.value = ""),
                                Te(),
                                this.input.dispatchEvent(new CustomEvent("theme:search:clear", { bubbles: !1 })),
                                this.popdown.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                        }
                        showPopdown() {
                            (this.input.value = ""),
                                this.popdown.classList.add(_o),
                                this.underlay.classList.add(Ho),
                                ke(this.popdown, { elementToFocus: this.input }),
                                this.popdown.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                        }
                        constructor(t) {
                            (this.trigger = t),
                                (this.key = this.trigger.getAttribute(xo)),
                                (this.popdown = document.querySelector(`[id='${this.key}']`)),
                                (this.input = this.popdown.querySelector($o)),
                                (this.close = this.popdown.querySelector(Po)),
                                (this.wrapper = this.popdown.closest(Co)),
                                (this.underlay = this.wrapper.querySelector(Mo)),
                                this.initTriggerEvents(),
                                this.initPopdownEvents();
                        }
                    })(t));
            },
            onUnload: function () {
                "function" == typeof Io[this.id].unload && Io[this.id].unload();
            },
        },
        Bo = "data-grid-item-variant",
        Wo = "data-grid-image";
    let Fo = class extends HTMLElement {
        connectedCallback() {
            this.gridItemVariantLinks.length &&
                this.gridItemVariantLinks.forEach((t) => {
                    t.hasAttribute(Bo) && (this.siblingHoverEvent(t), this.siblingClickEvent(t));
                });
        }
        siblingHoverEvent(t) {
            t.addEventListener("mouseenter", () => {
                if (t.hasAttribute(Bo)) {
                    const e = t.getAttribute(Bo);
                    this.container.querySelectorAll(`product-grid-item-content[${Bo}]`).forEach((t) => {
                        t.getAttribute(Bo) === e &&
                            t.querySelectorAll(`[${Wo}]`).forEach((t) => {
                                t.classList.add("lazyload", "lazypreload");
                            });
                    });
                }
            });
        }
        siblingClickEvent(t) {
            t.addEventListener("click", (e) => {
                e.preventDefault();
                const i = this.container.querySelector(`a[${Bo}][aria-current="true"]`);
                if ((i && i.removeAttribute("aria-current"), t.setAttribute("aria-current", "true"), t.hasAttribute(Bo))) {
                    const e = t.getAttribute(Bo);
                    this.container.querySelectorAll(`product-grid-item-content[${Bo}]`).forEach((t) => {
                        t.getAttribute(Bo) === e ? t.removeAttribute("hidden") : t.setAttribute("hidden", "");
                    });
                }
            });
        }
        constructor() {
            super(), (this.container = this), (this.gridItemVariantLinks = this.container.querySelectorAll(`a[${Bo}]`));
        }
    };
    const Oo = "[data-grid-link]",
        No = "data-grid-images",
        zo = "data-grid-image",
        Ro = "data-grid-image-target",
        Vo = "data-grid-image-current-variant",
        jo = "data-grid-pagination",
        Uo = "data-grid-page",
        Jo = "data-stop-slideshow-mobile",
        Ko = "--width",
        Yo = "is-active",
        Qo = "is-mobile",
        Go = "product-grid-item__pagination",
        Xo = 1500;
    let Zo = class extends HTMLElement {
        static get observedAttributes() {
            return ["hidden"];
        }
        connectedCallback() {
            this.images.length > 1 &&
                (this.createPaging(),
                this.container.addEventListener("theme:swatch:change", (t) => {
                    const e = t.detail.id,
                        i = this.container.querySelector(`[${Ro}="${e}"]`);
                    if (i) {
                        const e = i.getAttribute(zo);
                        (this.pagingProgressCounter = 0), this.changeImage(e), t.detail.stopSlideAnimation && this.stopPaging();
                    }
                })),
                this.images.length > 1 &&
                    (this.mobileStopSlideshow && (this.checkMobile(), document.addEventListener("theme:resize:width", () => this.checkMobile())),
                    this.container.addEventListener("mouseenter", () => {
                        this.container.querySelectorAll(`[${zo}]`).forEach((t) => {
                            t.classList.add("lazyload", "lazypreload");
                        }),
                            (this.pagingProgressPause = this.mobileStopProgress),
                            this.progressPaging();
                    }),
                    this.container.addEventListener("mouseleave", () => {
                        (this.pagingProgressPause = !0), this.changeToCurrentVariantImage(), this.progressPaging();
                    }));
        }
        attributeChangedCallback(t) {
            "hidden" === t && this.changeToCurrentVariantImage();
        }
        checkMobile() {
            const t = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            (this.mobileStopProgress = t < window.theme.sizes.medium), this.container.classList.toggle(Qo, this.mobileStopProgress);
        }
        changeToCurrentVariantImage() {
            const t = this.container.querySelector(`[${Vo}]`);
            if (!t) return;
            const e = t.getAttribute(zo);
            e && ((this.pagingProgressPause = !0), this.changeImage(Number(e)));
        }
        changeImage(t = null) {
            const e = this.container.querySelector(`[${zo}].${Yo}`),
                i = null !== t ? this.images[t] : e.nextSibling ? e.nextSibling : this.images[0];
            if ((e && e.classList.remove(Yo), i)) {
                const t = i.hasAttribute(zo) ? i.getAttribute(zo) : 0;
                i.classList.add(Yo), this.changePaging(t);
            }
        }
        changePaging(t = 0) {
            const e = this.container.querySelector(`[${Uo}].${Yo}`),
                i = this.container.querySelector(`[${Uo}="${t}"]`);
            e && (e.style.setProperty(Ko, "100%"), e.classList.remove(Yo)), i && (i.classList.add(Yo), this.progressPaging());
        }
        progressPaging() {
            const t = this.container.querySelector(`[${Uo}].${Yo}`);
            t &&
                !this.mobileStopProgress &&
                (this.stopPaging(),
                0 === this.pagingProgressCounter && t.style.setProperty(Ko, "0%"),
                (this.interval = setInterval(() => {
                    this.pagingProgressCounter >= 100 && !this.pagingProgressPause
                        ? (this.stopPaging(), (this.pagingProgressCounter = 0), this.changeImage())
                        : this.pagingProgressPause || (this.pagingProgressCounter++, t.style.setProperty(Ko, `${this.pagingProgressCounter}%`));
                }, this.timeout / 100)));
        }
        stopPaging() {
            this.interval && clearInterval(this.interval);
        }
        createPaging() {
            if (this.imagesHolder) {
                let t = "";
                for (let e = 0; e < this.images.length; e++) {
                    let i = "";
                    0 === e && (i = `class="${Yo}"`), (t += `<span ${i} ${Uo}="${e}">${e + 1}</span>`);
                }
                if ("" !== t) {
                    let e = this.container.querySelector(`[${jo}]`);
                    e || ((e = document.createElement("div")), (e.className = Go), e.setAttribute(jo, "")), (e.innerHTML = t), this.imagesHolder.parentElement.prepend(e);
                }
            }
        }
        removePaging() {
            const t = this.container.querySelector(`[${jo}]`);
            t && t.remove();
        }
        constructor() {
            super(),
                (this.container = this),
                (this.mobileStopSlideshow = "true" === this.container.getAttribute(Jo)),
                (this.imagesHolder = this.container.querySelector(`[${No}]`)),
                (this.images = this.container.querySelectorAll(`[${zo}]`)),
                (this.links = this.container.querySelectorAll(Oo)),
                (this.imagesLimit = this.imagesHolder && this.imagesHolder.hasAttribute(No) ? parseInt(this.imagesHolder.getAttribute(No)) : 5),
                (this.timeout = Xo),
                (this.interval = null),
                (this.mobileStopProgress = !1),
                (this.pagingProgressPause = !1),
                (this.pagingProgressCounter = 0),
                (this.siblingsFetchCounter = 0),
                (this.siblingLoadImageIndex = null);
        }
    };
    const tr = "[data-popout]",
        er = "[data-popout-list]",
        ir = "data-popout-list-scroll",
        sr = "data-popout-toggle",
        or = "[data-popout-input]",
        rr = "[data-popout-option]",
        nr = "data-popout-prevent",
        ar = "data-quantity-field",
        lr = "data-value",
        cr = "aria-expanded",
        hr = "aria-current",
        dr = "popout-list--visible",
        ur = "--current";
    let pr = class extends HTMLElement {
        unload() {
            this.popoutOptions.length &&
                this.popoutOptions.forEach((t) => {
                    t.removeEventListener("theme:popout:click", this.popupOptionsClick.bind(this)), t.removeEventListener("click", this._connectOptionsDispatch.bind(this));
                }),
                this.popoutToggle.removeEventListener("click", this.popupToggleClick.bind(this)),
                this.popoutToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this)),
                this.popoutList.removeEventListener("focusout", this.popupListFocusout.bind(this)),
                this.container.removeEventListener("keyup", this.containerKeyup.bind(this)),
                this.outsidePopupToggle && (this.outsidePopupToggle.removeEventListener("click", this.popupToggleClick.bind(this)), this.outsidePopupToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this)));
        }
        popupToggleClick(t) {
            const e = "true" === t.currentTarget.getAttribute(cr);
            t.currentTarget.setAttribute(cr, !e),
                this.popoutList.classList.toggle(dr),
                this.popupListMaxWidth(),
                this.popoutList.hasAttribute(ir) &&
                    setTimeout(() => {
                        this.popoutList.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                    }, 1);
        }
        popupToggleFocusout(t) {
            this.container.contains(t.relatedTarget) || this._hideList();
        }
        popupListFocusout(t) {
            const e = t.currentTarget.contains(t.relatedTarget);
            this.popoutList.classList.contains(dr) && !e && this._hideList();
        }
        popupListMaxWidth() {
            this.popoutList.style.maxWidth = `${parseInt(document.body.clientWidth - this.popoutList.getBoundingClientRect().left)}px`;
        }
        popupOptionsClick(t) {
            if ("#" === t.target.closest(rr).attributes.href.value) {
                t.preventDefault();
                let e = "";
                if ((t.currentTarget.getAttribute(lr) && (e = t.currentTarget.getAttribute(lr)), (this.popoutInput.value = e), this.popoutPrevent)) {
                    this.popoutInput.dispatchEvent(new Event("change")), !t.detail.preventTrigger && this.popoutInput.hasAttribute(ar) && this.popoutInput.dispatchEvent(new Event("input"));
                    const i = this.popoutList.querySelector(`[class*="${ur}"]`);
                    let s = ur;
                    if (i && i.classList.length)
                        for (const t of i.classList)
                            if (t.includes(ur)) {
                                s = t;
                                break;
                            }
                    const o = this.popoutList.querySelector(`.${s}`);
                    o && (o.classList.remove(`${s}`), t.currentTarget.parentElement.classList.add(`${s}`));
                    const r = this.popoutList.querySelector(`[${hr}]`);
                    r && r.hasAttribute(`${hr}`) && (r.removeAttribute(`${hr}`), t.currentTarget.setAttribute(`${hr}`, "true")),
                        "" !== e && ((this.popoutToggle.textContent = e), this.outsidePopupToggle && (this.outsidePopupToggle.textContent = e)),
                        this.popupToggleFocusout(t),
                        this.popupListFocusout(t);
                } else this._submitForm(e);
            }
        }
        updatePopout(t) {
            const e = this.popoutList.querySelector(`[${lr}="${this.popoutInput.value}"]`);
            e && e.dispatchEvent(new CustomEvent("theme:popout:click", { cancelable: !0, bubbles: !0, detail: { preventTrigger: !0 } }));
        }
        containerKeyup(t) {
            t.which === window.theme.keyboardKeys.ESCAPE && (this._hideList(), this.popoutToggle.focus());
        }
        bodyClick(t) {
            const e = this.container.contains(t.target),
                i = this.popoutList.classList.contains(dr);
            this.outsidePopupToggle, t.target, i && !e && this._hideList();
        }
        _connectToggle() {
            this.popoutToggle.addEventListener("click", this.popupToggleClick.bind(this)), this.outsidePopupToggle && this.outsidePopupToggle.addEventListener("click", this.popupToggleClick.bind(this));
        }
        _connectOptions() {
            this.popoutOptions.length &&
                this.popoutOptions.forEach((t) => {
                    t.addEventListener("theme:popout:click", this.popupOptionsClick.bind(this)), t.addEventListener("click", this._connectOptionsDispatch.bind(this));
                });
        }
        _connectOptionsDispatch(t) {
            const e = new CustomEvent("theme:popout:click", { cancelable: !0, bubbles: !0, detail: { preventTrigger: !1 } });
            t.target.dispatchEvent(e) || t.preventDefault();
        }
        _onFocusOut() {
            this.popoutToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this)),
                this.outsidePopupToggle && this.outsidePopupToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this)),
                this.popoutList.addEventListener("focusout", this.popupListFocusout.bind(this)),
                this.container.addEventListener("keyup", this.containerKeyup.bind(this)),
                document.body.addEventListener("click", this.bodyClick.bind(this));
        }
        _submitForm(t) {
            const e = this.container.closest("form");
            e && e.submit();
        }
        _hideList() {
            this.popoutList.classList.remove(dr), this.popoutToggle.setAttribute(cr, !1), this.outsidePopupToggle && this.outsidePopupToggle.setAttribute(cr, !1);
        }
        constructor() {
            super(),
                (this.container = this.querySelector(tr)),
                (this.popoutList = this.container.querySelector(er)),
                (this.popoutToggle = this.container.querySelector(`[${sr}]`)),
                (this.outsidePopupToggle = document.querySelector(`[${sr}="${this.popoutList.id}"]`)),
                (this.popoutInput = this.container.querySelector(or)),
                (this.popoutOptions = this.container.querySelectorAll(rr)),
                (this.popoutPrevent = "true" === this.container.getAttribute(nr)),
                this._connectOptions(),
                this._connectToggle(),
                this._onFocusOut(),
                this.popupListMaxWidth(),
                this.popoutInput && this.popoutInput.hasAttribute(ar) && document.addEventListener("theme:popout:update", this.updatePopout.bind(this)),
                document.addEventListener("theme:resize", () => {
                    this.popupListMaxWidth();
                });
        }
    };
    const mr = "[data-cart-note]";
    class yr {
        initInputs() {
            this.inputs.forEach((t) => {
                t.addEventListener(
                    "change",
                    function (t) {
                        const e = t.target.value.toString() || "";
                        this.saveNotes(e);
                    }.bind(this)
                );
            });
        }
        saveNotes(t) {
            window.fetch(`${window.theme.routes.cart}/update.js`, { method: "post", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ note: t }) }).catch((t) => {
                console.error(t);
            });
        }
        constructor(t) {
            (this.inputs = t.querySelectorAll(mr)), this.initInputs();
        }
    }
    const gr = (t, e = [], i = !1) => {
            const s = Object.keys(t)
                .map((s) => {
                    let o = t[s];
                    if ("[object Object]" === Object.prototype.toString.call(o) || Array.isArray(o)) return Array.isArray(t) ? e.push("") : e.push(s), gr(o, e, Array.isArray(o));
                    {
                        let t = s;
                        if (e.length > 0) {
                            t = (i ? e : [...e, s]).reduce((t, e) => ("" === t ? e : `${t}[${e}]`), "");
                        }
                        return i ? `${t}[]=${o}` : `${t}=${o}`;
                    }
                })
                .join("&");
            return e.pop(), s;
        },
        fr = "html",
        wr = "[data-submit-shipping]",
        vr = "[data-shipping-estimate-form]",
        br = "[data-response-template]",
        Sr = "#estimate_address_country",
        Er = "#estimate_address_province",
        Lr = "#estimate_address_zip",
        kr = "[data-response-wrapper]",
        Tr = "lang",
        Ar = "data-default",
        qr = "shipping--success",
        Cr = "errors",
        xr = "disabled";
    class Pr {
        enableButtons() {
            this.button.removeAttribute("disabled"), this.button.classList.remove(xr);
        }
        disableButtons() {
            this.button.setAttribute("disabled", "disabled"), this.button.classList.add(xr);
        }
        render(t) {
            if (this.template && this.ratesWrapper) {
                const e = u.render(this.template, t);
                this.ratesWrapper.innerHTML = e;
            }
            this.enableButtons(), this.ratesWrapper.style.removeProperty("display");
        }
        estimate(t) {
            const e = encodeURI(gr({ shipping_address: t })),
                i = `${window.theme.routes.cart}/shipping_rates.json?${e}`,
                s = this;
            n.get(i)
                .then(function (t) {
                    const e = s.sanitize(t);
                    s.render(e), s.enableButtons(), s.ratesWrapper.style.removeProperty("display");
                })
                .catch(function (t) {
                    const e = s.sanitizeErrors(t);
                    s.render(e);
                });
        }
        sanitize(t) {
            const e = {};
            if (((e.class = qr), (e.items = []), t.data.shipping_rates && t.data.shipping_rates.length > 0)) {
                t.data.shipping_rates.forEach((t) => {
                    let i = {};
                    (i.title = t.presentment_name), (i.value = l.formatMoney(t.price, theme.moneyFormat)), e.items.push(i);
                });
            } else e.items[0] = { value: theme.strings.noShippingAvailable };
            return e;
        }
        sanitizeErrors(t) {
            const e = {};
            if (((e.class = Cr), (e.items = []), "object" == typeof t.data))
                for (const [i, s] of Object.entries(t.data)) {
                    let t = {};
                    (t.title = i.toString()), (t.value = s.toString()), e.items.push(t);
                }
            else e.items[0] = { value: theme.strings.noShippingAvailable };
            return e;
        }
        init() {
            const t = document.querySelector(fr);
            let e = "en";
            t.hasAttribute(Tr) && "" !== t.getAttribute(Tr) && (e = t.getAttribute(Tr)),
                this.form && c.AddressForm(this.form, e, { shippingCountriesOnly: !0 }),
                this.country &&
                    this.country.hasAttribute(Ar) &&
                    this.province &&
                    this.province.hasAttribute(Ar) &&
                    this.country.addEventListener("change", function () {
                        this.country.removeAttribute(Ar), this.province.removeAttribute(Ar);
                    }),
                this.button &&
                    this.button.addEventListener(
                        "click",
                        function (t) {
                            for (t.preventDefault(), this.disableButtons(); this.ratesWrapper.firstChild; ) this.ratesWrapper.removeChild(this.ratesWrapper.firstChild);
                            this.ratesWrapper.style.display = "none";
                            const e = {};
                            let i = this.country.value,
                                s = this.province.value;
                            const o = this.country.getAttribute(Ar);
                            "" === i && o && "" !== o && (i = o);
                            const r = this.province.getAttribute(Ar);
                            "" === s && r && "" !== r && (s = r), (e.zip = this.zip.value || ""), (e.country = i || ""), (e.province = s || ""), this.estimate(e);
                        }.bind(this)
                    );
        }
        constructor(t) {
            (this.button = t.container.querySelector(wr)),
                (this.template = t.container.querySelector(br).innerHTML),
                (this.ratesWrapper = t.container.querySelector(kr)),
                (this.form = t.container.querySelector(vr)),
                (this.country = t.container.querySelector(Sr)),
                (this.province = t.container.querySelector(Er)),
                (this.zip = t.container.querySelector(Lr)),
                this.init();
        }
    }
    const $r = "[data-quantity-selector]",
        Mr = "[data-increase-quantity]",
        Hr = "[data-decrease-quantity]",
        _r = "[data-quantity-input]";
    function Ir(t) {
        t.querySelectorAll($r).forEach((t) => {
            new (class {
                initButtons() {
                    this.increase.addEventListener(
                        "click",
                        function (t) {
                            t.preventDefault();
                            let e = parseInt(this.input.value, 10);
                            (e = isNaN(e) ? 0 : e), e++, (this.input.value = e), this.input.dispatchEvent(new Event("change"));
                        }.bind(this)
                    ),
                        this.decrease.addEventListener(
                            "click",
                            function (t) {
                                t.preventDefault();
                                let e = parseInt(this.input.value, 10);
                                (e = isNaN(e) ? 0 : e), e--, (e = Math.max(this.min, e)), (this.input.value = e), this.input.dispatchEvent(new Event("change"));
                            }.bind(this)
                        );
                }
                constructor(t) {
                    (this.wrapper = t),
                        (this.increase = this.wrapper.querySelector(Mr)),
                        (this.decrease = this.wrapper.querySelector(Hr)),
                        (this.input = this.wrapper.querySelector(_r)),
                        (this.min = parseInt(this.input.getAttribute("min"), 10)),
                        this.initButtons();
                }
            })(t);
        });
    }
    const Dr = '[data-drawer="drawer-cart"]',
        Br = "[data-shipping-estimate-form]",
        Wr = "[data-cart-loading]",
        Fr = "[data-cart-form]",
        Or = "[data-cart-empty]",
        Nr = "[data-cart-progress]",
        zr = "[data-line-items]",
        Rr = "[data-cart-subtotal]",
        Vr = "[data-cart-bottom]",
        jr = "[data-form-errors]",
        Ur = "[data-cart-item]",
        Jr = "[data-cart-final]",
        Kr = "data-update-cart",
        Yr = "data-remove-key",
        Qr = "[data-cart-page-upsell-wrapper]",
        Gr = '[data-section-type="cart"]',
        Xr = "[data-cart-bar]",
        Zr = "[data-cart-message]",
        tn = "[data-item-loadbar]",
        en = "[data-cart-message-container]",
        sn = "[data-api-content]",
        on = "cart--hidden",
        rn = "cart--loading";
    let nn = class {
        listen() {
            document.addEventListener(
                "theme:cart:change",
                function (t) {
                    (this.cart = t.detail.cart), (this.stale = !0);
                }.bind(this)
            ),
                document.addEventListener(
                    "theme:cart:init",
                    function () {
                        this.init();
                    }.bind(this)
                ),
                document.addEventListener(
                    "theme:cart:reload",
                    function () {
                        (this.stale = !0), this.cart ? this.loadHTML() : this.init().then(() => this.loadHTML());
                    }.bind(this)
                ),
                this.drawer &&
                    (this.drawer.addEventListener(
                        "theme:drawer:open",
                        function () {
                            this.cart ? this.loadHTML() : this.init().then(() => this.loadHTML()), (window.theme.state.cartOpen = !0);
                        }.bind(this)
                    ),
                    this.drawer.addEventListener("theme:drawer:close", function () {
                        window.theme.state.cartOpen = !1;
                    })),
                new yr(this.container),
                new ps(this.container);
        }
        init() {
            return window
                .fetch(`${window.theme.routes.cart}.js`)
                .then(this.handleErrors)
                .then((t) => t.json())
                .then((t) => ((this.cart = t), this.fireChange(t), t))
                .catch((t) => {
                    console.error(t);
                });
        }
        loadHTML() {
            this.stale &&
                (this.cart && this.cart.item_count > 0
                    ? this.loadForm()
                    : (this.showEmpty(),
                      this.cartMessages.forEach((t) => {
                          new ps(t);
                      }))),
                (this.stale = !1);
        }
        initInputs() {
            (this.inputs = this.container.querySelectorAll(`[${Kr}]`)),
                this.inputs.forEach((t) => {
                    const e = t.getAttribute(Kr);
                    t.addEventListener(
                        "change",
                        function (t) {
                            const i = parseInt(t.target.value, 10);
                            (this.latestClick = t.target.closest(Ur)), this.lockState(), this.updateCart(e, i);
                        }.bind(this)
                    );
                });
        }
        initRemove() {
            (this.removers = this.container.querySelectorAll(`[${Yr}]`)),
                this.removers.forEach((t) => {
                    const e = t.getAttribute(Yr);
                    t.addEventListener(
                        "click",
                        function (t) {
                            t.preventDefault(), (this.latestClick = t.target.closest(Ur)), this.lockState(), this.updateCart(e, 0);
                        }.bind(this)
                    );
                });
        }
        lockState() {
            (this.latestClick.querySelector(tn).style.display = "block"), this.loader.classList.add(rn);
        }
        updateCart(t, e) {
            let i = null,
                s = null,
                o = null;
            window
                .fetch(`${window.theme.routes.cart}.js`)
                .then(this.handleErrors)
                .then((t) => t.json())
                .then((s) => {
                    const r = s.items.findIndex((e) => e.key === t);
                    (i = s.item_count), (o = s.items[r].title);
                    const n = { line: `${r + 1}`, quantity: e };
                    return window.fetch(`${window.theme.routes.cart}/change.js`, { method: "post", headers: { "Content-Type": "application/json" }, body: JSON.stringify(n) });
                })
                .then(this.handleErrors)
                .catch((t) => {
                    console.error(t), this.showError(`<p>Error: ${t.message || "Could not update your cart, please try again in a second"}</p>`), this.loadHTML();
                })
                .then((t) => t.json())
                .then((t) => {
                    (this.cart = t), (s = t.item_count), i === s ? (this.stockoutError(o), (this.stale = !0)) : (Xe(this.errors), this.fireChange(t), (this.stale = !0)), this.loadHTML();
                })
                .catch((t) => {
                    console.error(t);
                    let e = "";
                    void 0 !== t.status && (e = `<p>${t.status}</p>`);
                    let i = t.json.description || "";
                    this.showError(`${e + i}`), this.loadHTML();
                });
        }
        fireChange(t) {
            document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart: t }, bubbles: !0 }));
        }
        updateTotal() {
            if (this.cart && this.cart.total_price) {
                const t = l.formatMoney(this.cart.total_price, theme.moneyFormat);
                this.finalPrice.innerHTML = t + ` ${theme.currencyCode}`;
            }
            this.subtotal &&
                this.cart &&
                window
                    .fetch(`${window.theme.routes.root_url}?section_id=api-cart-subtotal`)
                    .then(this.handleErrors)
                    .then((t) => t.text())
                    .then((t) => {
                        const e = document.createElement("div");
                        (e.innerHTML = t), (this.subtotal.innerHTML = e.querySelector(sn).innerHTML);
                    });
        }
        showError(t) {
            Xe(this.errors),
                (this.errors.innerHTML = t),
                window.setTimeout(() => {
                    Ge(this.errors);
                }, 600);
        }
        stockoutError(t) {
            let e = `<p><strong>${window.theme.strings.stockout}</strong></p>`,
                i = `<p>${t}</p>`;
            this.showError(`${e + i}`);
        }
        loadForm() {
            window
                .fetch(`${window.theme.routes.root_url}?section_id=api-cart-items`)
                .then(this.handleErrors)
                .then((t) => t.text())
                .then((t) => {
                    const e = document.createElement("div");
                    (e.innerHTML = t), (this.items.innerHTML = e.querySelector(sn).innerHTML), this.showForm(), this.initQuantity(), this.initQuickview(), this.updateTotal();
                });
        }
        initQuickview() {
            const t = this.items.querySelector(Qr),
                e = this.bottom.querySelector(Qr);
            e && e.remove(), this.cartPage && t && this.bottom.insertBefore(t, this.bottom.firstChild);
        }
        initQuantity() {
            Ir(this.container), this.initInputs(), this.initRemove();
        }
        showForm() {
            this.bar && this.bar.classList.remove(on),
                this.ship && this.ship.classList.remove(on),
                this.progress && this.progress.classList.remove(on),
                this.form.classList.remove(on),
                this.bottom.classList.remove(on),
                this.loader.classList.remove(rn),
                this.emptystate.classList.add(on);
        }
        showEmpty() {
            this.bar && this.bar.classList.add(on),
                this.ship && this.ship.classList.add(on),
                this.progress && this.progress.classList.add(on),
                this.emptystate.classList.remove(on),
                this.loader.classList.remove(rn),
                this.form.classList.add(on),
                this.bottom.classList.add(on);
        }
        handleErrors(t) {
            return t.ok
                ? t
                : t.json().then(function (e) {
                      throw new O({ status: t.statusText, headers: t.headers, json: e });
                  });
        }
        constructor(t) {
            (this.section = t),
                (this.container = t.container),
                (this.cartMessages = document.querySelectorAll(en)),
                (this.bar = this.container.querySelector(Xr)),
                (this.ship = this.container.querySelector(Zr)),
                (this.drawer = this.container.querySelector(Dr)),
                (this.form = this.container.querySelector(Fr)),
                (this.loader = this.container.querySelector(Wr)),
                (this.bottom = this.container.querySelector(Vr)),
                (this.items = this.container.querySelector(zr)),
                (this.subtotal = this.container.querySelector(Rr)),
                (this.errors = this.container.querySelector(jr)),
                (this.finalPrice = this.container.querySelector(Jr)),
                (this.emptystate = this.container.querySelector(Or)),
                (this.progress = this.container.querySelector(Nr)),
                (this.latestClick = null),
                (this.cart = null),
                (this.stale = !0),
                (this.cartPage = document.querySelector(Gr)),
                this.listen();
        }
    };
    const an = {
            onLoad() {
                this.container.querySelector(Dr) && (this.cart = new nn(this));
                this.container.querySelector(Br) && new Pr(this);
            },
            onUnload: function () {
                this.cart && "function" == typeof this.cart.unload && this.cart.unload();
            },
        },
        ln = "[data-accordion-group]",
        cn = "data-accordion-trigger",
        hn = "[data-accordion-body]",
        dn = "data-accordion-body-mobile",
        un = "data-range-holder",
        pn = "[data-section-id]",
        mn = "accordion-is-open";
    let yn = {},
        gn = class {
            mobileAccordions() {
                window.innerWidth < window.theme.sizes.medium ? (this.init(), this.setDefaultState()) : (this.resetMobileAccordions(), this.body.removeAttribute("style")),
                    document.addEventListener("theme:resize", () => {
                        window.innerWidth < window.theme.sizes.medium ? (this.init(), this.setDefaultState()) : (this.resetMobileAccordions(), this.body.removeAttribute("style"));
                    });
            }
            init() {
                this.trigger.setAttribute("aria-haspopup", !0),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.trigger.setAttribute("aria-controls", this.key),
                    this.setDefaultState(),
                    this.trigger.addEventListener("click", this.toggleEvent),
                    this.body.addEventListener("keyup", this.keyboardEvent),
                    this.body.addEventListener("theme:accordion:close", this.hideEvent);
            }
            hideEvents() {
                this.hideAccordion();
            }
            clickEvents(t) {
                t.preventDefault(), this.toggleState();
            }
            keyboardEvents(t) {
                t.which === window.theme.keyboardKeys.ESCAPE && (this.hideAccordion(), this.trigger.focus());
            }
            resetMobileAccordions() {
                this.trigger.removeEventListener("click", this.toggleEvent), this.body.removeEventListener("keyup", this.keyboardEvent), this.body.removeEventListener("theme:accordion:close", this.hideEvent);
            }
            setDefaultState() {
                this.trigger.classList.contains(mn) ? F(this.body) : this.hideAccordion();
            }
            getSiblings() {
                const t = [...this.body.closest(pn).querySelectorAll(ln)].filter((t) => t.contains(this.body)).shift();
                if (t) {
                    return [...t.querySelectorAll(hn)].filter((t) => !t.contains(this.body));
                }
                return [];
            }
            closeSiblings() {
                this.syncBodies.forEach((t) => {
                    t.dispatchEvent(new CustomEvent("theme:accordion:close", { bubbles: !1 }));
                });
            }
            toggleState() {
                this.trigger.classList.contains(mn)
                    ? this.hideAccordion()
                    : (this.showAccordion(),
                      this.closeSiblings(),
                      this.body.hasAttribute(un) &&
                          setTimeout(() => {
                              document.dispatchEvent(new CustomEvent("theme:price-range:reset", { bubbles: !1 }));
                          }, 400));
            }
            hideAccordion() {
                this.trigger.classList.remove(mn), Xe(this.body);
            }
            showAccordion() {
                this.trigger.classList.add(mn),
                    Ge(this.body),
                    setTimeout(() => {
                        this.checkInViewportAndScrollTo();
                    }, 600);
            }
            checkInViewportAndScrollTo() {
                const t = this.trigger.getBoundingClientRect(),
                    e = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
                (t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth)) ||
                    window.scrollTo({ top: e + t.top, left: 0, behavior: "smooth" });
            }
            onBlockSelect(t) {
                this.body.contains(t.target) && this.showAccordion();
            }
            onBlockDeselect(t) {
                this.body.contains(t.target) && this.hideAccordion();
            }
            constructor(t) {
                (this.body = t), (this.key = this.body.id);
                const e = `[${cn}='${this.key}']`;
                (this.trigger = document.querySelector(e)),
                    (this.toggleEvent = (t) => this.clickEvents(t)),
                    (this.keyboardEvent = (t) => this.keyboardEvents(t)),
                    (this.hideEvent = () => this.hideEvents()),
                    (this.syncBodies = this.getSiblings()),
                    this.body.hasAttribute(dn) ? this.mobileAccordions() : this.init();
            }
        };
    const fn = {
            onLoad() {
                yn[this.id] = [];
                this.container.querySelectorAll(hn).forEach((t) => {
                    yn[this.id].push(new gn(t));
                });
            },
            onUnload: function () {
                yn[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
            onSelect: function () {
                "accordion-single" === this.type && this.container.querySelector(`[${cn}]`).click();
            },
            onDeselect: function () {
                "accordion-single" === this.type && this.container.querySelector(`[${cn}]`).click();
            },
            onBlockSelect(t) {
                yn[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                yn[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockDeselect(t);
                });
            },
        },
        wn = "on-sale",
        vn = "sold-out";
    const bn = "[data-search-popdown-wrap]",
        Sn = "[data-predictive-search-results]",
        En = "[data-predictive-search-input]",
        Ln = "[data-search-product-template]",
        kn = "[data-search-other-template]",
        Tn = "[data-predictive-search-title-template]",
        An = "[data-predictive-search-aria-template]",
        qn = "[data-product-title-wrap]",
        Cn = "[data-product-wrap]",
        xn = "[data-collection-wrap]",
        Pn = "[data-article-wrap]",
        $n = "[data-page-wrap]",
        Mn = "[data-predictive-search-aria]",
        Hn = "[data-popdown-outer]",
        _n = "[data-loading-indicator]",
        In = "dirty",
        Dn = "search--empty";
    let Bn = {};
    u.filters.define("animationDelay", function (t) {
        return 90 * t + 10;
    });
    const Wn = {
            onLoad() {
                Bn[this.id] = [];
                document.querySelectorAll(bn).forEach((t) => {
                    Bn[this.id].push(
                        new (class {
                            initSearch() {
                                this.input.addEventListener(
                                    "input",
                                    k(
                                        function (t) {
                                            const e = t.target.value;
                                            e && e.length > 1 ? ((this.loader.style.display = "block"), this.render(e)) : (this.resetTemplates(), this.outer.classList.remove(In));
                                        }.bind(this),
                                        300
                                    )
                                ),
                                    this.input.addEventListener("theme:search:clear", this.reset.bind(this));
                            }
                            render(t) {
                                let e = "";
                                (e += window.theme.settings.search_products ? "product," : ""),
                                    (e += window.theme.settings.search_collections ? "collection," : ""),
                                    (e += window.theme.settings.search_articles ? "article," : ""),
                                    (e += window.theme.settings.search_pages ? "page," : ""),
                                    (e = e.slice(0, -1));
                                const i = `${window.theme.routes.root_url}search/suggest.json?q=${t}&resources[type]=${e}&resources[options][unavailable_products]=last`;
                                fetch(i)
                                    .then(this.handleErrors)
                                    .then((t) => t.json())
                                    .then((e) => {
                                        this.resetTemplates(), this.outer.classList.add(In);
                                        const i = e.resources.results,
                                            s = [];
                                        for (const t in i) ({}.hasOwnProperty.call(i, t) && s.push(...i[t]));
                                        s.length ? (this.outer.classList.remove(Dn), this.injectOther(i), this.injectProduct(i.products)) : this.noResults(t), this.injectAria(t, s), ke(this.outer, { elementToFocus: this.input });
                                    })
                                    .catch((t) => {
                                        console.error(t);
                                    })
                                    .finally(() => {
                                        this.loader.style.display = "none";
                                    });
                            }
                            injectAria(t, e) {
                                let i = window.theme.strings.noResultsFor,
                                    s = null;
                                e.length && ((s = e.length), (i = window.theme.strings.resultsFor)), (this.ariaWrapper.innerHTML = u.render(this.ariaTemplate, { count: s, title: i, query: t }));
                            }
                            noResults() {
                                this.resetTemplates(), this.outer.classList.add(In), this.outer.classList.add(Dn);
                            }
                            resetTemplates() {
                                (this.productTitleWrapper.innerHTML = ""),
                                    (this.collectionWrapper.innerHTML = ""),
                                    (this.articleWrapper.innerHTML = ""),
                                    (this.productWrapper.innerHTML = ""),
                                    (this.pageWrapper.innerHTML = ""),
                                    (this.ariaWrapper.innerHTML = "");
                            }
                            reset() {
                                this.resetTemplates(), this.outer.classList.remove(In), this.outer.classList.remove(Dn), (this.input.val = "");
                            }
                            injectOther(t) {
                                const e = t.collections;
                                if (((this.productTitleWrapper.innerHTML += u.render(this.titleTemplate, { title: window.theme.strings.products, count: t.products.length })), e && e.length)) {
                                    for (let t = e.length - 1; t >= 0; t--) {
                                        const i = e[t];
                                        theme.settings.excluded_collections_strict.forEach((s) => {
                                            s.trim() == i.handle && e.splice(t, 1);
                                        }),
                                            theme.settings.excluded_collections.forEach((s) => {
                                                i.handle.includes(s.trim()) && e.splice(t, 1);
                                            });
                                    }
                                    (this.collectionWrapper.innerHTML += u.render(this.titleTemplate, { title: window.theme.strings.collections, count: e.length })), (this.collectionWrapper.innerHTML += u.render(this.otherTemplate, e));
                                }
                                t.pages &&
                                    t.pages.length &&
                                    ((this.pageWrapper.innerHTML += u.render(this.titleTemplate, { title: window.theme.strings.pages, count: t.pages.length })), (this.pageWrapper.innerHTML += u.render(this.otherTemplate, t.pages))),
                                    t.articles &&
                                        t.articles.length &&
                                        ((this.articleWrapper.innerHTML += u.render(this.titleTemplate, { title: window.theme.strings.articles, count: t.articles.length })),
                                        (this.articleWrapper.innerHTML += u.render(this.otherTemplate, t.articles)));
                            }
                            injectProduct(t) {
                                let e = [];
                                t.forEach((t) => {
                                    let i = t;
                                    (i = (function (t) {
                                        const e = t.price < t.compare_at_price_min;
                                        let i = e ? wn : "";
                                        if (
                                            ((i += t.available ? "" : vn),
                                            (t.price = theme.settings.currency_code_enable ? l.formatMoney(t.price, theme.moneyFormat) + ` ${theme.currencyCode}` : l.formatMoney(t.price, theme.moneyFormat)),
                                            t.price_min !== t.price_max)
                                        ) {
                                            let e = theme.settings.currency_code_enable ? l.formatMoney(t.price_min, theme.moneyFormat) + ` ${theme.currencyCode}` : l.formatMoney(t.price_min, theme.moneyFormat);
                                            t.price = `${window.theme.strings.from} ${e}`;
                                        }
                                        return {
                                            ...t,
                                            classes: i,
                                            on_sale: e,
                                            sold_out: !t.available,
                                            sold_out_translation: window.theme.strings.soldOut,
                                            compare_at_price: theme.settings.currency_code_enable
                                                ? l.formatMoney(t.compare_at_price_min, theme.moneyFormat) + ` ${theme.currencyCode}`
                                                : l.formatMoney(t.compare_at_price_min, theme.moneyFormat),
                                            compare_at_price_max: theme.settings.currency_code_enable
                                                ? l.formatMoney(t.compare_at_price_max, theme.moneyFormat) + ` ${theme.currencyCode}`
                                                : l.formatMoney(t.compare_at_price_max, theme.moneyFormat),
                                            compare_at_price_min: theme.settings.currency_code_enable
                                                ? l.formatMoney(t.compare_at_price_min, theme.moneyFormat) + ` ${theme.currencyCode}`
                                                : l.formatMoney(t.compare_at_price_min, theme.moneyFormat),
                                            price_max: theme.settings.currency_code_enable ? l.formatMoney(t.price_max, theme.moneyFormat) + ` ${theme.currencyCode}` : l.formatMoney(t.price_max, theme.moneyFormat),
                                            price_min: theme.settings.currency_code_enable ? l.formatMoney(t.price_min, theme.moneyFormat) + ` ${theme.currencyCode}` : l.formatMoney(t.price_min, theme.moneyFormat),
                                        };
                                    })(i)),
                                        (i.image = null),
                                        i.featured_image &&
                                            (i.thumb = (function (t, e) {
                                                if (null === e) return t;
                                                if ((null == t && (t = window.theme.assets.noImage), "master" === e)) return mt(t);
                                                const i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
                                                if (i) {
                                                    const s = t.split(i[0]),
                                                        o = i[0];
                                                    return mt(`${s[0]}_${e}${o}`);
                                                }
                                                return null;
                                            })(i.featured_image.url, "360x360")),
                                        e.push(i);
                                });
                                const i = u.render(this.productTemplate, e);
                                this.productWrapper.innerHTML += i;
                            }
                            handleErrors(t) {
                                return t.ok
                                    ? t
                                    : t.json().then(function (e) {
                                          throw new O({ status: t.statusText, headers: t.headers, json: e });
                                      });
                            }
                            constructor(t) {
                                (this.wrapper = t),
                                    (this.input = this.wrapper.querySelector(En)),
                                    (this.loader = this.wrapper.querySelector(_n)),
                                    (this.results = this.wrapper.querySelector(Sn)),
                                    (this.outer = this.input.closest(Hn)),
                                    (this.productTemplate = this.wrapper.querySelector(Ln).innerHTML),
                                    (this.otherTemplate = this.wrapper.querySelector(kn).innerHTML),
                                    (this.titleTemplate = this.wrapper.querySelector(Tn).innerHTML),
                                    (this.ariaTemplate = this.wrapper.querySelector(An).innerHTML),
                                    (this.productTitleWrapper = this.results.querySelector(qn)),
                                    (this.productWrapper = this.results.querySelector(Cn)),
                                    (this.collectionWrapper = this.results.querySelector(xn)),
                                    (this.articleWrapper = this.results.querySelector(Pn)),
                                    (this.pageWrapper = this.results.querySelector($n)),
                                    (this.ariaWrapper = this.results.querySelector(Mn)),
                                    this.initSearch();
                            }
                        })(t)
                    );
                });
            },
            onUnload: function () {
                Bn[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        Fn = "[data-drawer-search]",
        On = "[data-search-popdown-wrap]",
        Nn = "[data-predictive-search-input]",
        zn = "[data-clear-input]";
    const Rn = {
            onLoad() {
                this.searchDrawer = new (class {
                    init() {
                        this.clear.addEventListener(
                            "click",
                            function (t) {
                                t.preventDefault(), this.clearInput();
                            }.bind(this)
                        );
                    }
                    clearInput() {
                        (this.input.value = ""), this.input.dispatchEvent(new CustomEvent("theme:search:clear", { bubbles: !1 })), this.input.focus();
                    }
                    constructor(t) {
                        (this.outer = t.container.querySelector(Fn)), this.outer && ((this.wrapper = this.outer.querySelector(On)), (this.input = this.outer.querySelector(Nn)), (this.clear = this.outer.querySelector(zn)), this.init());
                    }
                })(this);
            },
            onUnload: function () {
                this.searchDrawer && "function" == typeof this.searchDrawer.unload && this.searchDrawer.unload();
            },
        },
        Vn = {
            drawer: "data-drawer-scrolls",
            slideruleOpen: "data-sliderule-open",
            slideruleClose: "data-sliderule-close",
            sliderulePane: "data-sliderule-pane",
            slideruleWrappper: "[data-sliderule]",
            dataAnimates: "data-animates",
            children: ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope .sliderule-grid  > *",
        },
        jn = "is-visible",
        Un = "is-hiding",
        Jn = "is-hidden";
    let Kn = {};
    const Yn = {
            onLoad() {
                Kn[this.id] = [];
                this.container.querySelectorAll(Vn.slideruleWrappper).forEach((t) => {
                    Kn[this.id].push(
                        new (class {
                            clickEvents() {
                                this.trigger.addEventListener(
                                    "click",
                                    function () {
                                        this.showSliderule();
                                    }.bind(this)
                                ),
                                    this.exit.forEach((t) => {
                                        t.addEventListener(
                                            "click",
                                            function () {
                                                this.hideSliderule();
                                            }.bind(this)
                                        );
                                    });
                            }
                            keyboardEvents() {
                                this.trigger.addEventListener(
                                    "keyup",
                                    function (t) {
                                        t.which === window.theme.keyboardKeys.SPACE && this.showSliderule();
                                    }.bind(this)
                                ),
                                    this.sliderule.addEventListener(
                                        "keyup",
                                        function (t) {
                                            t.which === window.theme.keyboardKeys.ESCAPE && (this.hideSliderule(), this.buttons[0].focus());
                                        }.bind(this)
                                    );
                            }
                            staggerChildAnimations(t = !1) {
                                (t ? Array.prototype.slice.call(this.children).slice().reverse() : this.children).forEach((t, e) => {
                                    t.style.transitionDelay = 50 * e + 10 + "ms";
                                });
                            }
                            hideSliderule(t = !1) {
                                const e = window.getComputedStyle(this.pane),
                                    i = 1e3 * parseFloat(e.getPropertyValue("transition-duration")),
                                    s = t ? this.pane.querySelectorAll(`.${jn}`) : this.children;
                                this.pane.style.setProperty("--sliderule-height", "auto"),
                                    this.staggerChildAnimations(!0),
                                    this.pane.classList.add(Un),
                                    this.sliderule.classList.add(Un),
                                    this.sliderule.classList.remove(jn),
                                    s.forEach((t) => {
                                        t.classList.remove(jn);
                                    });
                                const o = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                                this.pane.setAttribute(Vn.sliderulePane, o);
                                const r = t ? `[${Vn.dataAnimates}].${Jn}` : `[${Vn.dataAnimates}="${o}"].${Jn}`,
                                    n = this.pane.querySelectorAll(r);
                                n.length &&
                                    n.forEach((t) => {
                                        t.classList.remove(Jn);
                                    }),
                                    setTimeout(() => {
                                        this.pane.classList.remove(Un), this.sliderule.classList.remove(Un), this.staggerChildAnimations();
                                    }, i);
                            }
                            showSliderule() {
                                this.pane.style.setProperty("--sliderule-height", "auto"),
                                    this.sliderule.classList.add(jn),
                                    this.children.forEach((t) => {
                                        t.classList.add(jn);
                                    });
                                const t = parseInt(this.pane.dataset.sliderulePane, 10),
                                    e = t + 1;
                                this.pane.setAttribute(Vn.sliderulePane, e);
                                const i = this.pane.querySelectorAll(`[${Vn.dataAnimates}="${t}"]`);
                                if (i.length) {
                                    const t = 1e3 * parseFloat(window.getComputedStyle(i[0]).getPropertyValue("transition-duration"));
                                    setTimeout(() => {
                                        i.forEach((t) => {
                                            t.classList.add(Jn);
                                        });
                                    }, t);
                                }
                                const s = parseInt(this.trigger.nextElementSibling.offsetHeight);
                                this.pane.style.setProperty("--sliderule-height", `${s}px`);
                                const o = this.drawer.scrollTop,
                                    r = this.pane.offsetTop;
                                r < o && this.pane.offsetHeight >= this.drawer.offsetHeight && this.drawer.scrollTo({ top: r, left: 0, behavior: "smooth" });
                            }
                            closeSliderule() {
                                this.pane &&
                                    this.pane.hasAttribute(Vn.sliderulePane) &&
                                    parseInt(this.pane.getAttribute(Vn.sliderulePane)) > 0 &&
                                    (this.hideSliderule(!0), parseInt(this.pane.getAttribute(Vn.sliderulePane)) > 0 && this.pane.setAttribute(Vn.sliderulePane, 0));
                            }
                            constructor(t) {
                                (this.sliderule = t), (this.wrapper = t.closest(Vn.wrapper)), (this.key = this.sliderule.id);
                                const e = `[${Vn.slideruleOpen}='${this.key}']`,
                                    i = `[${Vn.slideruleClose}='${this.key}']`;
                                (this.trigger = document.querySelector(e)),
                                    (this.drawer = document.querySelector(`[${Vn.drawer}]`)),
                                    (this.exit = document.querySelectorAll(i)),
                                    (this.pane = document.querySelector(`[${Vn.sliderulePane}]`)),
                                    (this.children = this.sliderule.querySelectorAll(Vn.children)),
                                    this.trigger.setAttribute("aria-haspopup", !0),
                                    this.trigger.setAttribute("aria-expanded", !1),
                                    this.trigger.setAttribute("aria-controls", this.key),
                                    this.clickEvents(),
                                    this.staggerChildAnimations(),
                                    document.addEventListener("theme:sliderule:close", this.closeSliderule.bind(this));
                            }
                        })(t)
                    );
                });
            },
        },
        Qn = "[data-product-add-popdown-wrapper]",
        Gn = "[data-close-popdown]",
        Xn = "[data-api-content]",
        Zn = '[data-ajax-disable="false"]',
        ta = '[data-ajax-disable="true"]',
        ea = '[data-drawer-toggle="drawer-cart"]',
        ia = '[data-drawer="drawer-cart"]',
        sa = "is-visible";
    let oa;
    const ra = {
            onLoad() {
                new (class {
                    renderPopdown(t) {
                        const e = t.detail.variant,
                            i = `${window.theme.routes.root_url}variants/${e.id}/?section_id=api-product-popdown`,
                            s = this;
                        n.get(i)
                            .then(function (t) {
                                const e = document.createElement("div");
                                (e.innerHTML = t.data), (s.drawer.innerHTML = e.querySelector(Xn).innerHTML), s.connectCartButton(), s.connectCloseButton();
                            })
                            .catch(function (t) {
                                console.warn(t);
                            });
                    }
                    connectCloseButton() {
                        this.drawer.classList.add(sa),
                            this.drawer.querySelector(Gn).addEventListener(
                                "click",
                                function (t) {
                                    t.preventDefault(), this.drawer.classList.remove(sa);
                                }.bind(this)
                            ),
                            this.popdownTimer();
                    }
                    connectCartButton() {
                        const t = this.drawer.querySelector(ea),
                            e = document.querySelector(ia);
                        e &&
                            t.addEventListener(
                                "click",
                                function (t) {
                                    t.preventDefault(), this.drawer.classList.remove(sa), e.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: !1 }));
                                }.bind(this)
                            );
                    }
                    popdownTimer() {
                        clearTimeout(oa),
                            (oa = setTimeout(() => {
                                this.drawer.classList.remove(sa);
                            }, 5e3));
                    }
                    constructor() {
                        (this.drawer = document.querySelector(Qn)),
                            (this.cartSectionAjax = document.querySelector(Zn)),
                            (this.ajaxDisabled = document.querySelector(ta)),
                            document.addEventListener("theme:cart:popdown", (t) => {
                                this.cartSectionAjax ? this.cartSectionAjax.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: !0 })) : this.ajaxDisabled ? window.location.reload() : this.renderPopdown(t);
                            });
                    }
                })(this);
            },
        },
        na = "[data-takes-space]",
        aa = "[data-header-desktop]",
        la = "js__header__clone",
        ca = "js__show__mobile",
        ha = "[data-header-backfill]",
        da = "data-header-transparent",
        ua = "header-override-border",
        pa = ".main-content > .shopify-section:first-child [data-overlay-header]",
        ma = ".main-content > .shopify-section:first-child [data-prevent-transparent-header]",
        ya = '.navlink[href="#"]',
        ga = "has-overlay";
    let fa = {};
    Pi("header", [
        {
            onLoad() {
                fa = new (class {
                    unload() {
                        document.removeEventListener("theme:resize", this.checkWidth);
                    }
                    checkForImage() {
                        this.overlayedImages = document.querySelectorAll(pa);
                        let t = document.querySelectorAll(ma).length;
                        this.overlayedImages.length && !t && this.transparent ? ((document.querySelector(ha).style.display = "none"), this.listenOverlay()) : this.wrapper.setAttribute(da, !1),
                            !this.overlayedImages.length || t || this.transparent || (this.wrapper.classList.add(ua), this.subtractHeaderHeight());
                    }
                    listenOverlay() {
                        document.addEventListener("theme:resize", this.checkWidth.bind(this)), this.subtractAnnouncementHeight();
                    }
                    listenWidth() {
                        document.addEventListener("theme:resize", this.checkWidth.bind(this)), this.checkWidth();
                    }
                    killDeadLinks() {
                        this.deadLinks.forEach((t) => {
                            t.onclick = (t) => {
                                t.preventDefault();
                            };
                        });
                    }
                    subtractAnnouncementHeight() {
                        const { windowHeight: t, announcementHeight: e } = g();
                        this.overlayedImages.forEach((i) => {
                            i.style.setProperty("--full-screen", t - e + "px"), i.classList.add(ga);
                        });
                    }
                    subtractHeaderHeight() {
                        const { windowHeight: t, headerHeight: e } = g();
                        this.overlayedImages.forEach((i) => {
                            i.style.setProperty("--full-screen", t - e + "px");
                        });
                    }
                    checkWidth() {
                        document.body.clientWidth < this.minWidth ? this.wrapper.classList.add(ca) : this.wrapper.classList.remove(ca);
                    }
                    getMinWidth() {
                        const t = this.wrapper.cloneNode(!0);
                        t.classList.add(la), document.body.appendChild(t);
                        const e = t.querySelectorAll(na);
                        let i = 0;
                        return (
                            (i =
                                3 === e.length
                                    ? (function (t) {
                                          let e = [];
                                          return (
                                              t.forEach((t) => {
                                                  e.push(t.clientWidth);
                                              }),
                                              e[0] > e[2] ? (e[2] = e[0]) : (e[0] = e[2]),
                                              e.reduce((t, e) => t + e)
                                          );
                                      })(e)
                                    : (function (t) {
                                          let e = 0;
                                          return (
                                              t.forEach((t) => {
                                                  e += t.clientWidth;
                                              }),
                                              e
                                          );
                                      })(e)),
                            document.body.removeChild(t),
                            i + 20 * e.length
                        );
                    }
                    constructor(t) {
                        (this.wrapper = t),
                            (this.style = this.wrapper.dataset.style),
                            (this.desktop = this.wrapper.querySelector(aa)),
                            (this.transparent = "false" !== this.wrapper.getAttribute(da)),
                            (this.overlayedImages = document.querySelectorAll(pa)),
                            (this.deadLinks = document.querySelectorAll(ya)),
                            this.killDeadLinks(),
                            "drawer" !== this.style && this.desktop && ((this.minWidth = this.getMinWidth()), this.listenWidth()),
                            this.checkForImage(),
                            window.dispatchEvent(new Event("resize")),
                            document.addEventListener("theme:header:check", this.checkForImage.bind(this));
                    }
                })(this.container);
            },
            onUnload: function () {
                "function" == typeof fa.unload && fa.unload();
            },
        },
        Rs,
        Yn,
        Xs,
        po,
        Lo,
        qo,
        Do,
        Wn,
        Rn,
        Ut,
        an,
        ra,
        fn,
        is,
    ]),
        customElements.get("popout-select") || customElements.define("popout-select", pr),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Vt),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Fo),
        customElements.get("product-grid-item-content") || customElements.define("product-grid-item-content", Zo);
    const wa = "[data-newsletter-form]",
        va = "has-success",
        ba = "has-error",
        Sa = {};
    const Ea = {
        onLoad() {
            Sa[this.id] = [];
            this.container.querySelectorAll(wa).forEach((t) => {
                Sa[this.id].push(
                    new (class {
                        init() {
                            this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage();
                        }
                        newsletterSubmitEvent(t) {
                            this.stopSubmit && (t.preventDefault(), t.stopImmediatePropagation(), this.removeStorage(), this.writeStorage(), (this.stopSubmit = !1), this.newsletter.submit());
                        }
                        checkForChallengePage() {
                            this.isChallengePage = "/challenge" === window.location.pathname;
                        }
                        writeStorage() {
                            void 0 !== this.sessionStorage && this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id);
                        }
                        readStorage() {
                            this.formID = this.sessionStorage.getItem("newsletter_form_id");
                        }
                        removeStorage() {
                            this.sessionStorage.removeItem("newsletter_form_id");
                        }
                        showMessage() {
                            if ((this.readStorage(), this.newsletter.id === this.formID)) {
                                const t = document.getElementById(this.formID);
                                -1 !== window.location.search.indexOf("?customer_posted=true")
                                    ? (t.classList.remove(ba), t.classList.add(va))
                                    : -1 !== window.location.search.indexOf("accepts_marketing") && (t.classList.remove(va), t.classList.add(ba)),
                                    this.removeStorage(),
                                    this.scrollToForm(t);
                            }
                        }
                        scrollToForm(t) {
                            const e = t.getBoundingClientRect();
                            (e.top >= 0 && e.left >= 0 && e.bottom <= (window.innerHeight || document.documentElement.clientHeight) && e.right <= (window.innerWidth || document.documentElement.clientWidth)) ||
                                setTimeout(() => {
                                    window.scroll({ top: e.top, left: 0, behavior: "smooth" });
                                }, 400);
                        }
                        unload() {
                            this.newsletter.removeEventListener("submit", this.newsletterSubmit);
                        }
                        constructor(t) {
                            (this.sessionStorage = window.sessionStorage),
                                (this.newsletter = t),
                                (this.stopSubmit = !0),
                                (this.isChallengePage = !1),
                                (this.formID = null),
                                this.checkForChallengePage(),
                                (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
                                this.isChallengePage || this.init();
                        }
                    })(t)
                );
            });
        },
        onUnload() {
            Sa[this.id].forEach((t) => {
                "function" == typeof t.unload && t.unload();
            });
        },
    };
    function La() {
        const t = "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        return document.documentElement.classList.toggle("supports-touch", t), t;
    }
    Pi("footer", [fn, Ea]), customElements.get("popout-select") || customElements.define("popout-select", pr), La();
    const ka = { cc_load_policy: 1, iv_load_policy: 3, modestbranding: 1, playsinline: 1, controls: 1, showinfo: 0, ecver: 2, fs: 1, rel: 0 },
        Ta = "iframe, [data-replace]",
        Aa = "data-video-id";
    function qa(t, e) {
        const i = { ...ka, ...e },
            s = document.querySelector(`[data-player="${t}"]`),
            o = s.querySelector(Ta),
            r = s.querySelector(`[${Aa}]`).getAttribute(Aa);
        kt({ url: "https://www.youtube.com/iframe_api" });
        return window.youtubeLoaderPromise
            .then(function () {
                let t = new window.YT.Player(o, { videoId: r, playerVars: { ...i } });
                return (
                    s.addEventListener("pause", function () {
                        try {
                            t.pauseVideo && t.pauseVideo();
                        } catch (t) {
                            console.warn(t);
                        }
                    }),
                    s.addEventListener("theme:media:play-desktop", function () {
                        La() || s.dispatchEvent(new Event("play"));
                    }),
                    s.addEventListener("play", function () {
                        try {
                            t.playVideo
                                ? t.playVideo()
                                : t.addEventListener("onReady", function (t) {
                                      t.target.playVideo();
                                  });
                        } catch (t) {
                            console.warn(t);
                        }
                    }),
                    s.addEventListener("destroy", function () {
                        try {
                            t.destroy && t.destroy();
                        } catch (t) {
                            console.warn(t);
                        }
                    }),
                    t
                );
            })
            .catch(function (t) {
                console.error(t);
            });
    }
    window.youtubeLoaderPromise = new Promise((t) => {
        window.onYouTubeIframeAPIReady = function () {
            t();
        };
    });
    const Ca = { autoplay: !0, loop: !0, controls: !0, muted: !1, playsinline: !0 },
        xa = "iframe, [data-replace]",
        Pa = "data-video-id";
    const $a = "[data-video-popup]",
        Ma = "[data-video-autoplay]",
        Ha = "data-unique",
        _a = "data-video-id",
        Ia = "data-video-type",
        Da = "data-player";
    const Ba = {
            onLoad() {
                new (class {
                    init() {
                        this.triggers.forEach((t) => {
                            const e = t.getAttribute(Ha),
                                i = t.getAttribute(_a),
                                s = t.getAttribute(Ia),
                                o = `${i}-${e}`,
                                n = document.querySelector(`[${Da}="${o}"]`);
                            r.init({
                                onShow: () => {
                                    this.backgroundVideo && "function" == typeof this.backgroundVideo.pause && this.backgroundVideo.pause();
                                    let t = {};
                                    "youtube" === s
                                        ? (t = qa(o))
                                        : "vimeo" === s &&
                                          (t = (function (t, e) {
                                              const i = { ...Ca, ...e },
                                                  s = document.querySelector(`[data-player="${t}"]`),
                                                  o = s.querySelector(xa),
                                                  r = s.querySelector(`[${Pa}]`).getAttribute(Pa),
                                                  n = kt({ url: "https://player.vimeo.com/api/player.js" }),
                                                  a = `select-${t}`;
                                              return (
                                                  o.setAttribute("id", a),
                                                  n
                                                      .then(function () {
                                                          const t = new window.Vimeo.Player(a, { ...i, id: r });
                                                          return (
                                                              s.addEventListener("pause", function () {
                                                                  try {
                                                                      t.pause && t.pause();
                                                                  } catch (t) {
                                                                      console.warn(t);
                                                                  }
                                                              }),
                                                              s.addEventListener("theme:media:play-desktop", function () {
                                                                  La() || s.dispatchEvent(new Event("play"));
                                                              }),
                                                              s.addEventListener("play", function () {
                                                                  t.play && t.play();
                                                              }),
                                                              s.addEventListener("destroy", function () {
                                                                  try {
                                                                      t.destroy && t.destroy();
                                                                  } catch (t) {
                                                                      console.log(t);
                                                                  }
                                                              }),
                                                              t
                                                          );
                                                      })
                                                      .catch(function (t) {
                                                          console.error(t);
                                                      })
                                              );
                                          })(o)),
                                        t.then(() => {
                                            n.dispatchEvent(new CustomEvent("play"));
                                        });
                                },
                                onClose: (t, e, i) => {
                                    i.preventDefault(), n.dispatchEvent(new CustomEvent("destroy")), this.backgroundVideo && "function" == typeof this.backgroundVideo.play && this.backgroundVideo.play();
                                },
                                openTrigger: `data-trigger-${i}-${e}`,
                            });
                        });
                    }
                    constructor(t) {
                        (this.container = t.container), (this.triggers = this.container.querySelectorAll($a)), (this.backgroundVideo = this.container.querySelector(Ma)), this.init();
                    }
                })(this);
            },
        },
        Wa = "[data-scroll-down]";
    const Fa = {
        onLoad() {
            this.scrollButton = new (class {
                init() {
                    const t = this.wrapper.querySelectorAll(Wa);
                    t &&
                        t.forEach((t) => {
                            t.addEventListener("click", this.scroll.bind(this));
                        });
                }
                scroll() {
                    const t = this.wrapper.offsetTop + this.wrapper.clientHeight;
                    window.scroll({ top: t, left: 0, behavior: "smooth" });
                }
                constructor(t) {
                    (this.wrapper = t), this.init();
                }
            })(this.container);
        },
        onUnload: function () {
            delete this.scrollButton;
        },
    };
    Pi("video", [Vi, Fa, Ba]), Pi("page-faq", fn), Pi("hero", [Vi, Fa, Zt]);
    const Oa = "[data-slider]",
        Na = "[data-grid-slide]",
        za = "[data-wrapper]",
        Ra = "data-custom-scrollbar-items",
        Va = "data-show-dots",
        ja = "wrapper",
        Ua = "wrapper--full",
        Ja = window.innerWidth - document.documentElement.clientWidth,
        Ka = 112,
        Ya = {};
    const Qa = {
        onLoad() {
            Ya[this.id] = [];
            this.container.querySelectorAll(Oa).forEach((t) => {
                Ya[this.id].push(
                    new (class {
                        init() {
                            const t = this,
                                e = {
                                    initialIndex: 0,
                                    accessibility: !0,
                                    autoPlay: !1,
                                    contain: !0,
                                    pageDots: this.pageDots,
                                    adaptiveHeight: !1,
                                    wrapAround: !1,
                                    groupCells: !1,
                                    cellAlign: "left",
                                    freeScroll: !0,
                                    prevNextButtons: !1,
                                    draggable: !0,
                                    rightToLeft: window.isRTL,
                                    watchCSS: !0,
                                    arrowShape: { x0: 10, x1: 60, y1: 50, x2: 65, y2: 45, x3: 20 },
                                    on: {
                                        ready: function () {
                                            t.removeIncorrectAria();
                                        },
                                    },
                                };
                            (this.flkty = new s(this.slideshow, e)),
                                this.container.addEventListener("theme:tab:change", () => {
                                    this.flkty.resize();
                                }),
                                this.toggleWrapperModifier(),
                                document.addEventListener("theme:resize:width", this.toggleWrapperModifier.bind(this)),
                                this.slideshow.hasAttribute(Ra) && new Xt(this.container),
                                new K(this.container);
                        }
                        toggleWrapperModifier() {
                            this.wrapper.classList.contains(ja) && this.wrapper.classList.toggle(Ua, this.wrapperWidthWithGutter >= window.innerWidth);
                        }
                        removeIncorrectAria() {
                            this.slideshow.querySelectorAll('[aria-hidden="true"]').forEach((t) => t.removeAttribute("aria-hidden"));
                        }
                        onUnload() {
                            this.slideshow && this.flkty && ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
                        }
                        constructor(t, e) {
                            if (
                                ((this.container = t),
                                (this.slideshow = e),
                                (this.wrapper = this.container.closest(za)),
                                (this.wrapperWidth = Number(getComputedStyle(document.documentElement).getPropertyValue("--LAYOUT-WIDTH").replace("px", ""))),
                                (this.wrapperWidthWithGutter = this.wrapperWidth + Ka + Ja),
                                (this.pageDots = "true" === this.slideshow.getAttribute(Va)),
                                (this.firstPhoto = this.container.querySelector(Na)),
                                this.firstPhoto)
                            ) {
                                const t = this.firstPhoto.offsetHeight / 2;
                                this.slideshow.style.setProperty("--buttons-top", `${t}px`);
                            }
                            this.slideshow && ((this.flkty = null), this.init());
                        }
                    })(this.container, t)
                );
            });
        },
        onUnload(t) {
            Ya[this.id].forEach((e) => {
                "function" == typeof e.onUnload && e.onUnload(t);
            });
        },
    };
    Pi("custom-content", [Vi, Ba, Ut, Qa]),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Vt),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Fo),
        customElements.get("product-grid-item-content") || customElements.define("product-grid-item-content", Zo);
    const Ga = [],
        Xa = "[data-slideshow-wrapper]",
        Za = "data-slideshow-speed",
        tl = "data-slideshow-autoplay",
        el = "data-slideshow-slides",
        il = "[data-slide-custom-prev]",
        sl = "[data-slide-custom-next]",
        ol = "data-slideshow-index",
        rl = "flickity-enabled";
    Pi("slideshow", [
        {
            onLoad() {
                Ga[this.id] = new (class {
                    init() {
                        const t = {
                            autoPlay: !(!this.autoplay || !this.speed) && parseInt(this.speed),
                            contain: !1,
                            pageDots: !0,
                            adaptiveHeight: !0,
                            accessibility: !0,
                            wrapAround: 2 !== this.slideCount,
                            prevNextButtons: !1,
                            draggable: !0,
                            fade: !0,
                            rightToLeft: window.isRTL,
                        };
                        (this.flkty = new e(this.wrapper, t)),
                            this.prevButtons.length &&
                                this.prevButtons.forEach((t) => {
                                    t.onclick = () => {
                                        this.flkty.previous(!0, !1);
                                    };
                                }),
                            this.nextButtons.length &&
                                this.nextButtons.forEach((t) => {
                                    t.onclick = () => {
                                        this.flkty.next(!0, !1);
                                    };
                                }),
                            document.addEventListener("theme:scroll", this.scrollEvent);
                    }
                    scrollEvents() {
                        if (this.flkty && this.autoplay && this.speed) {
                            const t = this.flkty.element,
                                e = t.getBoundingClientRect().top + window.scrollY + t.offsetHeight;
                            window.pageYOffset > e ? "playing" === this.flkty.player.state && this.flkty.pausePlayer() : "paused" === this.flkty.player.state && this.flkty.playPlayer();
                        }
                    }
                    unload() {
                        document.removeEventListener("theme:scroll", this.scrollEvent), this.flkty && this.wrapper && this.wrapper.classList.contains(rl) && this.flkty.destroy();
                    }
                    onBlockSelect(t) {
                        const e = t.target.closest(`[${ol}]`).getAttribute(ol),
                            i = parseInt(e);
                        this.flkty.selectCell(i), this.flkty.stopPlayer();
                    }
                    onBlockDeselect() {
                        this.autoplay && this.flkty.playPlayer();
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.wrapper = t.container.querySelector(Xa)),
                            (this.speed = this.wrapper.getAttribute(Za)),
                            (this.autoplay = "true" === this.wrapper.getAttribute(tl)),
                            (this.slideCount = parseInt(this.wrapper.getAttribute(el), 10)),
                            (this.prevButtons = this.wrapper.querySelectorAll(il)),
                            (this.nextButtons = this.wrapper.querySelectorAll(sl)),
                            (this.flkty = null),
                            (this.scrollEvent = () => this.scrollEvents()),
                            this.init();
                    }
                })(this);
            },
            onUnload() {
                "function" == typeof Ga[this.id].unload && Ga[this.id].unload();
            },
            onBlockSelect(t) {
                "function" == typeof Ga[this.id].onBlockSelect && Ga[this.id].onBlockSelect(t);
            },
            onBlockDeselect(t) {
                "function" == typeof Ga[this.id].onBlockSelect && Ga[this.id].onBlockDeselect(t);
            },
        },
        Vi,
        Fa,
    ]);
    const nl = "[data-range-slider]",
        al = "[data-range-left]",
        ll = "[data-range-right]",
        cl = "[data-range-line]",
        hl = "[data-range-holder]",
        dl = "data-se-min",
        ul = "data-se-max",
        pl = "data-se-min-value",
        ml = "data-se-max-value",
        yl = "data-se-step",
        gl = "data-range-filter-update",
        fl = "[data-field-price-min]",
        wl = "[data-field-price-max]",
        vl = "is-initialized";
    let bl = class {
        init() {
            this.setDefaultValues(),
                this.touchLeft.addEventListener("mousedown", this.onStartEvent),
                this.touchRight.addEventListener("mousedown", this.onStartEvent),
                this.touchLeft.addEventListener("touchstart", this.onStartEvent),
                this.touchRight.addEventListener("touchstart", this.onStartEvent),
                this.slider.classList.add(vl);
        }
        setDefaultValues() {
            let t = this.min;
            this.slider.hasAttribute(pl) && (t = parseFloat(this.slider.getAttribute(pl)));
            let e = this.max;
            this.slider.hasAttribute(ml) && (e = parseFloat(this.slider.getAttribute(ml))),
                t < this.min && (t = this.min),
                e > this.max && (e = this.max),
                t > e && (t = e),
                this.slider.getAttribute(yl) && (this.step = Math.abs(parseFloat(this.slider.getAttribute(yl)))),
                this.reset(),
                (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
                (this.selectedTouch = null),
                (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
                this.setMinValue(t),
                this.setMaxValue(e);
        }
        reset() {
            (this.touchLeft.style.left = "0px"),
                (this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                (this.lineSpan.style.marginLeft = "0px"),
                (this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                (this.startX = 0),
                (this.x = 0);
        }
        setMinValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            (this.touchLeft.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px"),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.slider.setAttribute(pl, t);
        }
        setMaxValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            (this.touchRight.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px"),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.slider.setAttribute(ml, t);
        }
        onStart(t) {
            t.preventDefault();
            let e = t;
            t.touches && (e = t.touches[0]),
                t.currentTarget === this.touchLeft ? (this.x = this.touchLeft.offsetLeft) : t.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft),
                (this.startX = e.pageX - this.x),
                (this.selectedTouch = t.currentTarget),
                document.addEventListener("mousemove", this.onMoveEvent),
                document.addEventListener("mouseup", this.onStopEvent),
                document.addEventListener("touchmove", this.onMoveEvent),
                document.addEventListener("touchend", this.onStopEvent);
        }
        onMove(t) {
            let e = t;
            if (
                (t.touches && (e = t.touches[0]),
                (this.x = e.pageX - this.startX),
                this.selectedTouch === this.touchLeft
                    ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 ? (this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10) : this.x < 0 && (this.x = 0),
                      (this.selectedTouch.style.left = this.x + "px"))
                    : this.selectedTouch === this.touchRight &&
                      (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 ? (this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10) : this.x > this.maxX && (this.x = this.maxX),
                      (this.selectedTouch.style.left = this.x + "px")),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.calculateValue(),
                this.slider.getAttribute("on-change"))
            ) {
                new Function("min, max", this.slider.getAttribute("on-change"))(this.slider.getAttribute(pl), this.slider.getAttribute(ml));
            }
            this.onChange(this.slider.getAttribute(pl), this.slider.getAttribute(ml));
        }
        onStop(t) {
            document.removeEventListener("mousemove", this.onMoveEvent),
                document.removeEventListener("mouseup", this.onStopEvent),
                document.removeEventListener("touchmove", this.onMoveEvent),
                document.removeEventListener("touchend", this.onStopEvent),
                (this.selectedTouch = null),
                this.calculateValue(),
                this.onChanged(this.slider.getAttribute(pl), this.slider.getAttribute(ml));
        }
        onChange(t, e) {
            const i = this.slider.closest(hl);
            if (i) {
                const s = i.querySelector(fl),
                    o = i.querySelector(wl);
                s && o && ((s.value = t), (o.value = e));
            }
        }
        onChanged(t, e) {
            this.slider.hasAttribute(gl) && this.slider.dispatchEvent(new CustomEvent("theme:range:update", { bubbles: !0 }));
        }
        calculateValue() {
            const t = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
            let e = this.lineSpan.offsetLeft / this.initialValue,
                i = e + t;
            if (((e = e * (this.max - this.min) + this.min), (i = i * (this.max - this.min) + this.min), 0 !== this.step)) {
                let t = Math.floor(e / this.step);
                (e = this.step * t), (t = Math.floor(i / this.step)), (i = this.step * t);
            }
            this.selectedTouch === this.touchLeft && this.slider.setAttribute(pl, e), this.selectedTouch === this.touchRight && this.slider.setAttribute(ml, i);
        }
        constructor(t) {
            (this.container = t.container),
                (this.slider = t.querySelector(nl)),
                this.slider &&
                    ((this.onMoveEvent = (t) => this.onMove(t)),
                    (this.onStopEvent = (t) => this.onStop(t)),
                    (this.onStartEvent = (t) => this.onStart(t)),
                    (this.startX = 0),
                    (this.x = 0),
                    (this.touchLeft = this.slider.querySelector(al)),
                    (this.touchRight = this.slider.querySelector(ll)),
                    (this.lineSpan = this.slider.querySelector(cl)),
                    (this.min = parseFloat(this.slider.getAttribute(dl))),
                    (this.max = parseFloat(this.slider.getAttribute(ul))),
                    (this.step = 0),
                    (this.normalizeFact = 26),
                    this.init(),
                    document.addEventListener("theme:price-range:reset", () => {
                        this.setDefaultValues();
                    }));
        }
    };
    const Sl = "data-filters",
        El = "[data-filters-underlay]",
        Ll = "data-default-hide",
        kl = "data-filters-toggle",
        Tl = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        Al = "data-group-heading",
        ql = "data-show-more",
        Cl = "drawer--visible",
        xl = "filters--default-visible",
        Pl = "hidden",
        $l = "is-hidden",
        Ml = "focus-enabled",
        Hl = {};
    let _l = class {
        unload() {
            this.filtersToggleButtons.length &&
                this.filtersToggleButtons.forEach((t) => {
                    t.removeEventListener("click", this.connectToggleMemory);
                }),
                this.showMoreButtons.length &&
                    this.showMoreButtons.forEach((t) => {
                        t.removeEventListener("click", this.connectShowHiddenOptions);
                    });
        }
        expandingEvents() {
            this.showMoreButtons.length &&
                this.showMoreButtons.forEach((t) => {
                    t.addEventListener("click", Ae(this.connectShowHiddenOptions, 500));
                });
        }
        showHiddenOptions(t) {
            const e = t.target.hasAttribute(ql) ? t.target : t.target.closest(`[${ql}]`);
            e.classList.add($l),
                e.previousElementSibling.querySelectorAll(`.${$l}`).forEach((t) => {
                    t.classList.remove($l);
                });
        }
        connectToggle(t = !1) {
            this.filtersToggleButtons.forEach((e) => {
                const i = null !== e.closest(`[${Sl}]`);
                ((i && t) || (i && !t) || (!i && !t)) && e.addEventListener("click", this.connectToggleMemory.bind(this));
            });
        }
        connectToggleFunction(t) {
            "true" === t.currentTarget.getAttribute("aria-expanded") ? this.hideFilters() : this.showFilters();
        }
        onFocusOut() {
            this.container.addEventListener(
                "focusout",
                function (t) {
                    if (window.innerWidth >= window.theme.sizes.medium) return;
                    const e = t.currentTarget.contains(t.relatedTarget),
                        i = this.container.classList.contains(Cl);
                    document.body.classList.contains(Ml) && i && !e && this.hideFilters();
                }.bind(this)
            ),
                this.container.addEventListener(
                    "keyup",
                    function (t) {
                        t.which === window.theme.keyboardKeys.ESCAPE && (this.hideFilters(), this.filtersToggleButtons[0].focus());
                    }.bind(this)
                ),
                this.underlay.addEventListener(
                    "click",
                    function () {
                        this.hideFilters();
                    }.bind(this)
                );
        }
        getShowOnLoad() {
            const t = `[${Ll}='false']`,
                e = document.querySelector(t),
                i = window.innerWidth >= window.theme.sizes.medium;
            return !(!e || !i);
        }
        showFilters() {
            (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
                this.container.classList.remove(Pl),
                setTimeout(() => {
                    this.filtersToggleButtons.forEach((t) => t.setAttribute("aria-expanded", !0)), this.filtersToggleButtons.forEach((t) => t.classList.add(Cl)), this.container.classList.add(Cl), this.container.querySelector(Tl).focus();
                }, 1);
        }
        hideFilters() {
            (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
                this.filtersToggleButtons.forEach((t) => t.setAttribute("aria-expanded", !1)),
                this.container.classList.remove(Cl),
                this.container.classList.remove(xl),
                this.filtersToggleButtons.forEach((t) => t.classList.remove(Cl)),
                this.filtersToggleButtons.forEach((t) => t.classList.remove(xl)),
                setTimeout(() => {
                    this.container.classList.contains(Cl) || this.container.classList.add(Pl);
                }, 800);
        }
        constructor(t, e = !1) {
            (this.container = t),
                (this.underlay = this.container.querySelector(El)),
                (this.groupHeadings = this.container.querySelectorAll(`[${Al}]`)),
                (this.showMoreButtons = this.container.querySelectorAll(`[${ql}]`)),
                (this.triggerKey = this.container.getAttribute(Sl)),
                (this.selector = `[${kl}='${this.triggerKey}']`),
                (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
                (this.connectToggleMemory = (t) => this.connectToggleFunction(t)),
                (this.connectShowHiddenOptions = (t) => this.showHiddenOptions(t)),
                this.connectToggle(e),
                this.onFocusOut(),
                this.expandingEvents(),
                this.getShowOnLoad() ? this.showFilters() : this.hideFilters();
        }
    };
    const Il = {
            onLoad() {
                Hl[this.id] = [];
                this.container.querySelectorAll(`[${Sl}]`).forEach((t) => {
                    Hl[this.id].push(new _l(t));
                });
            },
            onUnload: function () {
                Hl[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        Dl = {
            collectionSidebar: "[data-collection-sidebar]",
            form: "[data-sidebar-filter-form]",
            inputs: "input, select, label, textarea",
            priceMin: "data-field-price-min",
            priceMax: "data-field-price-max",
            rangeMin: "data-se-min-value",
            rangeMax: "data-se-max-value",
            rangeMinDefault: "data-se-min",
            rangeMaxDefault: "data-se-max",
            productsContainer: "[data-products-grid]",
            filterUpdateUrlButton: "[data-filter-update-url]",
            activeFiltersHolder: "[data-active-filters]",
            activeFiltersCount: "[data-active-filters-count]",
            productsCount: "[data-products-count]",
            dataSort: "data-sort-enabled",
            collectionTools: "[data-collection-tools]",
            filtersWrappper: "[data-filters]",
            headerSticky: '[data-header-sticky="sticky"]',
            headerHeight: "[data-header-height]",
            gridLarge: "data-grid-large",
            gridSmall: "data-grid-small",
            accordionBody: "[data-accordion-body]",
            checkedOption: "input:checked",
            optionHolder: "[data-option-holder]",
        },
        Bl = "is-hidden",
        Wl = "is-loading",
        Fl = 1e3,
        Ol = 1e3;
    const Nl = {
        onLoad() {
            this.filterForm = new (class {
                init() {
                    this.showAllOptions(),
                        this.form &&
                            (new bl(this.form),
                            this.sidebar.addEventListener(
                                "input",
                                k((t) => {
                                    const e = t.type,
                                        i = t.target;
                                    if (!Dl.inputs.includes(e) || !this.form || "function" != typeof this.form.submit) return;
                                    const s = this.form.querySelector(`[${Dl.priceMin}]`),
                                        o = this.form.querySelector(`[${Dl.priceMax}]`);
                                    if (i.hasAttribute(Dl.priceMin) || i.hasAttribute(Dl.priceMax)) {
                                        const t = this.form.querySelector(`[${Dl.rangeMin}]`),
                                            e = this.form.querySelector(`[${Dl.rangeMax}]`);
                                        parseInt(t.getAttribute(Dl.rangeMinDefault));
                                        const i = parseInt(e.getAttribute(Dl.rangeMaxDefault));
                                        s.value && !o.value && (o.value = i),
                                            o.value && !s.value && (s.value = rangeMinDefault),
                                            s.value <= rangeMinDefault && o.value >= i && ((s.placeholder = rangeMinDefault), (o.placeholder = i), (s.value = ""), (o.value = ""));
                                    }
                                    this.filtering(t);
                                }, 1500)
                            ),
                            this.form.addEventListener("theme:range:update", (t) => this.updateRange(t))),
                        this.sidebar && this.sidebar.addEventListener("click", (t) => this.updateFilterFromUrl(t)),
                        this.activeFiltersHolder && this.activeFiltersHolder.addEventListener("click", (t) => this.updateFilterFromUrl(t)),
                        this.productsContainer && this.productsContainer.addEventListener("click", (t) => this.updateFilterFromUrl(t)),
                        xt(this.sidebar);
                }
                updateRange(t) {
                    if (this.form && "function" == typeof this.form.submit) {
                        const e = this.form.querySelector(`[${Dl.rangeMin}]`),
                            i = this.form.querySelector(`[${Dl.rangeMax}]`),
                            s = this.form.querySelector(`[${Dl.priceMin}]`),
                            o = this.form.querySelector(`[${Dl.priceMax}]`);
                        if (e && i && s && o && e.hasAttribute(Dl.rangeMin) && i.hasAttribute(Dl.rangeMax)) {
                            const r = parseInt(s.placeholder),
                                n = parseInt(o.placeholder),
                                a = parseInt(e.getAttribute(Dl.rangeMin)),
                                l = parseInt(i.getAttribute(Dl.rangeMax));
                            (r === a && n === l) || ((s.value = a), (o.value = l), this.filtering(t));
                        }
                    }
                }
                updateFilterFromUrl(t) {
                    const e = t.target;
                    if (e.matches(Dl.filterUpdateUrlButton) || (e.closest(Dl.filterUpdateUrlButton) && e)) {
                        t.preventDefault();
                        const i = e.matches(Dl.filterUpdateUrlButton) ? e : e.closest(Dl.filterUpdateUrlButton);
                        this.filtering(t, i.getAttribute("href"));
                    }
                }
                addToHistory(t, e = "") {
                    const i = this.sort ? this.sort.getAttribute(Dl.dataSort) : "";
                    if (!t || (t && "popstate" !== t.type)) {
                        if ("" === e) {
                            const e = new window.URL(window.location.href).searchParams,
                                s = Object.fromEntries(e),
                                o = e.toString();
                            if (o.includes("filter.") || o.includes("sort_by") || o.includes("page")) for (const t in s) (t.includes("filter.") || t.includes("sort_by") || t.includes("page")) && e.delete(t);
                            if (this.form) {
                                const t = new URLSearchParams(new FormData(this.form));
                                for (let [i, s] of t.entries()) i.includes("filter.") && s && e.append(i, s);
                                const i = this.form.querySelector(`[${Dl.rangeMin}]`),
                                    s = this.form.querySelector(`[${Dl.rangeMax}]`),
                                    o = this.form.querySelector(`[${Dl.priceMin}]`),
                                    r = this.form.querySelector(`[${Dl.priceMax}]`);
                                if (i && s && o && r && i.hasAttribute(Dl.rangeMinDefault) && s.hasAttribute(Dl.rangeMaxDefault)) {
                                    const t = parseFloat(i.getAttribute(Dl.rangeMinDefault), 10),
                                        n = parseFloat(s.getAttribute(Dl.rangeMaxDefault), 10),
                                        a = "" === o.value ? parseFloat(o.placeholder, 10) : parseFloat(o.value, 10),
                                        l = "" === r.value ? parseFloat(r.placeholder, 10) : parseFloat(r.value, 10);
                                    a <= t && l >= n && (e.delete("filter.v.price.gte"), e.delete("filter.v.price.lte"));
                                }
                            }
                            if (i || (t && t.detail && t.detail.href)) {
                                const s = i || t.detail.params;
                                e.set("sort_by", s);
                            }
                            const r = e.toString(),
                                n = r ? `?${r}` : location.pathname;
                            return void window.history.pushState(null, "", n);
                        }
                        window.history.pushState(null, "", e);
                    }
                }
                getFilterResult() {
                    this.productsContainer.classList.add(Wl),
                        this.getGridValues(),
                        fetch(`${window.location.pathname}${window.location.search}`)
                            .then((t) => t.text())
                            .then((t) => {
                                const e = document.createElement("div");
                                (e.innerHTML = t),
                                    this.sidebar && (this.sidebar.innerHTML = e.querySelector(Dl.collectionSidebar).innerHTML),
                                    this.activeFiltersCount && (this.activeFiltersCount.innerHTML = e.querySelector(Dl.activeFiltersCount).innerHTML),
                                    (this.productsContainer.innerHTML = e.querySelector(Dl.productsContainer).innerHTML),
                                    (this.activeFiltersHolder.innerHTML = e.querySelector(Dl.activeFiltersHolder).innerHTML),
                                    this.activeFiltersHolder.parentNode.classList.toggle(Bl, "" === this.activeFiltersHolder.innerHTML),
                                    this.productsCount && (this.productsCount.innerHTML = e.querySelector(Dl.productsCount).innerHTML),
                                    this.setGridValues(),
                                    this.refreshFunctionalities(),
                                    setTimeout(() => {
                                        this.productsContainer.classList.remove(Wl);
                                    }, Fl);
                            });
                }
                refreshFunctionalities() {
                    (this.form = this.container.querySelector(Dl.form)),
                        this.form && (new bl(this.form), this.form.addEventListener("theme:range:update", (t) => this.updateRange(t))),
                        this.container.querySelectorAll(Dl.filtersWrappper).forEach((t) => {
                            new _l(t, !0);
                        }),
                        this.container.querySelectorAll(Dl.accordionBody).forEach((t) => {
                            new gn(t);
                        }),
                        new K(this.container),
                        this.sidebar && xt(this.sidebar),
                        jt(this.container),
                        this.showAllOptions();
                }
                getGridValues() {
                    this.layoutLarge && (this.layoutLargeValue = this.layoutLarge.getAttribute(Dl.gridLarge)), this.layoutSmall && (this.layoutSmallValue = this.layoutSmall.getAttribute(Dl.gridSmall));
                }
                setGridValues() {
                    this.layoutLarge && ((this.layoutLarge = this.container.querySelector(`[${Dl.gridLarge}]`)), this.layoutLarge.setAttribute(Dl.gridLarge, this.layoutLargeValue)),
                        this.layoutSmall && ((this.layoutSmall = this.container.querySelector(`[${Dl.gridSmall}]`)), this.layoutSmall.setAttribute(Dl.gridSmall, this.layoutSmallValue));
                }
                showAllOptions() {
                    this.container.querySelectorAll(Dl.checkedOption).forEach((t) => {
                        if (t.closest(Dl.optionHolder) && t.closest(Dl.optionHolder).classList.contains(Bl)) {
                            const e = t.closest(Dl.accordionBody).nextElementSibling;
                            e.classList.contains(Dl.classHidden) || e.dispatchEvent(new Event("click"));
                        }
                    });
                }
                filtering(t, e = "") {
                    const i = window.scrollY || window.pageYOffset,
                        s = this.headerIsSticky ? document.querySelector(Dl.headerHeight).getBoundingClientRect().height : 0,
                        o = this.container.querySelector(Dl.collectionTools),
                        r = o.offsetTop - s,
                        n = o.offsetTop + o.getBoundingClientRect().height < i - s;
                    n && window.scrollTo({ top: r, left: 0, behavior: "smooth" }),
                        setTimeout(
                            () => {
                                this.addToHistory(t, e), this.getFilterResult();
                            },
                            n ? Ol : 10
                        );
                }
                constructor(t) {
                    (this.section = t),
                        (this.container = this.section.container),
                        (this.sidebar = this.container.querySelector(Dl.collectionSidebar)),
                        (this.form = t.container.querySelector(Dl.form)),
                        (this.sort = this.container.querySelector(`[${Dl.dataSort}]`)),
                        (this.productsContainer = this.container.querySelector(Dl.productsContainer)),
                        (this.activeFiltersHolder = this.container.querySelector(Dl.activeFiltersHolder)),
                        (this.activeFiltersCount = this.container.querySelector(Dl.activeFiltersCount)),
                        (this.productsCount = this.container.querySelector(Dl.productsCount)),
                        (this.headerIsSticky = null !== document.querySelector(Dl.headerSticky)),
                        (this.layoutLarge = this.container.querySelector(`[${Dl.gridLarge}]`)),
                        (this.layoutSmall = this.container.querySelector(`[${Dl.gridSmall}]`)),
                        this.productsContainer && this.sidebar && this.init(),
                        this.sort && this.container.addEventListener("theme:form:filter", (t) => this.filtering(t)),
                        (this.sidebar || this.sort) && window.addEventListener("popstate", (t) => this.filtering(t));
                }
            })(this);
        },
        onUnload() {
            this.filterForm && "function" == typeof this.filterForm.unload && this.filterForm.unload();
        },
    };
    Pi("search-page", [Il, Nl, Ut, fn]),
        customElements.get("popout-select") || customElements.define("popout-select", pr),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Vt),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Fo),
        customElements.get("product-grid-item-content") || customElements.define("product-grid-item-content", Zo);
    const zl = "[data-image-zoom]",
        Rl = "[data-modal-container]",
        Vl = "data-unique",
        jl = "data-src";
    const Ul = {
        onLoad() {
            new (class {
                init() {
                    this.triggers.forEach((t) => {
                        const e = t.getAttribute(Vl),
                            i = this.modalContainer.querySelector(`#zoom-${e}`);
                        if (i) {
                            const t = this.container.querySelector(`#zoom-${e}`);
                            t && (i.parentNode.removeChild(i), this.modalContainer.appendChild(t));
                        }
                        r.init({
                            disableScroll: !0,
                            openTrigger: `data-popup-${e}`,
                            onShow: (t) => {
                                t.querySelectorAll(`[${jl}]`, t).forEach((t) => {
                                    if (null === t.getAttribute("src")) {
                                        const e = t.getAttribute(jl);
                                        t.setAttribute("src", e);
                                    }
                                });
                            },
                            onClose: (t, e, i) => {
                                i.preventDefault();
                            },
                        });
                    });
                }
                constructor(t) {
                    (this.container = t), (this.triggers = this.container.querySelectorAll(zl)), (this.modalContainer = document.querySelector(Rl)), this.init();
                }
            })(this.container);
        },
    };
    Pi("gallery", [Ul, Ba, Zt]);
    const Jl = (t, e) => {
        const { el: i, elStyle: s, elHeight: o, rowsLimit: r, rowsWrapped: n, options: a } = t;
        let l = t.buffer,
            c = l;
        if (n === r + 1) return { ...t };
        const h = l;
        let d = n,
            u = o;
        return (
            (i.innerHTML = c = l.length ? `${l}${a.delimiter}${e}${a.replaceStr}` : `${e}${a.replaceStr}`),
            parseFloat(s.height) > parseFloat(o) && (d++, (u = s.height), d === r + 1)
                ? ((i.innerHTML = c = "." === h[h.length - 1] && "..." === a.replaceStr ? `${h}..` : `${h}${a.replaceStr}`), { ...t, elHeight: u, rowsWrapped: d })
                : ((i.innerHTML = c = h.length ? `${h}${a.delimiter}${e}` : `${e}`), { ...t, buffer: c, elHeight: u, rowsWrapped: d })
        );
    };
    let Kl = {},
        Yl = {},
        Ql = {};
    const Gl = "[data-product-slideshow]",
        Xl = "[data-shopify-xr]",
        Zl = "data-media-id",
        tc = "data-model-id",
        ec = "model-viewer",
        ic = "data-shopify-model3d-id",
        sc = "#ModelJson-";
    function oc(t) {
        if (t) console.warn(t);
        else if (window.ShopifyXR) {
            for (const t in Kl)
                if (Kl.hasOwnProperty(t)) {
                    const e = Kl[t];
                    if (e.loaded) continue;
                    const i = document.querySelector(`${sc}${t}`);
                    i && (window.ShopifyXR.addModels(JSON.parse(i.innerHTML)), (e.loaded = !0));
                }
            window.ShopifyXR.setupXRElements();
        } else
            document.addEventListener("shopify_xr_initialized", function () {
                oc();
            });
    }
    function rc(t) {
        if (t) console.warn(t);
        else
            for (const t in Yl)
                if (Yl.hasOwnProperty(t)) {
                    const e = Yl[t];
                    e.modelViewerUi || (e.modelViewerUi = new Shopify.ModelViewerUI(e.$element)), nc(e);
                }
    }
    function nc(t) {
        const e = Ql[t.sectionId];
        t.$container.addEventListener("pause", function () {
            t.modelViewerUi.pause && t.modelViewerUi.pause();
        }),
            t.$container.addEventListener("theme:media:play-desktop", function () {
                t.modelViewerUi.play && !La() && t.modelViewerUi.play(), e && e.$element && t && t.modelId && ic && e.$element.setAttribute(ic, t.modelId);
            }),
            t.$container.addEventListener("play", function () {
                t.modelViewerUi.play && t.modelViewerUi.play();
            });
    }
    async function ac(t) {
        const e = document.querySelector(`[data-player="${t}"]`),
            i = e.querySelector("video");
        await kt({ name: "video-ui", version: "1.0" });
        const s = new window.Shopify.Plyr(i);
        return (
            e.addEventListener("pause", function () {
                s.pause && s.pause();
            }),
            e.addEventListener("theme:media:play-desktop", function () {
                s.play && !La() && e.dispatchEvent(new CustomEvent("play"));
            }),
            e.addEventListener("play", function () {
                try {
                    s.play
                        ? s.play()
                        : s.addEventListener("onReady", function (t) {
                              t.target.play();
                          });
                } catch (t) {
                    console.warn(t);
                }
            }),
            e.addEventListener("destroy", function () {
                try {
                    s.destroy && s.destroy();
                } catch (t) {
                    console.warn(t);
                }
            }),
            s
        );
    }
    const lc = {
            productSlideshow: "[data-product-slideshow]",
            slideshowMobileStyle: "data-slideshow-mobile-style",
            slideshowDesktopStyle: "data-slideshow-desktop-style",
            productThumbs: "[data-product-thumbs]",
            leftThumbsHolder: "[data-thumbs-holder]",
            thumbImage: "[data-slideshow-thumbnail]",
            mediaSlide: "[data-media-slide]",
            dataMediaId: "data-media-id",
            dataMediaSelect: "data-media-select",
            mediaType: "data-type",
            videoPlayerExternal: '[data-type="external_video"]',
            videoPlayerNative: '[data-type="video"]',
            modelViewer: '[data-type="model"]',
            allPlayers: "[data-player]",
            loopVideo: "data-enable-video-looping",
            verticalAlignment: "[data-thumbnails-left]",
            arrowPrev: "[data-thumbs-arrow-prev]",
            arrowNext: "[data-thumbs-arrow-next]",
            aspectRatio: "data-aspect-ratio",
            flickitylockHeight: "flickity-lock-height",
        },
        cc = "is-activated",
        hc = "show";
    function dc(t) {
        return (
            t.addEventListener("onStateChange", function (t) {
                0 === t.data && t.target.playVideo();
            }),
            t
        );
    }
    const uc = "data-store-availability-container",
        pc = "[data-api-content]",
        mc = "[data-pickup-drawer]",
        yc = "[data-pickup-drawer-open]",
        gc = "[data-pickup-drawer-close]",
        fc = "[data-pickup-body]",
        wc = "drawer--visible",
        vc = "hide",
        bc = "is-pickup-visible";
    let Sc = {};
    const Ec = {
            onLoad() {
                Sc[this.id] = new (class {
                    fetchPickupAvailability(t) {
                        const e = this.container.querySelector(`[${uc}]`);
                        if (!e) return;
                        const i = t && t.detail.variant ? t.detail.variant.id : e.getAttribute(uc);
                        !t || t.detail.variant
                            ? i &&
                              fetch(`${window.theme.routes.root_url}variants/${i}/?section_id=api-pickup-availability`)
                                  .then(this.handleErrors)
                                  .then((t) => t.text())
                                  .then((t) => {
                                      const i = new DOMParser().parseFromString(t, "text/html").querySelector(pc).innerHTML;
                                      (e.innerHTML = i),
                                          e.classList.remove(vc),
                                          (this.drawer = this.container.querySelector(mc)),
                                          (this.buttonDrawerOpen = this.container.querySelector(yc)),
                                          (this.buttonDrawerClose = this.container.querySelectorAll(gc)),
                                          (this.drawerBody = this.container.querySelector(fc)),
                                          this.buttonDrawerOpen && this.buttonDrawerOpen.addEventListener("click", () => this.openDrawer()),
                                          this.buttonDrawerClose.length &&
                                              this.buttonDrawerClose.forEach((t) => {
                                                  t.addEventListener("click", () => this.closeDrawer());
                                              });
                                  })
                                  .catch((t) => {
                                      console.error(t);
                                  })
                            : e.classList.add(vc);
                    }
                    openDrawer() {
                        this.drawer &&
                            (document.body.classList.add(bc),
                            this.drawer.classList.add(wc),
                            this.drawer.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                            this.drawerBody.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })));
                    }
                    closeDrawer() {
                        this.drawer &&
                            (document.body.classList.remove(bc),
                            this.drawer.classList.remove(wc),
                            this.drawer.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                            this.drawerBody.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })));
                    }
                    handleErrors(t) {
                        return t.ok
                            ? t
                            : t.json().then(function (e) {
                                  throw new O({ status: t.statusText, headers: t.headers, json: e });
                              });
                    }
                    constructor(t) {
                        (this.container = t.container),
                            (this.drawer = null),
                            (this.buttonDrawerOpen = null),
                            (this.buttonDrawerClose = null),
                            (this.drawerBody = null),
                            this.fetchPickupAvailability(),
                            this.container.addEventListener("theme:variant:change", (t) => this.fetchPickupAvailability(t));
                    }
                })(this);
            },
        },
        Lc = (t) => {
            t && (t.style.display = "none");
        },
        kc = "[data-product-form]",
        Tc = "data-option-position",
        Ac = '[name^="options"], [data-popout-option]',
        qc = "data-value",
        Cc = "sold-out",
        xc = "unavailable";
    const Pc = "[data-section-id]",
        $c = "[data-quickview-modal]",
        Mc = "[data-product-form]",
        Hc = "[data-product-slideshow]",
        _c = "[data-add-to-cart]",
        Ic = "[data-add-to-cart-text]",
        Dc = "[data-compare-price]",
        Bc = "[data-compare-text]",
        Wc = "[data-buttons-wrapper]",
        Fc = "[data-product-select]",
        Oc = "[data-price-wrapper]",
        Nc = "[data-button-price]",
        zc = "[data-product-json]",
        Rc = "[data-product-price]",
        Vc = "[data-product-unit-price]",
        jc = "[data-product-base]",
        Uc = "[data-product-unit]",
        Jc = "data-enable-history-state",
        Kc = "data-option-position",
        Yc = "[data-option-value]",
        Qc = "[data-subscription-watch-price]",
        Gc = "[data-subscription-selectors]",
        Xc = "[data-price-off]",
        Zc = "[data-price-off-type]",
        th = "[data-price-off-amount]",
        eh = "[data-toggles-group]",
        ih = "data-group-toggle",
        sh = "[data-plan-description]",
        oh = "[data-remaining-count]",
        rh = "data-remaining-max",
        nh = "[data-remaining-wrapper]",
        ah = "[data-product-remaining-json]",
        lh = "[data-product-preorder]",
        ch = "hide",
        hh = "variant--soldout",
        dh = "variant--unavailable",
        uh = "product__price--sale",
        ph = "count-is-low",
        mh = "count-is-in",
        yh = "count-is-out",
        gh = "count-is-unavailable";
    let fh = class extends HTMLElement {
            connectedCallback() {
                (this.outerSection = this.container.closest(Pc)),
                    (this.quickview = this.container.closest($c)),
                    (this.outerWrapper = this.quickview ? this.quickview : this.outerSection),
                    (this.productFormElement = this.container.querySelector(Mc)),
                    (this.productForm = this.container.querySelector(Mc)),
                    (this.slideshow = this.outerWrapper.querySelector(Hc)),
                    (this.enableHistoryState = !(!this.outerSection || !this.outerSection.hasAttribute(Jc)) && "true" === this.outerSection.getAttribute(Jc)),
                    (this.hasUnitPricing = this.outerWrapper.querySelector(Uc)),
                    (this.subSelectors = this.outerWrapper.querySelector(Gc)),
                    (this.subPrices = this.outerWrapper.querySelector(Qc)),
                    (this.priceOffWrap = this.outerWrapper.querySelector(Xc)),
                    (this.priceOffAmount = this.outerWrapper.querySelector(th)),
                    (this.priceOffType = this.outerWrapper.querySelector(Zc)),
                    (this.planDecription = this.outerWrapper.querySelector(sh)),
                    (this.isPreOrder = this.container.querySelector(lh)),
                    (this.remainingWrapper = this.outerWrapper.querySelector(nh));
                const t = this.outerWrapper.querySelector(`[${rh}]`);
                (this.sellout = null),
                    this.remainingWrapper &&
                        t &&
                        ((this.remainingMaxInt = parseInt(t.getAttribute(rh), 10)),
                        (this.remainingCount = this.outerWrapper.querySelector(oh)),
                        (this.remainingJSONWrapper = this.outerWrapper.querySelector(ah)),
                        (this.remainingJSON = null),
                        this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML ? (this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML)) : console.warn("Missing product quantity JSON")),
                    Ir(this.outerWrapper);
                let e = null;
                this.productJSON = null;
                const i = this.outerWrapper.querySelector(zc);
                i && (e = i.innerHTML),
                    e && this.productForm
                        ? ((this.productJSON = JSON.parse(e)),
                          (this.sellout = new (class {
                              init() {
                                  this.update();
                              }
                              update() {
                                  this.getCurrentState(),
                                      this.optionElements.forEach((t) => {
                                          const e = t.value || t.getAttribute(qc),
                                              i = t.closest(`[${Tc}]`).getAttribute(Tc),
                                              s = parseInt(i, 10) - 1;
                                          let o = [...this.selections];
                                          o[s] = e;
                                          const r = this.productJSON.variants.find((t) => {
                                              let e = !0;
                                              for (let i = 0; i < o.length; i++) t.options[i] !== o[i] && (e = !1);
                                              return e;
                                          });
                                          t.classList.remove(Cc, xc), void 0 === r ? t.classList.add(xc) : r && !1 === r.available && t.classList.add(Cc);
                                      });
                              }
                              getCurrentState() {
                                  for (var t of ((this.formData = new FormData(this.form)), (this.selections = []), this.formData.entries())) t[0].includes("options[") && this.selections.push(t[1]);
                              }
                              constructor(t, e) {
                                  (this.container = t),
                                      (this.productJSON = e),
                                      (this.form = this.container.querySelector(kc)),
                                      (this.formData = new FormData(this.form)),
                                      (this.optionElements = this.container.querySelectorAll(Ac)),
                                      this.productJSON && this.form && this.init();
                              }
                          })(this.outerWrapper, this.productJSON)),
                          this.linkForm())
                        : console.warn("Missing product form or product JSON"),
                    this.productJSON &&
                        new (class {
                            updateCookie() {
                                let t = this.cookie.read();
                                const e = t.indexOf(this.handle);
                                -1 === e ? (t.unshift(this.handle), (t = t.splice(0, Z))) : (t.splice(e, 1), t.unshift(this.handle)), this.cookie.write(t);
                            }
                            constructor(t) {
                                (this.handle = t), (this.cookie = new G(ht)), void 0 !== this.handle && (ut.push(this.handle), this.updateCookie());
                            }
                        })(this.productJSON.handle);
            }
            destroy() {
                this.productForm.destroy();
            }
            linkForm() {
                (this.productForm = new (class {
                    destroy() {
                        this._listeners.removeAll();
                    }
                    options() {
                        return this._serializeInputValues(this.optionInputs, function (t) {
                            return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                        });
                    }
                    variant() {
                        const t = this.options();
                        return t.length ? gt(this.product, t) : this.product.variants[0];
                    }
                    plan(t) {
                        let e = { allocation: null, group: null, detail: null };
                        const i = new FormData(this.form).get("selling_plan");
                        if (t && t.selling_plan_allocations && t.selling_plan_allocations.length > 0) {
                            const e = [...new Set(t.selling_plan_allocations.map((t) => t.selling_plan_group_id))],
                                i = this.element.querySelectorAll("[data-subscription-group]");
                            if (!i.length) return;
                            i.forEach((t) => (t.style.display = "none")),
                                e.forEach((t) => {
                                    this.element.querySelector(`[data-selling-plan-group="${t}"]`).style.display = "block";
                                });
                        }
                        return (
                            i &&
                                t &&
                                (e.allocation = t.selling_plan_allocations.find(function (t) {
                                    return t.selling_plan_id.toString() === i.toString();
                                })),
                            e.allocation &&
                                (e.group = this.product.selling_plan_groups.find(function (t) {
                                    return t.id.toString() === e.allocation.selling_plan_group_id.toString();
                                })),
                            e.group &&
                                (e.detail = e.group.selling_plans.find(function (t) {
                                    return t.id.toString() === i.toString();
                                })),
                            e && e.allocation && e.detail && e.allocation ? e : null
                        );
                    }
                    properties() {
                        return this._serializeInputValues(this.propertyInputs, function (t) {
                            return (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t;
                        });
                    }
                    quantity() {
                        return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
                    }
                    getFormState() {
                        const t = this.variant();
                        return { options: this.options(), variant: t, properties: this.properties(), quantity: this.quantity(), plan: this.plan(t) };
                    }
                    _setIdInputValue(t) {
                        t && t.id ? (this.variantElement.value = t.id.toString()) : (this.variantElement.value = ""), this.variantElement.dispatchEvent(new Event("change"));
                    }
                    _onSubmit(t, e) {
                        (e.dataset = this.getFormState()), t.onFormSubmit && t.onFormSubmit(e);
                    }
                    _onOptionChange(t) {
                        this._setIdInputValue(t.dataset.variant);
                    }
                    _onFormEvent(t) {
                        return void 0 === t
                            ? Function.prototype
                            : function (e) {
                                  (e.dataset = this.getFormState()), this._setIdInputValue(e.dataset.variant), t(e);
                              }.bind(this);
                    }
                    _initInputs(t, e) {
                        return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
                            function (t) {
                                return this._listeners.add(t, "change", this._onFormEvent(e)), t;
                            }.bind(this)
                        );
                    }
                    _serializeInputValues(t, e) {
                        return t.reduce(function (t, i) {
                            return (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) && t.push(e({ name: i.name, value: i.value })), t;
                        }, []);
                    }
                    _validateProductObject(t) {
                        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
                        if (void 0 === t.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                        return t;
                    }
                    constructor(t, e, i, s) {
                        (this.element = t),
                            (this.form = "FORM" == e.tagName ? e : e.querySelector("form")),
                            (this.product = this._validateProductObject(i)),
                            (this.variantElement = this.form.querySelector(wt)),
                            (s = s || {}),
                            (this.clickedElement = null),
                            (this._listeners = new yt()),
                            this._listeners.add(this.element, "submit", this._onSubmit.bind(this, s)),
                            (this.optionInputs = this._initInputs(bt, s.onOptionChange)),
                            (this.planInputs = this._initInputs(vt, s.onPlanChange)),
                            (this.quantityInputs = this._initInputs(St, s.onQuantityChange)),
                            (this.propertyInputs = this._initInputs(Et, s.onPropertyChange));
                    }
                })(this.outerWrapper, this.productFormElement, this.productJSON, { onOptionChange: this.onOptionChange.bind(this), onPlanChange: this.onPlanChange.bind(this), onQuantityChange: this.onQuantityChange.bind(this) })),
                    this.pushState(this.productForm.getFormState(), !0),
                    this.subsToggleListeners();
            }
            onOptionChange(t) {
                this.pushState(t.dataset);
            }
            onPlanChange(t) {
                this.subPrices && this.pushState(t.dataset);
            }
            onQuantityChange(t) {
                const e = t.dataset;
                (this.productState = this.setProductState(e)), this.updateButtonPrices(e);
            }
            pushState(t, e = !1) {
                (this.productState = this.setProductState(t)),
                    this.updateProductImage(t),
                    this.updateAddToCartState(t),
                    this.updateProductPrices(t),
                    this.updateSaleText(t),
                    this.updateSubscriptionText(t),
                    this.updateLegend(t),
                    this.updateRemaining(t),
                    this.fireHookEvent(t),
                    this.sellout && this.sellout.update(t),
                    this.enableHistoryState && !e && this.updateHistoryState(t);
            }
            updateAddToCartState(t) {
                const e = t.variant;
                let i = theme.strings.addToCart;
                const s = this.outerWrapper.querySelectorAll(Oc),
                    o = this.outerWrapper.querySelector(Wc),
                    r = o.querySelectorAll(_c),
                    n = o.querySelectorAll(Ic);
                if (
                    (this.isPreOrder && (i = theme.strings.preOrder),
                    s.length &&
                        e &&
                        s.forEach((t) => {
                            t.classList.remove(ch);
                        }),
                    r.length &&
                        r.forEach((t) => {
                            e && e.available ? (t.disabled = !1) : (t.disabled = !0);
                        }),
                    n.length &&
                        n.forEach((t) => {
                            e ? (e.available ? (t.innerHTML = i) : (t.innerHTML = theme.strings.soldOut)) : (t.innerHTML = theme.strings.unavailable);
                        }),
                    o)
                )
                    if (e) {
                        e.available ? o.classList.remove(hh, dh) : (o.classList.add(hh), o.classList.remove(dh));
                        const t = o.querySelector(Fc);
                        t && (t.value = e.id);
                    } else o.classList.add(dh), o.classList.remove(hh);
            }
            updateLegend(t) {
                const e = t.variant;
                if (e) {
                    this.container.parentNode.querySelectorAll(Yc).forEach((t) => {
                        const i = t.closest(`[${Kc}]`);
                        if (i) {
                            const s = i.getAttribute(Kc),
                                o = parseInt(s, 10) - 1;
                            (this.newValue = e.options[o]), (t.innerHTML = this.newValue);
                        }
                    });
                }
            }
            updateHistoryState(t) {
                const e = t.variant,
                    i = t.plan,
                    s = window.location.href;
                if (e && s.includes("/product")) {
                    const t = new window.URL(s),
                        o = t.searchParams;
                    o.set("variant", e.id), i && i.detail && i.detail.id && this.productState.hasPlan ? o.set("selling_plan", i.detail.id) : o.delete("selling_plan"), (t.search = o.toString());
                    const r = t.toString();
                    window.history.replaceState({ path: r }, "", r);
                }
            }
            updateRemaining(t) {
                const e = t.variant;
                if (e && this.remainingWrapper && this.remainingJSON && this.remainingCount) {
                    const t = this.remainingJSON[e.id];
                    t && t <= this.remainingMaxInt && t > 0
                        ? (this.remainingWrapper.classList.remove(mh, yh, gh), this.remainingWrapper.classList.add(ph), (this.remainingCount.innerHTML = t))
                        : this.productState.soldOut
                        ? (this.remainingWrapper.classList.remove(ph, mh, gh), this.remainingWrapper.classList.add(yh))
                        : this.productState.available && (this.remainingWrapper.classList.remove(ph, yh, gh), this.remainingWrapper.classList.add(mh));
                } else this.remainingWrapper && (this.remainingWrapper.classList.remove(mh, yh, ph), this.remainingWrapper.classList.add(gh));
            }
            getBaseUnit(t) {
                return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit;
            }
            subsToggleListeners() {
                this.outerWrapper.querySelectorAll(eh).forEach((t) => {
                    t.addEventListener(
                        "change",
                        function (t) {
                            const e = t.target.value.toString(),
                                i = this.outerWrapper.querySelector(`[${ih}="${e}"]`),
                                s = this.outerWrapper.querySelectorAll(`[${ih}]`);
                            if (i) {
                                i.classList.remove(ch);
                                const t = i.querySelector('[name="selling_plan"]');
                                (t.checked = !0), t.dispatchEvent(new Event("change"));
                            }
                            s.forEach((t) => {
                                if (t !== i) {
                                    t.classList.add(ch);
                                    t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                                        (t.checked = !1), t.dispatchEvent(new Event("change"));
                                    });
                                }
                            });
                        }.bind(this)
                    );
                });
            }
            updateSaleText(t) {
                this.productState.planSale ? this.updateSaleTextSubscription(t) : this.productState.onSale ? this.updateSaleTextStandard(t) : this.priceOffWrap && this.priceOffWrap.classList.add(ch);
            }
            updateSaleTextStandard(t) {
                if (!this.priceOffType) return;
                this.priceOffType.innerHTML = window.theme.strings.sale || "sale";
                const e = t.variant;
                if (window.theme.settings.badge_sale_type && "percentage" === window.theme.settings.badge_sale_type) {
                    const t = (e.compare_at_price - e.price) / e.compare_at_price,
                        i = Math.floor(100 * t);
                    this.priceOffAmount.innerHTML = `${i}%`;
                } else {
                    const t = e.compare_at_price - e.price;
                    this.priceOffAmount.innerHTML = this.formattingMoney(t);
                }
                this.priceOffWrap.classList.remove(ch);
            }
            updateSaleTextSubscription(t) {
                this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton";
                const e = t.variant,
                    i = t.plan.detail.price_adjustments[0],
                    s = i.value;
                i && "percentage" === i.value_type
                    ? (this.priceOffAmount.innerHTML = `${s}%`)
                    : i && "price" === i.value_type
                    ? (this.priceOffAmount.innerHTML = this.formattingMoney(e.price - i.value))
                    : (this.priceOffAmount.innerHTML = this.formattingMoney(s)),
                    this.priceOffWrap.classList.remove(ch);
            }
            updateSubscriptionText(t) {
                t.plan && this.planDecription && null !== t.plan.detail.description
                    ? ((this.planDecription.innerHTML = t.plan.detail.description), this.planDecription.classList.remove(ch))
                    : this.planDecription && this.planDecription.classList.add(ch);
            }
            getPrices(t) {
                const e = t.variant,
                    i = t.plan;
                let s = "",
                    o = "";
                return (
                    this.productState.available && ((s = e.compare_at_price), (o = e.price)),
                    this.productState.hasPlan && (o = i.allocation.price),
                    this.productState.planSale && ((s = i.allocation.compare_at_price), (o = i.allocation.price)),
                    { price: o, comparePrice: s }
                );
            }
            updateButtonPrices(t) {
                const e = this.outerWrapper.querySelectorAll(Nc),
                    { price: i } = this.getPrices(t);
                e.length &&
                    e.forEach((e) => {
                        const s = t.quantity * i;
                        e.innerHTML = this.formattingMoney(s);
                    });
            }
            updateProductPrices(t) {
                const e = t.variant,
                    i = this.outerWrapper.querySelectorAll(Oc),
                    s = this.outerWrapper.querySelectorAll(Nc),
                    { price: o, comparePrice: r } = this.getPrices(t);
                i.forEach((t) => {
                    const i = t.querySelector(Dc),
                        s = t.querySelector(Rc),
                        n = t.querySelector(Bc);
                    i &&
                        (this.productState.onSale || this.productState.planSale ? (i.classList.remove(ch), n.classList.remove(ch), s.classList.add(uh)) : (i.classList.add(ch), n.classList.add(ch), s.classList.remove(uh)),
                        (i.innerHTML = this.formattingMoney(r))),
                        s && (s.innerHTML = e ? this.formattingMoney(o) : "&nbsp;");
                }),
                    s.length &&
                        s.forEach((e) => {
                            const i = t.quantity * o;
                            e.innerHTML = this.formattingMoney(i);
                        }),
                    this.hasUnitPricing && this.updateProductUnits(t);
            }
            updateProductUnits(t) {
                const e = t.variant,
                    i = t.plan;
                let s = null;
                if ((e && e.unit_price && (s = e.unit_price), i && i.allocation && i.allocation.unit_price && (s = i.allocation.unit_price), s)) {
                    const t = this.getBaseUnit(e);
                    (this.outerWrapper.querySelector(Vc).innerHTML = this.formattingMoney(s)), (this.outerWrapper.querySelector(jc).innerHTML = t), F(this.outerWrapper.querySelector(Uc));
                } else Lc(this.outerWrapper.querySelector(Uc));
            }
            fireHookEvent(t) {
                const e = t.variant;
                this.container.dispatchEvent(new CustomEvent("theme:variant:change", { detail: { variant: e }, bubbles: !0 }));
            }
            setProductState(t) {
                const e = t.variant,
                    i = t.plan,
                    s = { available: !0, soldOut: !1, onSale: !1, showUnitPrice: !1, requiresPlan: !1, hasPlan: !1, planPerDelivery: !1, planSale: !1 };
                return (
                    !e || (e.requires_selling_plan && !i)
                        ? (s.available = !1)
                        : (e.available || (s.soldOut = !0),
                          e.compare_at_price > e.price && (s.onSale = !0),
                          e.unit_price && (s.showUnitPrice = !0),
                          this.productJSON && this.productJSON.requires_selling_plan && (s.requiresPlan = !0),
                          i && this.subPrices && ((s.hasPlan = !0), i.allocation.per_delivery_price !== i.allocation.price && (s.planPerDelivery = !0), e.price > i.allocation.price && (s.planSale = !0))),
                    s
                );
            }
            updateProductImage(t) {
                const e = t.variant;
                e && this.slideshow && e.featured_media && e.featured_media.id && this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", { detail: { id: e.featured_media.id } }));
            }
            formattingMoney(t) {
                return theme.settings.currency_code_enable ? l.formatMoney(t, theme.moneyFormat) + ` ${theme.currencyCode}` : l.formatMoney(t, theme.moneyFormat);
            }
            constructor() {
                super(), (this.container = this);
            }
        },
        wh = class extends HTMLElement {
            connectedCallback() {
                fetch(this.dataset.url)
                    .then((t) => t.text())
                    .then((t) => {
                        const e = document.createElement("div");
                        e.innerHTML = t;
                        const i = e.querySelector("[data-api-content]");
                        i && (this.innerHTML = i.innerHTML);
                        const s = this.closest("[data-product-complimentary-loaded]");
                        s && "" !== i.innerHTML.trim() && s.classList.remove("js-unloaded");
                    })
                    .catch((t) => {
                        console.error(t);
                    });
            }
            constructor() {
                super();
            }
        };
    const vh = "[data-product-slideshow]",
        bh = "[data-product-image]",
        Sh = "[data-zoom-button]",
        Eh = "[data-zoom-wrapper]",
        Lh = "data-media-id";
    const kh = "body",
        Th = "[data-related-section]",
        Ah = "[data-tabs-holder]",
        qh = "data-tab",
        Ch = "data-tab-index",
        xh = "data-block-id",
        Ph = ".tabs > button",
        $h = ".tab-link",
        Mh = ".tab-link__recent",
        Hh = ".tab-content",
        _h = "[data-scrollbar]",
        Ih = "a:first-child, input:first-child",
        Dh = "current",
        Bh = "hide",
        Wh = "alt",
        Fh = "is-focused",
        Oh = {};
    const Nh = {
            onLoad() {
                Oh[this.id] = [];
                this.container.querySelectorAll(Ah).forEach((t) => {
                    Oh[this.id].push(
                        new (class {
                            init() {
                                const t = this.container,
                                    e = t.querySelectorAll(Ph),
                                    i = t.querySelector(`${$h}-0`),
                                    s = t.querySelector(`${Hh}-0`);
                                s && s.classList.add(Dh),
                                    i && i.classList.add(Dh),
                                    this.checkVisibleTabLinks(),
                                    this.container.addEventListener("theme:tabs:check", () => this.checkRecentTab()),
                                    this.container.addEventListener("theme:tabs:hide", () => this.hideRelatedTab()),
                                    e.length &&
                                        e.forEach((e) => {
                                            const i = parseInt(e.getAttribute(qh)),
                                                s = t.querySelector(`${Hh}-${i}`);
                                            e.addEventListener("click", () => {
                                                this.tabChange(e, s);
                                            }),
                                                e.addEventListener("keyup", (t) => {
                                                    (t.which !== window.theme.keyboardKeys.SPACE && t.which !== window.theme.keyboardKeys.ENTER) ||
                                                        !this.body.classList.contains(Fh) ||
                                                        (this.tabChange(e, s), s.querySelector("a, input") && ((this.accessibility.lastFocused = e), this.accessibility.a11y.trapFocus(s, { elementToFocus: s.querySelector(Ih) })));
                                                });
                                        });
                            }
                            tabChange(t, e) {
                                this.container.querySelector(`${Ph}.${Dh}`).classList.remove(Dh),
                                    this.container.querySelector(`${Hh}.${Dh}`).classList.remove(Dh),
                                    t.classList.add(Dh),
                                    e.classList.add(Dh),
                                    t.classList.contains(Bh) && e.classList.add(Bh),
                                    this.checkVisibleTabLinks(),
                                    this.container.dispatchEvent(new CustomEvent("theme:tab:change"));
                            }
                            initNativeScrollbar() {
                                this.scrollbarHolder.length &&
                                    this.scrollbarHolder.forEach((t) => {
                                        new U(t);
                                    });
                            }
                            checkVisibleTabLinks() {
                                const t = this.container.querySelectorAll(Ph),
                                    e = this.container.querySelectorAll(`${$h}.${Bh}`);
                                t.length - e.length < 2 ? this.container.classList.add(Wh) : this.container.classList.remove(Wh);
                            }
                            checkRecentTab() {
                                const t = this.container.querySelector(Mh);
                                if (t) {
                                    t.classList.remove(Bh);
                                    const e = parseInt(t.getAttribute(qh)),
                                        i = this.container.querySelector(`${Hh}[${Ch}="${e}"]`);
                                    i && i.classList.remove(Bh), this.checkVisibleTabLinks(), this.initNativeScrollbar();
                                }
                            }
                            hideRelatedTab() {
                                const t = this.container.querySelector(Th);
                                if (!t) return;
                                const e = t.closest(`${Hh}.${Dh}`);
                                if (!e) return;
                                const i = parseInt(e.getAttribute(Ch)),
                                    s = this.container.querySelectorAll(Ph);
                                if (s.length > i) {
                                    const t = s[i].nextSibling;
                                    t && (s[i].classList.add(Bh), t.dispatchEvent(new Event("click")), this.initNativeScrollbar());
                                }
                            }
                            onBlockSelect(t) {
                                const e = this.container.querySelector(`${$h}[${xh}="${t.detail.blockId}"]`);
                                e && (e.dispatchEvent(new Event("click")), e.parentNode.scrollTo({ top: 0, left: e.offsetLeft - e.clientWidth, behavior: "smooth" }));
                            }
                            constructor(t) {
                                (this.container = t),
                                    (this.body = document.querySelector(kh)),
                                    (this.accessibility = window.accessibility),
                                    this.container && ((this.scrollbarHolder = this.container.querySelectorAll(_h)), this.init(), this.initNativeScrollbar());
                            }
                        })(t)
                    );
                });
            },
            onBlockSelect(t) {
                Oh[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
        },
        zh = "[data-share-url]",
        Rh = "data-section-type",
        Vh = "[data-share-details]",
        jh = "[data-share-summary]",
        Uh = "[data-share-copy]",
        Jh = "[data-share-button]",
        Kh = "[data-close-button]",
        Yh = "[data-success-message]",
        Qh = "[data-share-holder]",
        Gh = "is-hidden";
    let Xh = class extends HTMLElement {
        init() {
            navigator.share
                ? (this.mainDetailsToggle.classList.add(Gh),
                  this.shareButton.classList.remove(Gh),
                  this.shareButton.addEventListener("click", () => {
                      navigator.share({ url: this.urlToShare, title: document.title });
                  }))
                : (this.mainDetailsToggle.addEventListener("toggle", this.toggleDetails.bind(this)),
                  this.mainDetailsToggle.addEventListener("focusout", () => {
                      setTimeout(() => {
                          this.contains(document.activeElement) || this.close();
                      });
                  }),
                  this.shareCopy.addEventListener("click", this.copyToClipboard.bind(this)),
                  this.closeButton.addEventListener("click", this.close.bind(this)),
                  this.container.addEventListener("keyup", this.keyboardEvents.bind(this)));
        }
        updateShareLink() {
            "product" == this.container.getAttribute(Rh) &&
                this.container.addEventListener("theme:variant:change", (t) => {
                    t.detail.variant && ((this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${t.detail.variant.id}`), this.urlInput && (this.urlInput.value = `${this.urlToShare.split("?")[0]}?variant=${t.detail.variant.id}`));
                });
        }
        toggleDetails() {
            this.mainDetailsToggle.open || (this.successMessage.classList.add(Gh), (this.successMessage.textContent = ""), this.closeButton.classList.add(Gh), this.shareCopy.focus());
        }
        copyToClipboard() {
            navigator.clipboard.writeText(this.urlInput.value).then(() => {
                this.successMessage.classList.remove(Gh), (this.successMessage.textContent = theme.strings.successMessage), this.closeButton.classList.remove(Gh), this.closeButton.focus();
            });
        }
        close() {
            this.mainDetailsToggle.removeAttribute("open"), this.shareSummary.setAttribute("aria-expanded", !1);
        }
        keyboardEvents(t) {
            t.which === window.theme.keyboardKeys.ESCAPE && (this.mainDetailsToggle.focus(), this.close());
        }
        constructor() {
            super(),
                (this.container = this.closest(`[${Rh}]`)),
                (this.mainDetailsToggle = this.querySelector(Vh)),
                (this.shareButton = this.querySelector(Jh)),
                (this.shareCopy = this.querySelector(Uh)),
                (this.shareSummary = this.querySelector(jh)),
                (this.closeButton = this.querySelector(Kh)),
                (this.successMessage = this.querySelector(Yh)),
                (this.shareHolder = this.querySelector(Qh)),
                (this.urlInput = this.querySelector(zh)),
                (this.urlToShare = this.urlInput ? this.urlInput.value : document.location.href),
                this.init(),
                this.updateShareLink();
        }
    };
    const Zh = "data-image-filter",
        td = "[data-product-slideshow]",
        ed = "[data-product-thumbs]",
        id = "[data-slideshow-thumbnail]",
        sd = "[data-media-slide]",
        od = "hide",
        rd = "flickity-enabled";
    const nd = "[data-product-json]",
        ad = "[data-zoom-button]",
        ld = "[data-truncated-holder]",
        cd = "[data-truncated-button]",
        hd = "data-truncated-content",
        dd = "is-expanded",
        ud = "is-visible",
        pd = [];
    const md = {
        onLoad() {
            pd[this.id] = new (class {
                init() {
                    var t, e;
                    (this.zoomEnabled = null !== this.container.querySelector(ad)),
                        this.zoomEnabled &&
                            ((t = this.container),
                            (e = this.product),
                            kt({ url: window.theme.assets.photoswipe })
                                .then(() => {
                                    const i = window.themePhotoswipe.PhotoSwipe.default,
                                        s = window.themePhotoswipe.PhotoSwipeUI.default;
                                    t.querySelectorAll(Sh).forEach((o) => {
                                        o.addEventListener("click", (o) => {
                                            const r = t.querySelector(Eh),
                                                n = o.target.closest(`[${Lh}]`).getAttribute(Lh).toString(),
                                                a = [];
                                            for (let t = 0; t < e.media.length; t++) "image" === e.media[t].media_type && (a[a.length] = { src: e.media[t].src, w: e.media[t].width, h: e.media[t].height, id: e.media[t].id });
                                            const l = {
                                                index: a.findIndex((t) => t.id.toString() === n),
                                                showHideOpacity: !0,
                                                showAnimationDuration: 150,
                                                hideAnimationDuration: 250,
                                                bgOpacity: 1,
                                                spacing: 0,
                                                allowPanToNext: !1,
                                                maxSpreadZoom: 3,
                                                history: !1,
                                                loop: !0,
                                                pinchToClose: !1,
                                                modal: !1,
                                                closeOnScroll: !1,
                                                closeOnVerticalDrag: !0,
                                                getDoubleTapZoom: function (t, e) {
                                                    return t ? 1.67 : e.initialZoomLevel < 0.7 ? 1 : 1.3;
                                                },
                                                getThumbBoundsFn: function () {
                                                    let e = t.querySelector(vh);
                                                    e || (e = t.querySelector(bh));
                                                    const i = window.pageYOffset || document.documentElement.scrollTop,
                                                        s = e.getBoundingClientRect();
                                                    return { x: s.left, y: s.top + i, w: s.width };
                                                },
                                            };
                                            r.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                                            const c = new i(r, s, a, l);
                                            c.init(),
                                                c.listen("close", function () {
                                                    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                                                });
                                        });
                                    });
                                })
                                .catch((t) => console.error(t))),
                        this.truncateElementHolder && this.truncateElement && (setTimeout(this.resizeEventTruncate, 50), document.addEventListener("theme:resize", this.resizeEventTruncate)),
                        new Pe(this.container);
                }
                truncateText() {
                    if (this.truncateElementHolder.classList.contains(ud)) return;
                    const t = this.truncateElement.querySelectorAll("style");
                    t.length &&
                        t.forEach((t) => {
                            this.truncateElementHolder.prepend(t);
                        });
                    const e = this.truncateElement.cloneNode(!0),
                        i = this.truncateElement.getAttribute(hd),
                        s = this.truncateElement.nextElementSibling;
                    s && s.remove(), this.truncateElement.parentElement.append(e);
                    const o = this.truncateElement.nextElementSibling;
                    o.classList.add(i),
                        o.removeAttribute(hd),
                        F(o),
                        ((t = "", e = 1, i = {}) => {
                            const s = { replaceStr: "...", debounceDelay: 250, delimiter: " ", ...i },
                                o = t && (t instanceof NodeList ? t : 1 === t.nodeType ? [t] : document.querySelectorAll(t));
                            for (let t = 0; t < o.length; t++) {
                                const i = o[t],
                                    r = /<!--[\s\S]*?-->/g,
                                    n = i.innerHTML.replace(r, "").split(s.delimiter);
                                i.innerHTML = "";
                                const a = window.getComputedStyle(i);
                                n.reduce(Jl, { el: i, buffer: i.innerHTML, elStyle: a, elHeight: 0, rowsLimit: e, rowsWrapped: 0, options: s });
                            }
                        })(o, 5, { replaceStr: "", delimiter: " " }),
                        Lc(o),
                        this.truncateElement.innerHTML !== o.innerHTML ? this.truncateElementHolder.classList.add(dd) : (o.remove(), this.truncateElementHolder.classList.remove(dd)),
                        this.toggleTruncatedContent(this.truncateElementHolder);
                }
                toggleTruncatedContent(t) {
                    const e = t.querySelector(cd);
                    e &&
                        e.addEventListener("click", (e) => {
                            e.preventDefault(), t.classList.remove(dd), t.classList.add(ud);
                        });
                }
                onBlockSelect(t) {
                    const e = this.container.querySelector(`[data-block-id="${t.detail.blockId}"]`);
                    e && e.dispatchEvent(new Event("click"));
                }
                onBlockDeselect(t) {
                    const e = this.container.querySelector(`[data-block-id="${t.detail.blockId}"]`);
                    e && e.dispatchEvent(new Event("click"));
                }
                onUnload() {
                    this.media.destroy(), this.truncateElementHolder && this.truncateElement && document.removeEventListener("theme:resize", this.resizeEventTruncate);
                }
                constructor(t) {
                    (this.section = t),
                        (this.id = t.id),
                        (this.container = t.container),
                        (this.settings = t.settings),
                        Bi(this.id),
                        (this.media = new (class {
                            init() {
                                this.storeEvents(),
                                    this.connectSliderMediaEvents(),
                                    this.detectVideo(),
                                    this.detectYouTube(),
                                    this.detect3d(),
                                    this.scrollThumbs(),
                                    document.addEventListener("theme:resize:width", () => {
                                        this.scrollThumbs();
                                    });
                            }
                            connectSliderMediaEvents() {
                                const t = `(max-width: ${window.theme.sizes.medium}px)`,
                                    e = window.matchMedia(t);
                                e.addEventListener("change", (t) => {
                                    t.matches ? this.createMobileSlider() : this.createDesktopSlider();
                                }),
                                    e.matches ? this.createMobileSlider() : this.createDesktopSlider();
                            }
                            createMobileSlider() {
                                this.flkty && this.destroySlider();
                                const t = { autoPlay: !1, prevNextButtons: !1, pageDots: !1, adaptiveHeight: !0, accessibility: !0, watchCSS: !1, wrapAround: !0, rightToLeft: window.isRTL, dragThreshold: 80, contain: !0, fade: !0 };
                                "carousel" == this.mobileStyle && ((t.contain = !1), (t.dragThreshold = 10), (t.fade = !1)),
                                    "slideshow" == this.mobileStyle && ((t.pageDots = !0), (t.fade = !1), (t.dragThreshold = 10)),
                                    this.createSlider(t);
                            }
                            createDesktopSlider() {
                                if ((this.flkty && this.destroySlider(), "none" == this.desktopStyle)) return;
                                const t = { autoPlay: !1, prevNextButtons: !1, pageDots: !1, adaptiveHeight: !0, accessibility: !0, watchCSS: !1, wrapAround: !0, rightToLeft: window.isRTL, dragThreshold: 80, contain: !0, fade: !0 };
                                this.createSlider(t);
                            }
                            createSlider(t) {
                                (this.flkty = new s(this.slideshow, t)), this.flkty.resize(), (this.currentSlide = this.slideshow.querySelectorAll(lc.mediaSlide)[0]), this.setDraggable(), this.addEventListeners();
                            }
                            destroySlider() {
                                this.removeEventListeners(), this.flkty.destroy();
                            }
                            storeEvents() {
                                (this.storeFlktyChange = (t) => this.doFlktyChange(t)),
                                    (this.storeFlktySettle = (t) => this.doFlktySettle(t)),
                                    (this.storeImageChange = (t) => this.doImageChange(t)),
                                    (this.storeArrowPrevClick = (t) => this.doArrowPrevClick(t)),
                                    (this.storeArrowNextClick = (t) => this.doArrowNextClick(t)),
                                    (this.storeThumbClick = (t) => this.doThumbClick(t)),
                                    (this.storeThumbContainerScroll = (t) => this.doThumbContainerScroll(t));
                            }
                            addEventListeners() {
                                var t, e, i;
                                this.flkty.on("change", this.storeFlktyChange),
                                    this.flkty.on("settle", this.storeFlktySettle),
                                    this.slideshow.addEventListener("theme:image:change", this.storeImageChange),
                                    null === (t = this.arrowPrev) || void 0 === t || t.addEventListener("click", this.storeArrowPrevClick),
                                    null === (e = this.arrowNext) || void 0 === e || e.addEventListener("click", this.storeArrowNextClick),
                                    null === (i = this.thumbs) || void 0 === i || i.addEventListener("scroll", this.storeThumbContainerScroll),
                                    this.thumbImages.forEach((t) => {
                                        t.addEventListener("click", this.storeThumbClick);
                                    });
                            }
                            removeEventListeners() {
                                var t, e, i;
                                this.flkty.on("change", this.storeFlktyChange),
                                    this.flkty.on("settle", this.storeFlktySettle),
                                    this.slideshow.removeEventListener("theme:image:change", this.storeImageChange),
                                    null === (t = this.arrowPrev) || void 0 === t || t.removeEventListener("click", this.storeArrowPrevClick),
                                    null === (e = this.arrowNext) || void 0 === e || e.removeEventListener("click", this.storeArrowNextClick),
                                    null === (i = this.thumbs) || void 0 === i || i.removeEventListener("scroll", this.storeThumbContainerScroll),
                                    this.thumbImages.forEach((t) => {
                                        t.removeEventListener("click", this.storeThumbClick);
                                    });
                            }
                            doFlktyChange(t) {
                                var e, i;
                                this.currentSlide.dispatchEvent(new CustomEvent("pause")), (this.currentSlide = this.flkty.cells[t].element), this.slideshow.classList.remove(lc.flickitylockHeight);
                                const s = this.currentSlide.getAttribute(lc.dataMediaId),
                                    o = null === (e = this.thumbWrapper) || void 0 === e ? void 0 : e.querySelector(`[${lc.dataMediaSelect}="${s}"]`);
                                null === (i = this.thumbWrapper) || void 0 === i || i.querySelector(`.${cc}`).classList.remove(cc), null == o || o.classList.add(cc), this.scrollThumbs();
                            }
                            doFlktySettle(t) {
                                (this.allSlides = this.flkty.cells),
                                    (this.currentSlide = this.flkty.cells[t].element),
                                    this.setDraggable(),
                                    this.currentSlide.dispatchEvent(new CustomEvent("theme:media:play-desktop")),
                                    document.body.classList.contains(lc.focusEnabled) && this.currentSlide.dispatchEvent(new Event("focus")),
                                    this.scrollThumbs();
                            }
                            doImageChange(t) {
                                var e = t.detail.id;
                                const i = `[${lc.dataMediaId}="${e}"]`,
                                    s = this.flkty.cells.findIndex((t) => t.element.matches(i));
                                this.flkty.select(s), this.scrollThumbs();
                            }
                            doThumbContainerScroll() {
                                this.scrollThumbs("scroll");
                            }
                            doArrowPrevClick() {
                                this.scrollThumbs("clickPrev");
                            }
                            doArrowNextClick() {
                                this.scrollThumbs("clickNext");
                            }
                            doThumbClick(t) {
                                const e = t.currentTarget.getAttribute(lc.dataMediaSelect);
                                this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", { detail: { id: e } }));
                            }
                            setDraggable() {
                                if (this.currentSlide) {
                                    const t = this.currentSlide.getAttribute(lc.mediaType);
                                    "model" === t || "video" === t || "external_video" === t ? ((this.flkty.options.draggable = !1), this.flkty.updateDraggable()) : ((this.flkty.options.draggable = !0), this.flkty.updateDraggable());
                                }
                            }
                            detect3d() {
                                const t = this.container.querySelectorAll(lc.modelViewer);
                                t &&
                                    (t.forEach((t) => {
                                        !(function (t, e) {
                                            Kl[e] = { loaded: !1 };
                                            const i = t.getAttribute(Zl),
                                                s = t.querySelector(ec),
                                                o = s.getAttribute(tc);
                                            if (null !== t.closest(Gl)) {
                                                const i = t.closest(Gl).parentElement.querySelector(Xl);
                                                Ql[e] = { $element: i, defaultId: o };
                                            }
                                            (Yl[i] = { modelId: o, mediaId: i, sectionId: e, $container: t, $element: s }),
                                                window.Shopify.loadFeatures([
                                                    { name: "shopify-xr", version: "1.0", onLoad: oc },
                                                    { name: "model-viewer-ui", version: "1.0", onLoad: rc },
                                                ]);
                                        })(t, this.section.id);
                                    }),
                                    document.addEventListener(
                                        "shopify_xr_launch",
                                        function () {
                                            this.container.querySelectorAll(lc.allPlayers).forEach((t) => {
                                                t.dispatchEvent(new CustomEvent("pause"));
                                            });
                                        }.bind(this)
                                    ));
                            }
                            detectVideo() {
                                const t = this.section.container.querySelectorAll(lc.videoPlayerNative);
                                for (var e of t) {
                                    const t = ac(e.dataset.player);
                                    !0 === this.loopVideo &&
                                        t
                                            .then((t) => ((t.loop = !0), t))
                                            .catch((t) => {
                                                console.error(t);
                                            });
                                }
                            }
                            detectYouTube() {
                                const t = this.section.container.querySelectorAll(lc.videoPlayerExternal);
                                for (var e of t) {
                                    const t = qa(e.dataset.player);
                                    !0 === this.loopVideo &&
                                        t
                                            .then((t) => dc(t))
                                            .catch((t) => {
                                                console.error(t);
                                            });
                                }
                            }
                            pauseAllMedia() {
                                this.container.querySelector(lc.mediaSlide).dispatchEvent(new CustomEvent("pause"));
                            }
                            pauseOtherMedia(t) {
                                this.container.querySelector(`${lc.mediaSlide}:not([data-player="${t}"])`).dispatchEvent(new CustomEvent("pause"));
                            }
                            destroy() {
                                this.container.querySelectorAll(lc.allPlayers).forEach((t) => {
                                    t.dispatchEvent(new CustomEvent("destroy"));
                                });
                            }
                            scrollThumbs(t) {
                                if (((this.thumbs = this.container.querySelector(lc.productThumbs)), this.thumbs)) {
                                    if (((this.thumb = this.thumbs.querySelector(`.${cc}`)), (this.thumbItems = this.container.querySelectorAll(lc.thumbImage)), (this.lastThumb = this.thumbItems[this.thumbItems.length - 1]), !this.thumb))
                                        return;
                                    (this.thumbsScrollTop = this.thumbs.scrollTop),
                                        (this.thumbsScrollLeft = this.thumbs.scrollLeft),
                                        (this.thumbsWidth = this.thumbs.offsetWidth),
                                        (this.thumbsHeight = this.slideshow.offsetWidth / this.thumb.getAttribute(lc.aspectRatio)),
                                        (this.thumbsPositionBottom = this.thumbsScrollTop + this.thumbsHeight),
                                        (this.thumbsPositionRight = this.thumbsScrollLeft + this.thumbsWidth),
                                        this.checkThumbPositions(),
                                        this.toggleToActiveThumb(t),
                                        this.toggleArrows();
                                }
                            }
                            checkThumbPositions() {
                                (this.thumbWidth = this.thumb.offsetWidth),
                                    (this.thumbHeight = this.thumb.offsetHeight),
                                    (this.thumbPosTop = this.thumb.offsetTop),
                                    (this.thumbPosLeft = this.thumb.offsetLeft),
                                    (this.lastThumbRightPos = this.lastThumb.offsetLeft + this.thumbWidth),
                                    (this.lastThumbBottomPos = this.lastThumb.offsetTop + this.thumbHeight),
                                    (this.scrollTopPosition = this.thumbPosTop + this.thumbHeight / 2 - this.thumbsHeight / 2),
                                    (this.scrollLeftPosition = this.thumbPosLeft + this.thumbWidth / 2 - this.thumbsWidth / 2),
                                    (this.topCheck = this.thumbsScrollTop > 0),
                                    (this.bottomCheck = this.thumbsPositionBottom < this.lastThumbBottomPos),
                                    (this.leftCheck = this.thumbsScrollLeft > 0),
                                    (this.rightCheck = this.thumbsPositionRight < this.lastThumbRightPos),
                                    (this.verticalCheck = this.bottomCheck || this.topCheck),
                                    (this.horizontalCheck = this.rightCheck || this.leftCheck);
                            }
                            toggleToActiveThumb(t) {
                                "scroll" !== t &&
                                    ("clickPrev" == t &&
                                        (this.verticalCheck
                                            ? ((this.scrollTopPosition = this.thumbsScrollTop - this.thumbsHeight), (this.scrollLeftPosition = 0))
                                            : ((this.scrollTopPosition = 0), (this.scrollLeftPosition = this.thumbsScrollLeft - this.thumbsWidth))),
                                    "clickNext" == t &&
                                        (this.verticalCheck
                                            ? ((this.scrollTopPosition = this.thumbsScrollTop + this.thumbsHeight), (this.scrollLeftPosition = 0))
                                            : ((this.scrollTopPosition = 0), (this.scrollLeftPosition = this.thumbsScrollLeft + this.thumbsWidth))),
                                    this.thumbs.scrollTo({ top: this.scrollTopPosition, left: this.scrollLeftPosition, behavior: "smooth" }));
                            }
                            toggleArrows() {
                                (this.verticalCheck || (this.verticalAlignment && !this.verticalCheck)) && (this.arrowPrev.classList.toggle(hc, this.topCheck), this.arrowNext.classList.toggle(hc, this.bottomCheck)),
                                    (this.horizontalCheck || (!this.verticalAlignment && !this.horizontalCheck)) && (this.arrowPrev.classList.toggle(hc, this.leftCheck), this.arrowNext.classList.toggle(hc, this.rightCheck));
                            }
                            constructor(t) {
                                (this.section = t),
                                    (this.container = t.container),
                                    (this.slideshow = this.container.querySelector(lc.productSlideshow));
                                if (!this.slideshow) return;
                                (this.mobileStyle = this.slideshow.getAttribute(lc.slideshowMobileStyle)),
                                    (this.desktopStyle = this.slideshow.getAttribute(lc.slideshowDesktopStyle)),
                                    (this.arrowPrev = this.container.querySelector(lc.arrowPrev)),
                                    (this.arrowNext = this.container.querySelector(lc.arrowNext)),
                                    (this.leftThumbsHolder = this.container.querySelector(lc.leftThumbsHolder)),
                                    (this.thumbWrapper = this.container.querySelector(lc.productThumbs)),
                                    (this.thumbImages = this.container.querySelectorAll(lc.thumbImage)),
                                    (this.loopVideo = "true" === this.container.getAttribute(lc.loopVideo)),
                                    (this.verticalAlignment = Boolean(this.container.querySelector(lc.verticalAlignment))),
                                    (this.flkty = null),
                                    (this.thumbs = this.container.querySelector(lc.productThumbs)),
                                    (this.currentSlide = null),
                                    this.init();
                            }
                        })(t)),
                        new (class {
                            listen() {
                                this.container.addEventListener("theme:variant:change", (t) => {
                                    t.detail.variant && ((this.variantImage = t.detail.variant.featured_image), this.filterImages());
                                });
                            }
                            filterImages() {
                                null !== this.variantImage && null !== this.variantImage.alt ? ((this.variantImageAlt = this.variantImage.alt.split("#")[1]), this.showImages()) : this.resetImages(), this.refreshSliders();
                            }
                            resetImages() {
                                this.thumbs.forEach((t) => t.classList.remove(od)), this.slides.forEach((t) => t.classList.remove(od));
                            }
                            showImages() {
                                this.thumbs.forEach((t) => {
                                    "" === t.getAttribute(Zh) || t.getAttribute(Zh) === this.variantImageAlt ? t.classList.remove(od) : t.classList.add(od);
                                }),
                                    this.slides.forEach((t) => {
                                        "" === t.getAttribute(Zh) || t.getAttribute(Zh) === this.variantImageAlt ? t.classList.remove(od) : t.classList.add(od);
                                    });
                            }
                            refreshSliders() {
                                if (null !== this.slider && this.slider.classList.contains(rd)) {
                                    const t = e.data(this.slider);
                                    void 0 !== t && t.reloadCells();
                                }
                                if (null !== this.thumbSlider && this.thumbSlider.classList.contains(rd)) {
                                    const t = h.data(this.thumbSlider);
                                    void 0 !== t && t.reloadCells();
                                }
                            }
                            constructor(t) {
                                (this.section = t),
                                    (this.container = t.container),
                                    (this.slider = this.container.querySelector(td)),
                                    (this.thumbSlider = this.container.querySelector(ed)),
                                    (this.thumbs = this.container.querySelectorAll(id)),
                                    (this.slides = this.container.querySelectorAll(sd)),
                                    (this.variantImage = null),
                                    this.listen();
                            }
                        })(t);
                    const i = this.container.querySelector(nd);
                    i && "" !== i.innerHTML
                        ? ((this.product = JSON.parse(i.innerHTML)),
                          (this.truncateElementHolder = this.container.querySelector(ld)),
                          (this.truncateElement = this.container.querySelector(`[${hd}]`)),
                          (this.resizeEventTruncate = () => this.truncateText()),
                          this.init())
                        : console.error("Missing product JSON");
                }
            })(this);
        },
        onUnload() {
            "function" == typeof pd[this.id].unload && pd[this.id].unload();
        },
        onBlockSelect(t) {
            "function" == typeof pd[this.id].onBlockSelect && pd[this.id].onBlockSelect(t);
        },
        onBlockDeselect(t) {
            "function" == typeof pd[this.id].onBlockDeselect && pd[this.id].onBlockDeselect(t);
        },
    };
    Pi("product", [md, Ec, fn, Nh, Pt]),
        customElements.get("product-form") || customElements.define("product-form", fh),
        customElements.get("product-complimentary") || customElements.define("product-complimentary", wh),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Vt),
        customElements.get("popout-select") || customElements.define("popout-select", pr),
        customElements.get("share-button") || customElements.define("share-button", Xh);
    const yd = "data-toggle-grid",
        gd = "data-grid-large",
        fd = "data-grid-small",
        wd = "is-active",
        vd = window.theme.sizes.small;
    var bd = {};
    const Sd = {
            onLoad() {
                bd[this.id] = [];
                this.container.querySelectorAll(`[${yd}]`).forEach((t) => {
                    bd[this.id].push(
                        new (class {
                            init() {
                                this.toggle.addEventListener("click", this.toggleFunction), document.addEventListener("theme:resize:width", this.toggleFunction), this.toggleEvent(!1);
                            }
                            unload() {
                                this.toggle.removeEventListener("click", this.toggleFunction), document.removeEventListener("theme:resize:width", this.toggleFunction);
                            }
                            toggleEvent(t = !0) {
                                const e = t && "click" === t.type,
                                    i = window.innerWidth >= vd ? gd : fd,
                                    s = this.container.querySelector(`[${i}]`),
                                    o = s.getAttribute(i),
                                    r = this.toggle.parentElement.querySelector(`[${yd}].${wd}`);
                                let n = this.toggle.parentElement.querySelector(`[${yd}="${o}"]`);
                                e && ((n = this.toggle), s.setAttribute(i, this.value), window.lazySizes && window.lazySizes.autoSizer.checkElems()), r && r.classList.remove(wd), n && n.classList.add(wd);
                            }
                            constructor(t, e) {
                                (this.container = e || document), (this.toggle = t), (this.value = this.toggle.getAttribute(yd)), (this.toggleFunction = (t) => this.toggleEvent(t)), this.init();
                            }
                        })(t, this.container)
                    );
                });
            },
            onUnload: function () {
                bd[this.id].forEach((t) => {
                    "function" == typeof t.unload && t.unload();
                });
            },
        },
        Ed = "data-sort-enabled",
        Ld = "[data-sort-link]",
        kd = "[data-sort-button-text]",
        Td = "data-value",
        Ad = "popout-list__item--current";
    var qd = "[data-tag-group]",
        Cd = ".link--add",
        xd = ".link--remove",
        Pd = "data-swatch";
    Pi("collection", [
        {
            onLoad() {
                this.collection = new (class {
                    init() {
                        new (class {
                            init() {
                                this.sortLinks.forEach((t) => {
                                    t.addEventListener("click", (t) => {
                                        t.preventDefault(), this.sortingResults(t);
                                    });
                                });
                            }
                            sortingResults(t) {
                                const e = t.currentTarget,
                                    i = e.getAttribute(Td),
                                    s = e.innerText;
                                (this.sortButtonText.innerText = s),
                                    this.sortButtonText.parentNode.dispatchEvent(new Event("click")),
                                    this.sort.querySelector(`.${Ad}`).classList.remove(Ad),
                                    e.parentNode.classList.add(Ad),
                                    this.sort.setAttribute(Ed, i),
                                    this.container.dispatchEvent(new CustomEvent("theme:form:filter", { bubbles: !0, detail: { params: i } }));
                            }
                            constructor(t) {
                                (this.container = t.container),
                                    (this.sort = this.container.querySelector(`[${Ed}]`)),
                                    (this.sortLinks = this.container.querySelectorAll(Ld)),
                                    (this.sortButtonText = this.container.querySelector(kd)),
                                    this.sort && this.init();
                            }
                        })(this.section),
                            this.removeUnusableFilters();
                    }
                    removeUnusableFilters() {
                        const t = this.container.querySelectorAll(qd);
                        t.length > 0 &&
                            t.forEach((t) => {
                                const e = t.querySelector(Cd),
                                    i = t.querySelector(xd);
                                e || i || Lc(t);
                            });
                    }
                    constructor(t) {
                        (this.section = t), (this.container = this.section.container), (this.swatches = this.container.querySelectorAll(`[${Pd}]`)), this.init();
                    }
                })(this);
            },
        },
        Il,
        Nl,
        Sd,
        Ut,
        fn,
        Y,
    ]),
        customElements.get("popout-select") || customElements.define("popout-select", pr),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Vt),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Fo),
        customElements.get("product-grid-item-content") || customElements.define("product-grid-item-content", Zo),
        Pi("collection-row", [Ut, Y, Zt]),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Vt),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Fo),
        customElements.get("product-grid-item-content") || customElements.define("product-grid-item-content", Zo),
        Pi("collection-tabs", [Nh, Qa, Ut]),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Vt),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Fo),
        customElements.get("product-grid-item-content") || customElements.define("product-grid-item-content", Zo);
    var $d = {};
    function Md(t) {
        return $d[t];
    }
    ($d.basic = []),
        ($d.light = [
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "on" }, { lightness: "64" }, { hue: "#ff0000" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
            { featureType: "administrative", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }] },
            { featureType: "landscape.natural.landcover", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "landscape.natural.terrain", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry.fill", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "labels", stylers: [{ lightness: "100" }] },
            { featureType: "poi.park", elementType: "all", stylers: [{ visibility: "on" }] },
            { featureType: "poi.park", elementType: "geometry", stylers: [{ saturation: "-41" }, { color: "#e8ede7" }] },
            { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: "-100" }] },
            { featureType: "road", elementType: "labels", stylers: [{ lightness: "25" }, { gamma: "1.06" }, { saturation: "-100" }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ gamma: "10.00" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }, { visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "simplified" }, { weight: "0.01" }, { lightness: "39" }] },
            { featureType: "road.local", elementType: "labels.text.stroke", stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#cfe5ee" }, { visibility: "on" }] },
        ]),
        ($d.light_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "off" }, { lightness: "64" }, { hue: "#ff0000" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
            { featureType: "administrative", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }] },
            { featureType: "landscape.natural.landcover", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "landscape.natural.terrain", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry.fill", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "labels", stylers: [{ lightness: "100" }] },
            { featureType: "poi.park", elementType: "all", stylers: [{ visibility: "on" }] },
            { featureType: "poi.park", elementType: "geometry", stylers: [{ saturation: "-41" }, { color: "#e8ede7" }] },
            { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: "-100" }] },
            { featureType: "road", elementType: "labels", stylers: [{ lightness: "25" }, { gamma: "1.06" }, { saturation: "-100" }, { visibility: "off" }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ gamma: "10.00" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }, { visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }, { weight: "0.01" }, { lightness: "39" }] },
            { featureType: "road.local", elementType: "labels.text.stroke", stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#cfe5ee" }, { visibility: "on" }] },
        ]),
        ($d.white_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#444444" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#e4e4e4" }, { visibility: "on" }] },
        ]),
        ($d.white_label = [
            { featureType: "all", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "simplified" }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ gamma: "3.86" }, { lightness: "100" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#cccccc" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "labels.text", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#e4e4e4" }, { visibility: "on" }] },
        ]),
        ($d.dark_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "all", elementType: "labels.text.fill", stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }] },
            { featureType: "all", elementType: "labels.text.stroke", stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }] },
            { featureType: "all", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "landscape", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 21 }] },
            { featureType: "road", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 18 }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 16 }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 19 }] },
            { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 17 }] },
        ]),
        ($d.dark_label = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "all", elementType: "labels.text.fill", stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }] },
            { featureType: "all", elementType: "labels.text.stroke", stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }] },
            { featureType: "all", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }] },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "simplified" }, { lightness: "-82" }] },
            { featureType: "administrative", elementType: "labels.text.stroke", stylers: [{ invert_lightness: !0 }, { weight: "7.15" }] },
            { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "landscape", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 21 }] },
            { featureType: "road", elementType: "labels", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 18 }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 16 }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 19 }] },
            { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 17 }] },
        ]),
        (window.theme.allMaps = window.theme.allMaps || {});
    let Hd = window.theme.allMaps;
    const _d = "[data-map-container]",
        Id = "data-style",
        Dd = "data-api-key",
        Bd = "data-zoom",
        Wd = "data-address",
        Fd = "data-latlong-correction",
        Od = "data-lat",
        Nd = "data-long";
    const zd = {
        onLoad() {
            Hd[this.id] = new (class {
                initMaps() {
                    kt({ url: `https://maps.googleapis.com/maps/api/js?key=${this.key}` })
                        .then(() => {
                            return "true" === this.enableCorrection && "" !== this.lat && "" !== this.long
                                ? new window.google.maps.LatLng(this.lat, this.long)
                                : ((t = this.address),
                                  new Promise((e, i) => {
                                      new window.google.maps.Geocoder().geocode({ address: t }, function (t, s) {
                                          if ("OK" == s) {
                                              var o = { lat: t[0].geometry.location.lat(), lng: t[0].geometry.location.lng() };
                                              e(o);
                                          } else i(s);
                                      });
                                  }));
                            var t;
                        })
                        .then((t) => {
                            var e = { zoom: parseInt(this.zoomString, 10), styles: Md(this.styleString), center: t, draggable: !0, clickableIcons: !1, scrollwheel: !1, zoomControl: !1, disableDefaultUI: !0 };
                            const i = (function (t, e) {
                                var i = new window.google.maps.Map(t, e),
                                    s = i.getCenter();
                                return (
                                    new window.google.maps.Marker({ map: i, position: s }),
                                    window.google.maps.event.addDomListener(window, "resize", function () {
                                        window.google.maps.event.trigger(i, "resize"), i.setCenter(s);
                                    }),
                                    i
                                );
                            })(this.mapWrap, e);
                            return i;
                        })
                        .then((t) => {
                            (this.map = t), (Hd[this.id] = t);
                        })
                        .catch((t) => {
                            console.log("Failed to load Google Map"), console.log(t);
                        });
                }
                onUnload() {
                    void 0 !== window.google && window.google.maps.event.clearListeners(this.map, "resize");
                }
                constructor(t) {
                    (this.container = t.container),
                        (this.mapWrap = this.container.querySelector(_d)),
                        (this.styleString = this.container.getAttribute(Id) || ""),
                        (this.key = this.container.getAttribute(Dd)),
                        (this.zoomString = this.container.getAttribute(Bd) || 14),
                        (this.address = this.container.getAttribute(Wd)),
                        (this.enableCorrection = this.container.getAttribute(Fd)),
                        (this.lat = this.container.getAttribute(Od)),
                        (this.long = this.container.getAttribute(Nd)),
                        this.key && this.initMaps();
                }
            })(this);
        },
        onUnload() {
            "function" == typeof Hd[this.id].unload && Hd[this.id].unload();
        },
    };
    Pi("section-map", zd), Pi("section-columns", [Ba, Zt]);
    const Rd = "[data-related-section]",
        Vd = "[data-grid-item]",
        jd = "[data-carousel]",
        Ud = "data-limit",
        Jd = "data-minimum",
        Kd = "data-layout-desktop",
        Yd = "data-layout-tablet",
        Qd = "data-layout-mobile",
        Gd = "[data-recent-wrapper]",
        Xd = "[data-recently-viewed-wrapper]",
        Zd = "data-product-id";
    Pi("related", [
        {
            onLoad() {
                this.section = new (class {
                    init() {
                        const t = this.container.querySelector(Rd);
                        if (!t) return;
                        const e = t.getAttribute(Zd),
                            i = t.getAttribute(Ud),
                            s = t.getAttribute(Kd),
                            o = t.getAttribute(Yd),
                            r = t.getAttribute(Qd),
                            a = `${window.theme.routes.product_recommendations_url || "/recommendations/products/"}?section_id=related&limit=${i}&product_id=${e}`;
                        n.get(a)
                            .then((e) => {
                                const i = document.createElement("div");
                                i.innerHTML = e.data;
                                const n = i.querySelector(Rd);
                                if (n.querySelector(Vd)) {
                                    const e = n.innerHTML;
                                    (t.innerHTML = e),
                                        t.querySelector(jd).style.setProperty("--grid-large-items", s),
                                        t.querySelector(jd).style.setProperty("--grid-medium-items", o),
                                        t.querySelector(jd).style.setProperty("--grid-small-items", r),
                                        t.dispatchEvent(new CustomEvent("theme:related-products:added", { bubbles: !0 }));
                                } else t.dispatchEvent(new CustomEvent("theme:tabs:hide", { bubbles: !0 }));
                            })
                            .catch(function (t) {
                                console.warn(t);
                            });
                    }
                    recent() {
                        const t = this.container.querySelector(Gd),
                            e = this.container.querySelector(Xd),
                            i = this.container.querySelectorAll(Vd),
                            s = t.hasAttribute(Jd) ? parseInt(t.getAttribute(Jd)) : 4,
                            o = !e && i.length > 0,
                            r = e && i.length >= s;
                        (o || r) && t.dispatchEvent(new CustomEvent("theme:tabs:check", { bubbles: !0 }));
                    }
                    constructor(t) {
                        (this.section = t),
                            (this.container = t.container),
                            this.init(),
                            this.container.addEventListener("theme:recent-products:added", () => {
                                this.recent();
                            });
                    }
                })(this);
            },
        },
        Nh,
        pt,
    ]),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", Vt),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", Fo),
        customElements.get("product-grid-item-content") || customElements.define("product-grid-item-content", Zo);
    const tu = { ajaxDisable: "data-ajax-disable", shipping: "[data-shipping-estimate-form]", input: "[data-update-cart]", update: "[data-update-button]", bottom: "[data-cart-bottom]", upsellWrapper: "[data-cart-page-upsell-wrapper]" },
        eu = "cart--dirty",
        iu = "heart-beat",
        su = {
            onLoad() {
                if ((this.container.querySelector(tu.shipping) && new Pr(this), (this.disabled = "true" == this.container.getAttribute(tu.ajaxDisable)), this.disabled)) return void (this.cart = new ou(this));
                this.cart = new nn(this);
                this.cart.init().then(() => {
                    this.cart.loadHTML();
                });
            },
        };
    let ou = class {
        initQuantity() {
            Ir(this.container);
        }
        moveUpsell() {
            const t = this.container.querySelector(tu.bottom);
            t.insertBefore(this.upsellWrapper, t.firstChild);
        }
        initInputs() {
            this.inputs.forEach((t) => {
                t.addEventListener(
                    "change",
                    function () {
                        this.updateBtn.classList.add(eu),
                            this.updateBtn.classList.add(iu),
                            setTimeout(
                                function () {
                                    this.updateBtn.classList.remove(iu);
                                }.bind(this),
                                1300
                            );
                    }.bind(this)
                );
            });
        }
        constructor(t) {
            (window.theme.state.cartOpen = !0),
                (this.section = t),
                (this.container = t.container),
                (this.inputs = this.container.querySelectorAll(tu.input)),
                (this.quantityWrappers = this.container.querySelectorAll(tu.qty)),
                (this.updateBtn = this.container.querySelector(tu.update)),
                (this.upsellWrapper = this.container.querySelector(tu.upsellWrapper)),
                this.initQuantity(),
                this.initInputs(),
                this.upsellWrapper && this.moveUpsell();
        }
    };
    Pi("cart", [su, fn]), Pi("accordion-single", fn);
    const ru = (t, e, i = null) => {
            (t.style.opacity = 0),
                (t.style.display = e || "block"),
                (function e() {
                    let s = parseFloat(t.style.opacity);
                    (s += 0.1) > 1 || ((t.style.opacity = s), requestAnimationFrame(e)), 1 === s && "function" == typeof i && i();
                })();
        },
        nu = (t, e = null) => {
            (t.style.opacity = 1),
                (function i() {
                    (t.style.opacity -= 0.1) < 0 ? (t.style.display = "none") : requestAnimationFrame(i), 0 === parseFloat(t.style.opacity) && "function" == typeof e && e();
                })();
        },
        au = "[data-tracking-consent]",
        lu = "[data-confirm-cookies]",
        cu = "[data-close-modal]",
        hu = "[data-popup-inner]",
        du = "[data-newsletter]",
        uu = "[data-newsletter-holder]",
        pu = "[data-newsletter-field]",
        mu = "[data-newsletter-form]",
        yu = "[data-promo-text]",
        gu = "data-popup-delay",
        fu = "data-cookie-name",
        wu = "data-target-referrer",
        vu = "has-value",
        bu = "has-success",
        Su = "desktop",
        Eu = "mobile";
    let Lu = {},
        ku = class {
            write() {
                ((-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((t) => t.startsWith(this.name))) || -1 === document.cookie.indexOf("; ")) &&
                    (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
            }
            read() {
                if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t) => t.startsWith(this.name))) {
                    return document.cookie
                        .split("; ")
                        .find((t) => t.startsWith(this.name))
                        .split("=")[1];
                }
                return !1;
            }
            destroy() {
                document.cookie.split("; ").find((t) => t.startsWith(this.name)) && (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
            }
            constructor(t, e) {
                (this.configuration = { expires: null, path: "/", domain: window.location.hostname }), (this.name = t), (this.value = e);
            }
        },
        Tu = class {
            always() {
                ru(this.element);
            }
            delayed() {
                setTimeout(() => {
                    ru(this.element);
                }, 1e4);
            }
            bottom() {
                let t;
                const e = () => {
                    t && window.cancelAnimationFrame(t),
                        (t = window.requestAnimationFrame(() => {
                            window.requestIdleCallback(
                                () => {
                                    Math.round(window.scrollY + window.innerHeight) >= Math.round(document.body.clientHeight) && (ru(this.element), window.removeEventListener("scroll", e, { passive: !0 }));
                                },
                                { timeout: 300 }
                            );
                        }));
                };
                window.addEventListener("scroll", e, { passive: !0 });
            }
            onScroll() {}
            idle() {
                let t = 0;
                const e = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    i = ["load", "resize", "scroll"],
                    s = () => {
                        (t = setTimeout(() => {
                            (t = 0), ru(this.element);
                        }, 6e4)),
                            e.forEach((t) => {
                                document.addEventListener(t, o);
                            }),
                            i.forEach((t) => {
                                window.addEventListener(t, o);
                            });
                    },
                    o = () => {
                        t && clearTimeout(t),
                            e.forEach((t) => {
                                document.removeEventListener(t, o);
                            }),
                            i.forEach((t) => {
                                window.removeEventListener(t, o);
                            }),
                            s();
                    };
                s();
            }
            constructor(t, e) {
                (this.element = e), (this.delay = t.getAttribute(gu)), "always" === this.delay && this.always(), "delayed" === this.delay && this.delayed(), "bottom" === this.delay && this.bottom(), "idle" === this.delay && this.idle();
            }
        },
        Au = class {
            init() {
                -1 !== this.locationPath.indexOf(this.el.getAttribute(wu)) || window.Shopify.designMode || this.el.parentNode.removeChild(this.el);
            }
            constructor(t) {
                (this.el = t), (this.locationPath = location.href), this.el.hasAttribute(wu) && this.init();
            }
        };
    Pi("popups", [
        Ea,
        {
            onLoad() {
                Lu[this.id] = [];
                this.container.querySelectorAll(au).forEach((t) => {
                    Lu[this.id].push(
                        new (class {
                            init() {
                                this.showPopup && ru(this.modalInner), this.clickEvents();
                            }
                            clickEvents() {
                                this.close.addEventListener("click", (t) => {
                                    t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!1, () => nu(this.modalInner));
                                }),
                                    this.acceptButton.addEventListener("click", (t) => {
                                        t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!0, () => nu(this.modalInner));
                                    }),
                                    document.addEventListener("trackingConsentAccepted", function () {
                                        console.log("trackingConsentAccepted event fired");
                                    });
                            }
                            onBlockSelect(t) {
                                this.popup.contains(t.target) && this.showPopup && ru(this.modalInner);
                            }
                            onBlockDeselect(t) {
                                this.popup.contains(t.target) && nu(this.modalInner);
                            }
                            constructor(t) {
                                (this.popup = t),
                                    (this.modal = document.querySelector(au)),
                                    (this.modalInner = this.popup.querySelector(hu)),
                                    (this.close = this.modal.querySelector(cu)),
                                    (this.acceptButton = this.modal.querySelector(lu)),
                                    (this.enable = "true" === this.modal.getAttribute("data-enable")),
                                    (this.showPopup = !1),
                                    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (t) => {
                                        if (t) throw t;
                                        const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                                            i = window.Shopify.customerPrivacy.getTrackingConsent();
                                        (this.showPopup = !e && "no_interaction" === i && this.enable), window.Shopify.designMode && (this.showPopup = !0), this.init();
                                    });
                            }
                        })(t)
                    );
                });
                this.container.querySelectorAll(du).forEach((t) => {
                    Lu[this.id].push(
                        new (class {
                            init() {
                                (!1 !== this.cookie.read() && !window.Shopify.designMode) || (this.show(), this.form.classList.contains(bu) && this.checkForSuccess());
                            }
                            show() {
                                window.Shopify.designMode ? ru(this.popupInner) : new Tu(this.popup, this.popupInner), this.inputField(), this.closePopup();
                            }
                            checkForSuccess() {
                                ru(this.popupInner), this.cookie.write();
                            }
                            closePopup() {
                                this.close.addEventListener("click", (t) => {
                                    t.preventDefault(), nu(this.popupInner), this.cookie.write();
                                });
                            }
                            inputField() {
                                this.newsletterField.addEventListener("input", () => {
                                    "" !== this.newsletterField.value && this.holder.classList.add(vu, "" !== this.newsletterField.value);
                                }),
                                    this.newsletterField.addEventListener("focus", () => {
                                        "" !== this.newsletterField.value && this.holder.classList.add(vu, "" !== this.newsletterField.value);
                                    }),
                                    this.newsletterField.addEventListener("focusout", () => {
                                        setTimeout(() => {
                                            this.holder.classList.remove(vu);
                                        }, 2e3);
                                    });
                            }
                            onBlockSelect(t) {
                                this.popup.contains(t.target) && ru(this.popupInner);
                            }
                            onBlockDeselect(t) {
                                this.popup.contains(t.target) && nu(this.popupInner);
                            }
                            constructor(t) {
                                (this.popup = t),
                                    (this.popupInner = this.popup.querySelector(hu)),
                                    (this.holder = this.popup.querySelector(uu)),
                                    (this.close = this.popup.querySelector(cu)),
                                    (this.newsletterField = this.popup.querySelector(pu)),
                                    (this.cookie = new ku(this.popup.getAttribute(fu), "newsletter_is_closed")),
                                    (this.form = this.popup.querySelector(mu)),
                                    (this.isTargeted = new Au(this.popup)),
                                    this.init();
                            }
                        })(t)
                    );
                });
                this.container.querySelectorAll(yu).forEach((t) => {
                    Lu[this.id].push(
                        new (class {
                            init() {
                                (!1 !== this.cookie.read() && !window.Shopify.designMode) || (window.Shopify.designMode ? ru(this.popupInner) : new Tu(this.popup, this.popupInner), this.clickEvents());
                            }
                            clickEvents() {
                                this.close.addEventListener("click", (t) => {
                                    t.preventDefault(), nu(this.popupInner), this.cookie.write();
                                });
                            }
                            onBlockSelect(t) {
                                this.popup.classList.contains(Eu) && (this.hasDeviceClass = Eu),
                                    this.popup.classList.contains(Su) && (this.hasDeviceClass = Su),
                                    "" !== this.hasDeviceClass && this.popup.classList.remove(this.hasDeviceClass),
                                    this.popup.contains(t.target) && ru(this.popupInner);
                            }
                            onBlockDeselect(t) {
                                this.popup.contains(t.target) && nu(this.popupInner), "" !== this.hasDeviceClass && this.popup.classList.add(this.hasDeviceClass);
                            }
                            constructor(t) {
                                (this.popup = t),
                                    (this.popupInner = this.popup.querySelector(hu)),
                                    (this.close = this.popup.querySelector(cu)),
                                    (this.cookie = new ku(this.popup.getAttribute(fu), "user_has_closed")),
                                    (this.isTargeted = new Au(this.popup)),
                                    (this.hasDeviceClass = ""),
                                    this.init();
                            }
                        })(t)
                    );
                });
            },
            onBlockSelect(t) {
                Lu[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                Lu[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
        },
    ]),
        Pi("tabs", Nh);
    const qu = "data-look-dot",
        Cu = "data-products-holder",
        xu = "[data-carousel]",
        Pu = "[data-button-close-holder]",
        $u = "data-carousel-index",
        Mu = "data-block-id",
        Hu = "button",
        _u = "is-active",
        Iu = "is-expanded",
        Du = {};
    Pi("look", [
        {
            onLoad() {
                (Du[this.id] = []),
                    Du[this.id].push(
                        new (class {
                            init() {
                                (this.keyEvents = (t) => this.keyboardEventShowProductHolder(t)),
                                    (this.keyCloseEvent = (t) => this.hideProductsHolder(t)),
                                    (this.clickEventsDot = (t) => this.clickEventShowProductsHolder(t)),
                                    (this.clickEventToClose = (t) => this.clickEventCloseProductsHolder(t)),
                                    (this.toggleOnResize = (t) => k(this.onResize(t), 200)),
                                    this.initSlider(),
                                    this.addEvents();
                            }
                            initSlider() {
                                this.slider &&
                                    ((this.carousel = s.data(this.slider)),
                                    (this.carousel.options.wrapAround = !0),
                                    (this.carousel.options.freeScroll = !1),
                                    this.carousel.resize(),
                                    this.carousel.on("change", (t) => {
                                        (this.currentDot = this.container.querySelector(`[${qu}="${t}"]`)), this.currentDot.classList.add(_u), this.removeClassOnSiblingDots();
                                    }));
                            }
                            addEvents() {
                                this.dots.forEach((t) => {
                                    t.addEventListener("click", this.clickEventsDot), t.addEventListener("keyup", this.keyEvents);
                                }),
                                    document.addEventListener("keyup", this.keyCloseEvent),
                                    document.addEventListener("theme:resize", this.toggleOnResize),
                                    this.buttonClose && this.buttonClose.addEventListener("click", this.clickEventToClose);
                            }
                            showProductsHolder() {
                                const t = !this.productsHolder.classList.contains(Iu);
                                this.currentDot.classList.toggle(_u),
                                    this.productsHolder.classList.toggle(Iu, this.currentDot.classList.contains(_u)),
                                    this.currentDot.classList.contains(_u) && ((this.hasDefaultOpen = !0), this.carousel.selectCell(Number(this.currentDot.getAttribute(qu)), !0, t)),
                                    this.removeClassOnSiblingDots();
                            }
                            hideProductsHolder(t) {
                                t.which === window.theme.keyboardKeys.ESCAPE && (this.removeClasses(), Te(), this.currentDot.focus());
                            }
                            removeClasses() {
                                this.productsHolder.classList.remove(Iu), this.currentDot.classList.remove(_u), (this.hasDefaultOpen = !1);
                            }
                            clickEventShowProductsHolder(t) {
                                (this.currentDot = t.currentTarget), this.showProductsHolder();
                            }
                            clickEventCloseProductsHolder() {
                                this.removeClasses();
                            }
                            keyboardEventShowProductHolder(t) {
                                (t.which !== window.theme.keyboardKeys.ENTER && t.which !== window.theme.keyboardKeys.SPACE) ||
                                    setTimeout(() => {
                                        const t = this.productsHolder.querySelector(Hu);
                                        ke(this.productsHolder, { elementToFocus: t });
                                    }, 400);
                            }
                            onResize() {
                                this.currentDot &&
                                    (window.innerWidth < window.theme.sizes.medium
                                        ? (this.currentDot.classList.remove(_u), this.productsHolder.classList.remove(Iu))
                                        : this.hasDefaultOpen && (this.currentDot.classList.add(_u), this.productsHolder.classList.add(Iu)));
                            }
                            removeEvents() {
                                this.dots.forEach((t) => {
                                    t.removeEventListener("click", this.clickEventsDot), t.removeEventListener("keyup", this.keyEvents);
                                }),
                                    document.removeEventListener("keyup", this.keyCloseEvent),
                                    document.removeEventListener("theme:resize", this.toggleOnResize),
                                    this.buttonClose && this.buttonClose.removeEventListener("click", this.clickEventToClose);
                            }
                            removeClassOnSiblingDots() {
                                for (let t of this.currentDot.parentNode.children) t !== this.currentDot && t.classList.remove(_u);
                            }
                            onUnload() {
                                this.slider && this.carousel && this.carousel.destroy(), this.removeEvents();
                            }
                            onBlockSelect(t) {
                                if (this.slider && this.carousel) {
                                    const e = this.container.querySelector(`[${Mu}="${t.detail.blockId}"]`);
                                    this.productsHolder.classList.add(Iu), this.carousel.selectCell(Number(e.getAttribute($u)), !0, !0);
                                }
                            }
                            onBlockDeselect() {
                                window.innerWidth < window.theme.sizes.medium && (this.productsHolder.classList.remove(Iu), this.currentDot.classList.remove(_u));
                            }
                            constructor(t) {
                                (this.section = t),
                                    (this.container = this.section.container),
                                    (this.dots = this.container.querySelectorAll(`[${qu}]`)),
                                    (this.productsHolder = this.container.querySelector(`[${Cu}]`)),
                                    (this.slider = this.container.querySelector(xu)),
                                    (this.buttonClose = this.container.querySelector(Pu)),
                                    (this.currentDot = this.container.querySelector(`[${qu}].${_u}`)),
                                    (this.hasDefaultOpen = Boolean(this.currentDot)),
                                    this.init();
                            }
                        })(this)
                    );
            },
            onUnload() {
                Du[this.id].forEach((t) => {
                    "function" == typeof t.onUnload && t.onUnload();
                });
            },
            onBlockSelect(t) {
                Du[this.id].forEach((e) => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
                });
            },
            onBlockDeselect(t) {
                Du[this.id].forEach((e) => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
                });
            },
        },
    ]);
    const Bu = (t, e = "", i) => ((i = i || document.createElement("div")).classList.add(e), t.parentNode.insertBefore(i, t), i.appendChild(t));
    window.theme.settings.animate_scroll && t.init({ once: !0 }),
        document.addEventListener("DOMContentLoaded", function () {
            const t = document.querySelector("[data-header-height]");
            if (t) {
                const e = t.clientHeight || 0;
                document.documentElement.style.setProperty("--menu-height", `${e}px`);
            }
            $i("*"),
                window.theme.settings.animate_hover && document.body.classList.add("theme-animate-hover"),
                document.addEventListener("lazyloaded", function (t) {
                    const e = t.target.parentNode;
                    e.classList.contains("lazy-image") && (e.style.backgroundImage = "none");
                });
            document.querySelectorAll(".rte table").forEach((t) => {
                Bu(t, "rte__table-wrapper");
            });
            document.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe').forEach((t) => {
                Bu(t, "rte__video-wrapper");
            }),
                document.addEventListener("mousedown", () => {
                    document.body.classList.remove("focus-enabled");
                }),
                document.addEventListener("keyup", (t) => {
                    "Tab" === t.code && document.body.classList.add("focus-enabled");
                }),
                window.navigator.cookieEnabled && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies")),
                (function (t) {
                    t = t || {};
                    var e = window.location.hash,
                        i = document.getElementById(e.slice(1));
                    if (i && t.ignore && i.matches(t.ignore)) return !1;
                    e && i && Se(i, t);
                })(),
                Ee(),
                "scrollBehavior" in document.documentElement.style || kt({ url: window.theme.assets.smoothscroll });
        });
})(
    themeVendor.AOS,
    themeVendor.FlickityFade,
    themeVendor.BodyScrollLock,
    themeVendor.Flickity,
    themeVendor.Sqrl,
    themeVendor.MicroModal,
    themeVendor.axios,
    themeVendor.Rellax,
    themeVendor.themeCurrency,
    themeVendor.themeAddresses,
    themeVendor.FlickitySync
);
